webpackJsonp([1],{

/***/ "+f0w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "01On":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "04/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__ = __webpack_require__("6zSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__ = __webpack_require__("2bj9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__ = __webpack_require__("lv5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_components_ol_Map__ = __webpack_require__("i8bC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AppHeader__ = __webpack_require__("mUig");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_AppFooter__ = __webpack_require__("ZfcG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_AppSidebar__ = __webpack_require__("ETGo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_components_AppLogo__ = __webpack_require__("qq5n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_components_bglayerswitcher_BgLayerSwitcher_vue__ = __webpack_require__("jc9b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_components_measuretool_MeasureWin__ = __webpack_require__("lgWu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_components_layerlist_LayerListWin__ = __webpack_require__("29fi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_components_helpwin_HelpWin__ = __webpack_require__("UkhJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_components_infoclick_InfoClickWin__ = __webpack_require__("qUL7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__src_components_progress_MapLoadingStatus__ = __webpack_require__("novK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__src_components_attributeTable_AttributeTableWin_vue__ = __webpack_require__("MV43");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__src_components_maprecorder_MapRecorderWin__ = __webpack_require__("ILVl");







function ownKeys(object, enumerableOnly) { var keys = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys___default()(object); if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default.a) { var symbols = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default()(object); if (enumerableOnly) symbols = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default()(symbols).call(symbols, function (sym) { return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty___default()(target, key, source[key]); }); } else if (__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default.a) { Object.defineProperties(target, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(source, key)); }); } } return target; }


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-tpl',
  components: {
    'wgu-map': __WEBPACK_IMPORTED_MODULE_9__src_components_ol_Map__["a" /* default */],
    'wgu-app-header': __WEBPACK_IMPORTED_MODULE_10__components_AppHeader__["a" /* default */],
    'wgu-app-footer': __WEBPACK_IMPORTED_MODULE_11__components_AppFooter__["a" /* default */],
    'wgu-app-sidebar': __WEBPACK_IMPORTED_MODULE_12__components_AppSidebar__["a" /* default */],
    'wgu-app-logo': __WEBPACK_IMPORTED_MODULE_13__src_components_AppLogo__["a" /* default */],
    'wgu-bglayerswitcher': __WEBPACK_IMPORTED_MODULE_14__src_components_bglayerswitcher_BgLayerSwitcher_vue__["a" /* default */],
    'wgu-measuretool-win': __WEBPACK_IMPORTED_MODULE_15__src_components_measuretool_MeasureWin__["a" /* default */],
    'wgu-layerlist-win': __WEBPACK_IMPORTED_MODULE_16__src_components_layerlist_LayerListWin__["a" /* default */],
    'wgu-helpwin-win': __WEBPACK_IMPORTED_MODULE_17__src_components_helpwin_HelpWin__["a" /* default */],
    'wgu-infoclick-win': __WEBPACK_IMPORTED_MODULE_18__src_components_infoclick_InfoClickWin__["a" /* default */],
    'wgu-maploading-status': __WEBPACK_IMPORTED_MODULE_19__src_components_progress_MapLoadingStatus__["a" /* default */],
    'wgu-attributetable-win': __WEBPACK_IMPORTED_MODULE_20__src_components_attributeTable_AttributeTableWin_vue__["a" /* default */],
    'wgu-maprecorder-win': __WEBPACK_IMPORTED_MODULE_21__src_components_maprecorder_MapRecorderWin__["a" /* default */]
  },
  data: function data() {
    return {
      isEmbedded: false,
      floatingWins: this.getModuleWinData('floating'),
      sidebarWins: this.getModuleWinData('sidebar'),
      showCopyrightYear: __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$appConfig.showCopyrightYear,
      baseColor: __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$appConfig.baseColor
    };
  },
  created: function created() {
    this.setDocumentTitle();
  },
  mounted: function mounted() {
    // apply the isEmbedded state to the member var
    this.isEmbedded = this.$isEmbedded; // make the refs (floating module window, which are not connected to their
    // related components, e.g. buttons to toggle them)

    var refs = this.$refs;
    var cmpLookup = {};

    for (var _i = 0, _Object$keys = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys___default()(refs); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      cmpLookup[key] = refs[key][0];
    }

    __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.cmpLookup = cmpLookup; // inform registered cmps that the app is mounted and the dynamic
    // components are available

    __WEBPACK_IMPORTED_MODULE_8__src_WguEventBus__["a" /* WguEventBus */].$emit('app-mounted');
  },
  methods: {
    /**
     * Determines the module window configuration objects from app-config:
     *     moduleWins: [
     *       {type: 'wgu-layerlist-win'},
     *       {type: 'wgu-measuretool-win'}
     *     ]
     * @param  {String} target Either 'floating' or 'sidebar'
     * @return {Array} module window configuration objects
     */
    getModuleWinData: function getModuleWinData(target) {
      var appConfig = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$appConfig || {};
      var modulesConfs = appConfig.modules || {};
      var moduleWins = [];

      for (var _i2 = 0, _Object$keys3 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys___default()(modulesConfs); _i2 < _Object$keys3.length; _i2++) {
        var key = _Object$keys3[_i2];
        var moduleOpts = appConfig.modules[key];

        if (moduleOpts.win === target) {
          moduleWins.push(_objectSpread({
            type: key + '-win'
          }, moduleOpts));
        }
      }

      return moduleWins;
    },

    /**
     * Sets the document title from language file.
     */
    setDocumentTitle: function setDocumentTitle() {
      document.title = this.$t('app.browserTitle') || document.title;
    }
  },
  watch: {
    /**
     * Watch for locale changes.
     */
    '$i18n.locale': function $i18nLocale() {
      this.setDocumentTitle();
    }
  }
});

/***/ }),

/***/ "0ZKt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-module-card',_vm._b({staticClass:"wgu-measurewin",attrs:{"moduleName":_vm.moduleName,"icon":_vm.icon},on:{"visibility-change":_vm.show}},'wgu-module-card',_vm.$attrs,false),[_c('v-card-title',{attrs:{"primary-title":""}},[_c('wgu-measure-type-chooser',{attrs:{"measureType":_vm.measureType},on:{"wgu-measuretype-change":_vm.applyMeasureType}})],1),_vm._v(" "),_c('v-card-actions',[_c('wgu-measure-result',{attrs:{"measureGeom":_vm.measureGeom}})],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "0dsf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('table',{staticClass:"wgu-proptable",style:(_vm.tableStyles)},[_c('thead',[_c('tr',_vm._l((_vm.properties),function(entry,key){return _c('th',{key:key})}),0)]),_vm._v(" "),_c('tbody',{staticClass:"attr-tbody"},_vm._l((_vm.properties),function(value,key){return _c('tr',{key:key},[_c('td',{staticClass:"key-td"},[_vm._v("\n        "+_vm._s(key)+"\n      ")]),_vm._v(" "),_c('td',{staticClass:"val-td"},[_vm._v("\n        "+_vm._s(value)+"\n      ")])])}),0)]):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "1iCm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_string_split_js__ = __webpack_require__("388n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_string_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_string_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_regexp_exec_js__ = __webpack_require__("XEfP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_regexp_exec_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_regexp_exec_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_string_match_js__ = __webpack_require__("LBAN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_string_match_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_string_match_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modulecore_ModuleCard__ = __webpack_require__("6OvL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_canvas_record__ = __webpack_require__("UG1j");






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-maprecorder-win',
  inheritAttrs: false,
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_Mapable__["a" /* Mapable */]],
  components: {
    'wgu-module-card': __WEBPACK_IMPORTED_MODULE_6__modulecore_ModuleCard__["a" /* default */]
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: 'mdi-video'
    }
  },
  data: function data() {
    var mimeTypes = this.getSupportedMimeTypes();
    return {
      moduleName: 'wgu-maprecorder',

      /**
       * Custom canvas element for drawing the OpenLayers map.
       */
      mapCanvas: null,

      /**
       * Context of the custom canvas element.
       */
      mapContext: null,

      /**
       * Canvas recorder.
       */
      recorder: null,

      /**
       * Recording state.
       */
      recording: false,

      /**
       * Filename of the video. Defaults to 'Recording YYYY-MM-DD'.
       */
      filename: undefined,

      /**
       * The frame rate used by the MediaRecorder.
       */
      frameRate: 25,

      /**
       * The video encoding bit rate in MBits/s.
       */
      videoMBitsPerSecond: 2.5,

      /**
       * The selected video codec.
       */
      mimeType: mimeTypes.length > 0 ? mimeTypes[0] : undefined,

      /**
       * The video codecs supported by the browser.
       */
      mimeTypes: mimeTypes,

      /**
       * Timer handle for canvas draw callbacks.
       */
      timerHandle: null,

      /**
       * An error occured on recording.
       */
      error: false
    };
  },
  methods: {
    /**
     * Starting from OpenLayers 6, layers are no longer composed to a single
     * Canvas element. The following function does custom rendering of all map
     * layers, code is taken from this example:
     * https://openlayers.org/en/latest/examples/export-map.html
     */
    drawCanvas: function drawCanvas() {
      var me = this;
      me.mapContext.fillStyle = 'white';
      me.mapContext.fillRect(0, 0, me.mapCanvas.width, me.mapCanvas.height);
      Array.prototype.forEach.call(document.querySelectorAll('.ol-layer canvas'), function (canvas) {
        if (canvas.width > 0) {
          var _context;

          var opacity = canvas.parentNode.style.opacity;
          me.mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity); // Get the transform parameters from the style's transform matrix
          // and apply the transform to the export map context.

          var transform = canvas.style.transform;
          /* eslint-disable-next-line no-useless-escape */

          var matrix = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context = transform.match(/^matrix\(([^\(]*)\)$/)[1].split(',')).call(_context, Number);

          CanvasRenderingContext2D.prototype.setTransform.apply(me.mapContext, matrix);
          me.mapContext.drawImage(canvas, 0, 0);
        }
      });
    },

    /**
     * Starts / stops recording
     */
    toggleRecord: function toggleRecord() {
      var me = this;

      if (me.recording) {
        me.stopRecording();
      } else {
        me.startRecording();
      }
    },

    /**
     * Resize the canvas when the map changes. Only happens when recording
     * is active.
     */
    mapSizeChanged: function mapSizeChanged() {
      var me = this;

      var size = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).getSize();

      me.mapCanvas.width = size[0];
      me.mapCanvas.height = size[1];
    },

    /**
     * Create a custom canvas to render into, a map recorder and start the
     * capturing process.
     */
    startRecording: function startRecording() {
      var me = this;
      me.mapCanvas = document.createElement('canvas');
      me.mapSizeChanged();
      me.mapContext = me.mapCanvas.getContext('2d');
      me.drawCanvas();

      __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).on('change:size', me.mapSizeChanged);

      me.timerHandle = setInterval(me.drawCanvas, 1000 / me.frameRate);

      try {
        me.recorder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_canvas_record__["a" /* default */])(me.mapCanvas, {
          filename: me.filename,
          frameRate: me.frameRate,
          recorderOptions: {
            videoBitsPerSecond: me.videoMBitsPerSecond * 1048576,
            mimeType: me.mimeType
          }
        });
        me.recorder.start();
      } catch (e) {
        me.error = true;
        me.stopRecording();
        return;
      }

      me.error = false;
      me.recording = true;
    },

    /**
     * Stop recording and free all associated resources.
     */
    stopRecording: function stopRecording() {
      var me = this;

      if (me.recorder) {
        me.recorder.stop();
        me.recorder.dispose();
        me.recorder = null;
      }

      clearInterval(me.timerHandle);
      me.timerHandle = null;

      __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).un('change:size', me.mapSizeChanged);

      me.mapContext = me.mapCanvas = null;
      me.recording = false;
    },

    /**
     * Returns video codecs supported by the browser. See
     * https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Containers
     */
    getSupportedMimeTypes: function getSupportedMimeTypes() {
      var _context2;

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context2 = ['video/webm', 'video/mp4', 'video/ogg', 'video/x-matroska', 'video/quicktime', 'video/3gpp']).call(_context2, function (mimeType) {
        return MediaRecorder.isTypeSupported(mimeType);
      });
    }
  }
});

/***/ }),

/***/ "1iwb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-module-card',_vm._b({staticClass:"wgu-helpwin",attrs:{"moduleName":_vm.moduleName,"icon":_vm.icon,"width":_vm.width}},'wgu-module-card',_vm.$attrs,false),[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[(_vm.$t('wgu-helpwin.textTitle'))?_c('h3',{staticClass:"headline mb-0"},[_vm._v("\n        "+_vm._s(_vm.$t('wgu-helpwin.textTitle')))]):_vm._e()])]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"text--primary",domProps:{"innerHTML":_vm._s(_vm.$t('wgu-helpwin.htmlContent'))}})]),_vm._v(" "),_c('v-card-actions',[(_vm.$t('wgu-helpwin.infoLinkUrl'))?_c('a',{staticClass:"info-link red--text darken3",attrs:{"href":_vm.$t('wgu-helpwin.infoLinkUrl'),"target":"_blank"}},[_vm._v("\n      "+_vm._s(_vm.$t('wgu-helpwin.infoLinkText') || _vm.$t('wgu-helpwin.infoLinkUrl'))+"\n      ")]):_vm._e()])],1)}
var staticRenderFns = []


/***/ }),

/***/ "1l2W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PermalinkController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__ = __webpack_require__("nOcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__ = __webpack_require__("howJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_map__ = __webpack_require__("aEal");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_includes__ = __webpack_require__("wk9Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_proj_Projection__ = __webpack_require__("7rnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_proj__ = __webpack_require__("yGLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_Url__ = __webpack_require__("v9hS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ol_extent__ = __webpack_require__("/LWt");












/**
 * Class holding the logic for permalinks.
 */

var PermalinkController = /*#__PURE__*/function () {
  /* the OL map for permalink */
  function PermalinkController(map, permalinkConf) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default()(this, PermalinkController);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "map", null);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "shouldUpdate", false);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "projection", null);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "conf", null);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "urlParams", null);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "ignoreLayers", ['wgu-measure-layer', 'wgu-geolocator-layer']);

    this.map = map;
    this.conf = permalinkConf || {};
    this.projection = this.conf.projection ? new __WEBPACK_IMPORTED_MODULE_8_ol_proj_Projection__["a" /* default */]({
      'code': this.conf.projection
    }) : null;
    this.conf.paramPrefix = this.conf.paramPrefix || '';
    this.conf.location = this.conf.location || 'hash';
    this.conf.separator = this.conf.location === 'hash' ? '#' : '?';
    this.conf.history = this.conf.history ? this.conf.history : false;
    this.conf.extent = this.conf.extent ? this.conf.extent : false;
    this.conf.layers = this.conf.layers ? this.conf.layers : false;
    this.conf.precision = this.conf.precision ? this.conf.precision : 4;
    this.urlParams = __WEBPACK_IMPORTED_MODULE_10__util_Url__["a" /* default */].getParams(this.conf.location);
    this.layerListeners = [];
  }
  /**
   * Initializes the map permalink functionality:
   * Registers a 'moveend' event to update the permalink
   * 'hoverAttribute' if the layer is configured as 'hoverable'
   */


  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default()(PermalinkController, [{
    key: "setup",
    value: function setup() {
      var _this = this;

      this.shouldUpdate = true; // Listen to map state changes (pan, zoom)

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).on('moveend', function () {
        _this.onMapChange();
      }); // Listen to visibility changes in Map Layers.


      this.subscribeLayers(); // Listen to Layer Collection (dynamically Layers added/removed)

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().on('change:length', function () {
        _this.subscribeLayers();
      });

      if (this.conf.history === false) {
        return;
      } // restore the view state when navigating through the history (browser back/forward buttons), see
      // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate


      window.addEventListener('popstate', function (event) {
        if (event.state === null || __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this) === null) {
          return;
        }

        var view = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this).getView();

        var state = event.state;
        _this.shouldUpdate = false;
        view.setRotation(state.rotation); // Use extent (bbox) or center+zoom based on config

        if (_this.conf.extent) {
          _this.applyExtent(state.extent);
        } else {
          _this.applyCenter(state.center);
        } // somehow we also need zoom (or resolution) for extent:
        // See: https://stackoverflow.com/questions/47770782/openlayers-fit-to-current-extent-is-zooming-out


        view.setZoom(state.zoom);

        if (_this.conf.layers) {
          var _context;

          _this.applyLayers(new __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_map___default.a(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context = state.layers).call(_context, function (lid) {
            return [lid, lid];
          })));
        }
      });
    }
    /**
     * Stop this instance.
     */

  }, {
    key: "tearDown",
    value: function tearDown() {
      this.unsubscribeLayers();
      this.map = null;
    }
    /**
     * Subscribe to Layer visibility changes.
     */

  }, {
    key: "subscribeLayers",
    value: function subscribeLayers() {
      var _this2 = this;

      if (!__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this)) {
        return;
      } // First unsubscribe from all


      this.unsubscribeLayers(); // Listen to each Layer's visibility changes.

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().forEach(function (layer) {
        var key = layer.on('change:visible', function () {
          _this2.onMapChange();
        });

        _this2.layerListeners.push({
          'key': key,
          'layer': layer
        });
      });
    }
    /**
     * Unsubscribe to Layer visibility changes.
     */

  }, {
    key: "unsubscribeLayers",
    value: function unsubscribeLayers() {
      if (!__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this)) {
        return;
      } // Listen to each Layer's visibility changes.


      this.layerListeners.forEach(function (item) {
        item.layer.un(item.key.type, item.key.listener);
      });
      this.layerListeners = [];
    }
    /**
     * Applies map (View) rotation, center+zoom-level or extent
     * from permalink params in current URL 'location'
     */

  }, {
    key: "apply",
    value: function apply() {
      var permalinkParams = __WEBPACK_IMPORTED_MODULE_10__util_Url__["a" /* default */].getParams(this.conf.location);
      var prefix = this.conf.paramPrefix;

      var mapView = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView();

      var r = "".concat(prefix, "r");
      var c = "".concat(prefix, "c");
      var e = "".concat(prefix, "e");
      var z = "".concat(prefix, "z");
      var l = "".concat(prefix, "l");

      if (permalinkParams[r]) {
        mapView.setRotation(parseFloat(permalinkParams[r]));
      } // Both extent (bbox) or center+zoom supported.


      if (permalinkParams[e]) {
        var _context2;

        var extent = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context2 = permalinkParams[e].split(',')).call(_context2, function (n) {
          return parseFloat(n);
        });

        this.applyExtent(extent);
      } else if (permalinkParams[c]) {
        var _context3;

        var center = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context3 = permalinkParams[c].split(',')).call(_context3, function (n) {
          return parseFloat(n);
        });

        this.applyCenter(center);
      } // Always set zoom, even with extent
      // See: https://stackoverflow.com/questions/47770782/openlayers-fit-to-current-extent-is-zooming-out


      if (permalinkParams[z]) {
        mapView.setZoom(parseFloat(permalinkParams[z]));
      } // Set layer(s) visible


      if (permalinkParams[l]) {
        var _context4;

        this.applyLayers(new __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_map___default.a(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context4 = permalinkParams[l].split(',')).call(_context4, function (lid) {
          return [lid, lid];
        })));
      }
    }
    /**
     * Make only the layers for given array of layer ids visible.
     */

  }, {
    key: "applyLayers",
    value: function applyLayers(layers) {
      if (!layers) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().forEach(function (layer) {
        var layerId = layer.get('lid');
        layer.setVisible(layerId === layers.get(layerId));
      });
    }
    /**
     * Position map at provided center.
     */

  }, {
    key: "applyCenter",
    value: function applyCenter(center) {
      if (!center) {
        return;
      }

      var mapView = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView(); // Permalink coordinates may have specific Projection like WGS84


      if (this.projection) {
        center = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_ol_proj__["j" /* transform */])(center, this.projection, mapView.getProjection());
      }

      mapView.setCenter(center);
    }
    /**
     * Position map at provided map extent.
     */

  }, {
    key: "applyExtent",
    value: function applyExtent(extent) {
      if (!extent) {
        return;
      }

      var mapView = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView(); // Permalink coordinates may have specific Projection like WGS84


      if (this.projection) {
        extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_ol_extent__["i" /* applyTransform */])(extent, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_ol_proj__["b" /* getTransform */])(this.projection, mapView.getProjection()));
      } // Fit the map in extent


      mapView.fit(extent, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getSize());
    }
    /**
     * Get the URL parameter permalink string as query or hash.
     */

  }, {
    key: "getParamStr",
    value: function getParamStr() {
      var round = function round(num, places) {
        return +(Math.round(num + 'e+' + places) + 'e-' + places);
      };

      var state = this.getState();
      var prefix = this.conf.paramPrefix;
      var prec = this.conf.precision; // Use extent (bbox) or center+zoom based on config

      this.urlParams["".concat(prefix, "z")] = "".concat(round(state.zoom, prec));

      if (this.conf.extent) {
        var _context5;

        this.urlParams["".concat(prefix, "e")] = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context5 = state.extent).call(_context5, function (n) {
          return round(n, prec);
        }).join(',');
      } else {
        var _context6;

        this.urlParams["".concat(prefix, "c")] = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context6 = state.center).call(_context6, function (n) {
          return round(n, prec);
        }).join(',');
      }

      this.urlParams["".concat(prefix, "r")] = "".concat(round(state.rotation, prec));

      if (this.conf.layers) {
        this.urlParams["".concat(prefix, "l")] = state.layers.join(',');
      }

      return this.conf.separator + __WEBPACK_IMPORTED_MODULE_10__util_Url__["a" /* default */].toQueryString(this.urlParams);
    }
    /**
     * Get full URL with permalink string for sharing.
     */

  }, {
    key: "getShareUrl",
    value: function getShareUrl() {
      return location.href.split(this.conf.separator)[0] + this.getParamStr();
    }
    /**
     * Get (IFrame) code fragment for embedding the permalink in an HTML page.
     */

  }, {
    key: "getEmbedHTML",
    value: function getEmbedHTML() {
      var _context7, _context8;

      var mapSize = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getSize();

      return __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context7 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context8 = "<iframe width=\"".concat(mapSize[0], "\" height=\"")).call(_context8, mapSize[1], "\" src=\"")).call(_context7, this.getShareUrl(), "\" style=\"border:none;\"></iframe>");
    }
    /**
     * Get array of visible and not ignored layer IDs.
     */

  }, {
    key: "getLayerIds",
    value: function getLayerIds() {
      var _context9,
          _context10,
          _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context9 = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context10 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().getArray()).call(_context10, function (layer) {
        var _context11;

        return !!layer.get('lid') && layer.getVisible() && !__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_includes___default()(_context11 = _this3.ignoreLayers).call(_context11, layer.get('lid'));
      })).call(_context9, function (layer) {
        return layer.get('lid');
      });
    }
    /**
     * Get total State of the Map.
     */

  }, {
    key: "getState",
    value: function getState() {
      var mapView = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView();

      var center = mapView.getCenter();
      var extent = mapView.calculateExtent(); // Optionally reproject to permalink projection (e.g. WGS84 on WebMerc).

      if (this.projection) {
        center = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_ol_proj__["j" /* transform */])(center, mapView.getProjection(), this.projection);
        extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_ol_extent__["i" /* applyTransform */])(extent, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_ol_proj__["b" /* getTransform */])(mapView.getProjection(), this.projection));
      }

      return {
        zoom: mapView.getZoom(),
        center: center,
        extent: extent,
        rotation: mapView.getRotation(),
        layers: this.getLayerIds()
      };
    }
    /**
     * Callback when Map View has changed, e.g. 'moveend' or a Layer's visibility.
     */

  }, {
    key: "onMapChange",
    value: function onMapChange() {
      // console.log('mapchange');
      if (!this.shouldUpdate) {
        // do not update the URL when the view was changed in the 'popstate' handler
        this.shouldUpdate = true;
        return;
      }

      if (this.conf.history === false) {
        return;
      } // This changes the URL in address bar.


      window.history.pushState(this.getState(), 'map', this.getParamStr());
    }
  }]);

  return PermalinkController;
}();



/***/ }),

/***/ "1nz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Geolocator_vue__ = __webpack_require__("N/gh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1630e9fa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geolocator_vue__ = __webpack_require__("O1k0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("+f0w")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1630e9fa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Geolocator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1630e9fa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geolocator_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1630e9fa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geolocator_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1pk9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modulecore_ModuleCard__ = __webpack_require__("6OvL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LayerList__ = __webpack_require__("mucN");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-layerlist-win',
  inheritAttrs: false,
  components: {
    'wgu-module-card': __WEBPACK_IMPORTED_MODULE_0__modulecore_ModuleCard__["a" /* default */],
    'wgu-layerlist': __WEBPACK_IMPORTED_MODULE_1__LayerList__["a" /* default */]
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: 'layers'
    }
  }
});

/***/ }),

/***/ "1ywd":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de.json": "tdkq",
	"./en.json": "NuBg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1ywd";

/***/ }),

/***/ "29fi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerListWin_vue__ = __webpack_require__("1pk9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2be9e0fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerListWin_vue__ = __webpack_require__("fDqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerListWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2be9e0fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerListWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2be9e0fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerListWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "36PU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modulecore_ModuleCard__ = __webpack_require__("6OvL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_layer_Vector__ = __webpack_require__("Umvz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AttributeTable__ = __webpack_require__("odA+");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-attributetable-win',
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      required: false,
      default: 'table_chart'
    },
    syncTableMapSelection: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      moduleName: 'wgu-attributetable',
      layers: [],
      selLayer: null
    };
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_Mapable__["a" /* Mapable */]],
  components: {
    'wgu-module-card': __WEBPACK_IMPORTED_MODULE_2__modulecore_ModuleCard__["a" /* default */],
    'wgu-attributetable': __WEBPACK_IMPORTED_MODULE_5__AttributeTable__["a" /* default */]
  },
  methods: {
    show: function show() {
      // resize map properly after closing
      // the AttributeTable
      this.resizeOlMap();
    },
    onResize: function onResize() {
      // change map size when window is changing
      this.resizeOlMap();
    },

    /**
     * Update the OpenLayers map size.
     *
     * Necessary because the map does not automatically
     * notice when its size is changed externally.
     */
    resizeOlMap: function resizeOlMap() {
      var _this = this;

      this.$nextTick(function () {
        // must be within '$nextTick' to take effect
        __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this).updateSize();
      });
    },

    /**
     * This function is executed, after the map is bound (see mixins/Mapable).
     * Bind to the layers from the OpenLayers map.
     */
    onMapBound: function onMapBound() {
      this.layers = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().getArray();
    }
  },
  computed: {
    /**
     * Reactive property to return the OpenLayers vector layers to be shown in the selection menu.
     */
    displayedLayers: function displayedLayers() {
      var _context;

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context = this.layers).call(_context, function (layer) {
        return layer instanceof __WEBPACK_IMPORTED_MODULE_4_ol_layer_Vector__["a" /* default */] && layer.get('lid') !== 'wgu-measure-layer' && layer.get('lid') !== 'wgu-geolocator-layer';
      }).reverse();
    }
  }
});

/***/ }),

/***/ "4uSC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.logoSrc)?_c('v-avatar',{staticClass:"wgu-app-logo",attrs:{"width":_vm.logoWidth,"height":_vm.logoHeight,"tile":true}},[_c('img',{attrs:{"src":_vm.logoSrc,"alt":_vm.$t('app.logo')}})]):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "4z3x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modulecore_ModuleCard__ = __webpack_require__("6OvL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MeasureTypeChooser__ = __webpack_require__("w/12");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MeasureResult__ = __webpack_require__("cspx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OlMeasureController__ = __webpack_require__("VT4C");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-measuretool-win',
  inheritAttrs: false,
  components: {
    'wgu-module-card': __WEBPACK_IMPORTED_MODULE_1__modulecore_ModuleCard__["a" /* default */],
    'wgu-measure-type-chooser': __WEBPACK_IMPORTED_MODULE_3__MeasureTypeChooser__["a" /* default */],
    'wgu-measure-result': __WEBPACK_IMPORTED_MODULE_4__MeasureResult__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Mapable__["a" /* Mapable */]],
  props: {
    icon: {
      type: String,
      required: false,
      default: 'photo_size_select_small'
    }
  },
  data: function data() {
    return {
      moduleName: 'wgu-measuretool',
      measureGeom: null,
      measureType: 'distance'
    };
  },
  destroy: function destroy() {
    if (this.olMapCtrl) {
      this.olMapCtrl.destroy();
      this.olMapCtrl = undefined;
    }
  },
  watch: {
    measureType: function measureType() {
      if (!this.olMapCtrl) {
        return;
      } // reset old geom


      this.measureGeom = {};
      this.olMapCtrl.addInteraction(this.measureType, this.onMeasureVertexSet);
    }
  },
  methods: {
    /**
     * (Un-)Register map interactions when the visibility of the module changes.
     *
     * @param  {boolean} visible New visibility state
     */
    show: function show(visible) {
      if (!this.olMapCtrl) {
        return;
      }

      if (visible) {
        this.olMapCtrl.addInteraction(this.measureType, this.onMeasureVertexSet);
      } else {
        this.olMapCtrl.removeInteraction();
      }
    },

    /**
     * Applies the changed measure value to this.measureType.
     * Called as callback of MeasureTypeChooser
     *
     * @param  {String} newMeasureType New measure type
     * @param  {String} oldMeasureType Old measure type
     */
    applyMeasureType: function applyMeasureType(newMeasureType, oldMeasureType) {
      this.measureType = newMeasureType;
    },

    /**
     * This function is executed, after the map is bound (see mixins/Mapable)
     */
    onMapBound: function onMapBound() {
      if (this.unbound) {
        return;
      } // TODO: Should we explicitly declare all attributes as props?


      this.olMapCtrl = new __WEBPACK_IMPORTED_MODULE_5__OlMeasureController__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this), this.$attrs);
      this.olMapCtrl.createMeasureLayer();
    },

    /**
     * This function is executed, after the map is bound (see mixins/Mapable)
     */
    onMapUnbound: function onMapUnbound() {
      if (this.olMapCtrl) {
        this.olMapCtrl.destroy();
        this.olMapCtrl = undefined;
      }
    },

    /**
     * Callback function executed when user sets a measure point on the map.
     *
     * @param  {ol/geom/Geometry} geom The geometry object of the map
     */
    onMeasureVertexSet: function onMeasureVertexSet(geom) {
      // wrap geom into object, otherwise the injection into childs does
      // not work. Maybe the OL object does not feel changed for Vue
      this.measureGeom = {
        geom: geom
      };
    }
  }
});

/***/ }),

/***/ "5e8c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-module-card',_vm._b({staticClass:"wgu-infoclick-win",attrs:{"moduleName":_vm.moduleName,"icon":_vm.icon,"color":_vm.color},on:{"visibility-change":_vm.show}},'wgu-module-card',_vm.$attrs,false),[(!this.showMedia)?_c('div',[_c('v-card-title',{staticClass:"wgu-infoclick-win-title",attrs:{"primary-title":""}},[(!this.attributeData && !this.coordsData)?_c('v-card-text',{staticClass:"no-data"},[_vm._v("\n        "+_vm._s(_vm.$t('wgu-infoclick.mapClick'))+"\n      ")]):_vm._e(),_vm._v(" "),_c('wgu-property-table',{attrs:{"properties":_vm.attributeData,"color":_vm.color}}),_vm._v(" "),_c('wgu-coords-table',{attrs:{"coordsData":_vm.coordsData,"color":_vm.color}})],1)],1):_vm._e(),_vm._v(" "),(this.showMedia)?_c('div',[(!this.attributeData)?_c('v-card-text',{staticClass:"no-data"},[_vm._v(" \n      "+_vm._s(_vm.$t('wgu-infoclick.mediaClick'))+"\n    ")]):_vm._e(),_vm._v(" "),(this.attributeData)?_c('v-img',{attrs:{"height":"250","src":this.attributeData[this.imageProp]}}):_vm._e(),_vm._v(" "),(this.attributeData && this.attributeData[_vm.imageDescriptionProp])?_c('v-card-text',[_vm._v("\n      "+_vm._s(this.attributeData[_vm.imageDescriptionProp])+"\n    ")]):_vm._e(),_vm._v(" "),_c('v-card-actions',[(this.attributeData && this.attributeData[_vm.mediaInfoLinkUrlProp])?_c('v-btn',{attrs:{"text":"","color":_vm.color,"href":this.attributeData[_vm.mediaInfoLinkUrlProp],"target":"_blank"}},[_vm._v("\n        "+_vm._s(_vm.$t('wgu-infoclick.mediaInfoLinkText') || this.attributeData[_vm.mediaInfoLinkUrlProp])+"\n      ")]):_vm._e()],1)],1):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ "5tHn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{staticClass:"wgu-app-sidebar",attrs:{"app":"","clipped":"","width":"400"},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_c('v-btn',{staticClass:"wgu-app-sidebar-toggle-btn px0",attrs:{"absolute":"","top":"","color":"white","width":"20","min-width":"20"},on:{"click":function($event){_vm.sidebarOpen = !_vm.sidebarOpen}}},[(_vm.sidebarOpen)?_c('v-icon',[_vm._v("chevron_left")]):_c('v-icon',[_vm._v("chevron_right")])],1)]},proxy:true}]),model:{value:(_vm.sidebarOpen),callback:function ($$v) {_vm.sidebarOpen=$$v},expression:"sidebarOpen"}},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),

/***/ "6OvL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModuleCard_vue__ = __webpack_require__("kQCp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c125380c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModuleCard_vue__ = __webpack_require__("hQPT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModuleCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c125380c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModuleCard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c125380c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModuleCard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6f8f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7OTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modulecore_ModuleCard__ = __webpack_require__("6OvL");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-helpwin-win',
  inheritAttrs: false,
  components: {
    'wgu-module-card': __WEBPACK_IMPORTED_MODULE_1__modulecore_ModuleCard__["a" /* default */]
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: 'help'
    },
    width: {
      type: Number,
      required: false,
      default: 300
    }
  },
  data: function data() {
    return {
      moduleName: 'wgu-helpwin'
    };
  }
});

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8NCD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"white--text",attrs:{"color":_vm.color,"app":""}},[_c('span',{staticClass:"wgu-footer-left",domProps:{"innerHTML":_vm._s(_vm.footerTextLeft)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"wgu-footer-right"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.footerTextRight)}}),_vm._v(" "),(_vm.showCopyrightYear)?_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear()))]):_vm._e()])],1)}
var staticRenderFns = []


/***/ }),

/***/ "8SDf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8ZS6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PoiInfo_vue__ = __webpack_require__("HEFi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67013840_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PoiInfo_vue__ = __webpack_require__("arw4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("dvsc")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67013840"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PoiInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67013840_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PoiInfo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67013840_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PoiInfo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8tls":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WguEventBus__ = __webpack_require__("ZkkH");
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-toggle-btn',
  props: {
    moduleName: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    dark: {
      type: Boolean,
      required: false,
      default: false
    },
    visible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      show: this.visible
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__WguEventBus__["a" /* WguEventBus */].$on(this.moduleName + 'visibility-change', function (visible) {
      _this.show = visible;
    });
  },
  methods: {
    toggleUi: function toggleUi() {
      __WEBPACK_IMPORTED_MODULE_0__WguEventBus__["a" /* WguEventBus */].$emit(this.moduleName + 'visibility-change', !this.show);
    }
  }
});

/***/ }),

/***/ "8xuK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn-toggle',{attrs:{"borderless":"","dense":"","background-color":"transparent","dark":_vm.dark,"title":_vm.$t(_vm.moduleName + '.title')},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-btn',{attrs:{"icon":"","value":true},on:{"click":_vm.toggleUi}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "9OlX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = json;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof__ = __webpack_require__("xtLq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_promise__ = __webpack_require__("SBIS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat__);




// Code modified from: https://github.com/jonataswalker/ol-geocoder version: July 30, 2019
// The MIT License (MIT)
//
// Copyright (c) 2015 Jonatas Walker
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
// TODO: may use Axios/Axios-jsonp
function json(obj) {
  return new __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_promise___default.a(function (resolve, reject) {
    var url = encodeUrlXhr(obj.url, obj.data);
    var config = {
      method: 'GET',
      mode: 'cors',
      credentials: 'same-origin'
    };

    if (obj.jsonp) {
      jsonp(url, obj.callbackName, resolve);
    } else {
      fetch(url, config).then(function (r) {
        return r.json();
      }).then(resolve).catch(reject);
    }
  });
}

function toQueryString(obj) {
  return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_keys___default()(obj).reduce(function (a, k) {
    var _context;

    a.push(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default()(obj[k]) === 'object' ? toQueryString(obj[k]) : __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context = "".concat(encodeURIComponent(k), "=")).call(_context, encodeURIComponent(obj[k])));
    return a;
  }, []).join('&');
}

function encodeUrlXhr(url, data) {
  if (data && __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default()(data) === 'object') {
    url += (/\?/.test(url) ? '&' : '?') + toQueryString(data);
  }

  return url;
}

function jsonp(url, key, callback) {
  // https://github.com/Fresheyeball/micro-jsonp/blob/master/src/jsonp.js
  var head = document.head;
  var script = document.createElement('script'); // generate minimally unique name for callback function

  var callbackName = 'f' + Math.round(Math.random() * Date.now()); // set request url

  script.setAttribute('src',
  /*  add callback parameter to the url
        where key is the parameter key supplied
        and callbackName is the parameter value */
  url + (url.indexOf('?') > 0 ? '&' : '?') + key + '=' + callbackName);
  /*  place jsonp callback on window,
      the script sent by the server should call this
      function as it was passed as a url parameter */

  window[callbackName] = function (data) {
    window[callbackName] = undefined; // clean up script tag created for request

    setTimeout(function () {
      return head.removeChild(script);
    }, 0); // hand data back to the user

    callback(data);
  }; // actually make the request


  head.appendChild(script);
}

/***/ }),

/***/ "9x2o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bik2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Photon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__ = __webpack_require__("nOcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__ = __webpack_require__("howJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat__);




// Code modified from: https://github.com/jonataswalker/ol-geocoder version: Aug 01, 2019
// The MIT License (MIT)
//
// Copyright (c) 2015 Jonatas Walker
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
//

/**
 * Photon Provider. See https://photon.komoot.de.
 *
 * @class Photon
 */
var Photon = /*#__PURE__*/function () {
  /**
   * @constructor
   */
  function Photon() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default()(this, Photon);

    this.settings = {
      url: 'https://photon.komoot.de/api/',
      params: {
        q: '',
        limit: 10,
        lang: 'en'
      },
      langs: ['de', 'it', 'fr', 'en']
    };
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default()(Photon, [{
    key: "getParameters",
    value: function getParameters(options) {
      options.lang = options.lang.toLowerCase();
      return {
        url: this.settings.url,
        params: {
          q: options.query,
          limit: options.limit || this.settings.params.limit,
          lang: this.settings.langs.indexOf(options.lang) > -1 ? options.lang : this.settings.params.lang
        }
      };
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(results) {
      var _context;

      if (!results.features.length) return;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context = results.features).call(_context, function (feature) {
        var _context2, _context3, _context4, _context5;

        // Response is GeoJSON
        var geometry = feature.geometry;
        var properties = feature.properties;

        var displayName = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context2 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context3 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context4 = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context5 = "".concat(properties.name, " ")).call(_context5, properties.city || '', " ")).call(_context4, properties.postcode || '', " ")).call(_context3, properties.state || '', " ")).call(_context2, properties.country || '');

        var result = {
          lon: geometry.coordinates[0],
          lat: geometry.coordinates[1],
          address: {
            name: displayName,
            postcode: properties.postcode || '',
            city: properties.city || '',
            state: properties.state || '',
            country: properties.country || ''
          },
          original: {
            formatted: displayName,
            details: properties
          }
        }; // Sometimes has bbox

        if (properties.extent) {
          result.boundingbox = properties.extent;
        }

        return result;
      });
    }
  }]);

  return Photon;
}();

/***/ }),

/***/ "C22J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-app-tpl',[(_vm.inIframe())?_c('base',{attrs:{"target":"_parent"}}):_vm._e(),_vm._v(" "),_c('PoiInfo',{attrs:{"slot":"wgu-before-content","color":_vm.baseColor},slot:"wgu-before-content",scopedSlots:_vm._u([{key:"poiinfo-after-subtitle",fn:function(slotProps){return [(slotProps.featureProperties)?_c('v-sparkline',{attrs:{"value":_vm.extractTimeLineValues(slotProps.featureProperties.series),"color":_vm.baseColor}}):_vm._e()]}}])})],1)}
var staticRenderFns = []


/***/ }),

/***/ "DgqD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerPreviewImage_vue__ = __webpack_require__("h9kb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_462fe1a7_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerPreviewImage_vue__ = __webpack_require__("wHUX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerPreviewImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_462fe1a7_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerPreviewImage_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_462fe1a7_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerPreviewImage_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DjXo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"wgu-app-toolbar white--text",attrs:{"color":_vm.color,"fixed":"","app":"","clipped-left":"","clipped-right":""}},[_vm._t("wgu-tb-start"),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('app.title')))]),_vm._v(" "),_vm._t("wgu-tb-after-title"),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._t("wgu-tb-before-auto-buttons"),_vm._v(" "),_vm._l((_vm.tbButtons),function(tbButton,index){return [_c(tbButton.type,_vm._b({key:index,tag:"component"},'component',tbButton,false))]}),_vm._v(" "),_vm._t("wgu-tb-after-auto-buttons"),_vm._v(" "),(_vm.menuButtons.length)?_c('v-menu',{attrs:{"offset-y":"","nudge-bottom":"15"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","dark":"","title":_vm.$t('wgu-toolbar-menu.title')}},on),[_c('v-icon',{attrs:{"medium":""}},[_vm._v("menu")])],1)]}}],null,false,588104948)},[_vm._v(" "),_c('v-list',{attrs:{"color":_vm.color}},[_vm._l((_vm.menuButtons),function(tbButton,index){return [_c('v-list-item',{key:index},[_c(tbButton.type,_vm._b({key:index,tag:"component"},'component',tbButton,false))],1)]})],2)],1):_vm._e(),_vm._v(" "),_vm._t("wgu-tb-end")],2)}
var staticRenderFns = []


/***/ }),

/***/ "ETGo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSidebar_vue__ = __webpack_require__("u4kD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_316e83fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__ = __webpack_require__("5tHn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_316e83fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_316e83fc_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F+zM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ol_geom_LineString__ = __webpack_require__("grfP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_geom_Polygon__ = __webpack_require__("ZYQ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_sphere_js__ = __webpack_require__("1avf");
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-measure-result',
  props: {
    measureGeom: {
      type: Object
    }
  },
  data: function data() {
    return {
      area: ' -- ',
      distance: ' -- '
    };
  },
  watch: {
    measureGeom: function measureGeom() {
      var me = this;
      var geom = me.measureGeom.geom;
      var output;

      if (geom instanceof __WEBPACK_IMPORTED_MODULE_1_ol_geom_Polygon__["a" /* default */]) {
        output = me.formatArea(geom);
        me.area = output;
      } else if (geom instanceof __WEBPACK_IMPORTED_MODULE_0_ol_geom_LineString__["a" /* default */]) {
        output = me.formatLength(geom);
        me.distance = output;
      } else {
        me.area = ' -- ';
        me.distance = ' -- ';
      }
    }
  },
  methods: {
    /**
     * Calculates and formats the length of the given line.
     *
     * @param  {ol.geom.LineString} line The LineString object to calculate length for
     */
    formatLength: function formatLength(line) {
      var length = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_ol_sphere_js__["c" /* getLength */])(line);
      var output;

      if (length > 100) {
        output = this.$t('wgu-measuretool.lengthKm', [Math.round(length / 1000 * 100) / 100]);
      } else {
        output = this.$t('wgu-measuretool.lengthMeter', [Math.round(length * 100) / 100]);
      }

      return output;
    },

    /**
     * Calculates and formats the area of the given polygon.
     *
     * @param  {ol.geom.Polygon} polygon The Polygon object to calculate area for
     */
    formatArea: function formatArea(polygon) {
      var area = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_ol_sphere_js__["d" /* getArea */])(polygon);
      var output;

      if (area > 10000) {
        output = this.$t('wgu-measuretool.areaSquareKm', [Math.round(area / 1000000 * 100) / 100]);
      } else {
        output = this.$t('wgu-measuretool.areaSquareMeter', [Math.round(area * 100) / 100]);
      }

      return output;
    }
  }
});

/***/ }),

/***/ "G08c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.coordRows)?_c('table',{staticClass:"wgu-coordstable",style:(_vm.tableStyles)},[_c('thead',[_c('tr',_vm._l((_vm.coordRows),function(entry,key){return _c('th',{key:key})}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.coordRows),function(value,key){return _c('tr',{key:key},[_c('td',{staticClass:"key-td"},[_vm._v("\n        "+_vm._s(key)+"\n      ")]),_vm._v(" "),_c('td',{staticClass:"val-td"},[_vm._v("\n        "+_vm._s(value)+"\n      ")])])}),0)]):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "GgOu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WguAppTemplate_vue__ = __webpack_require__("c0QU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PoiInfo__ = __webpack_require__("8ZS6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_mixins_Mapable_js__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_factory_OlStyle_js__ = __webpack_require__("fT5P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_source_Cluster__ = __webpack_require__("j+56");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_geom_Point__ = __webpack_require__("T18w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_geom_LineString__ = __webpack_require__("grfP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ol_layer_Vector__ = __webpack_require__("Umvz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ol_source_Vector__ = __webpack_require__("WMwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_util_MapInteraction__ = __webpack_require__("wO5V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_util_Style__ = __webpack_require__("wClq");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'my-wgu-app',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__src_mixins_Mapable_js__["a" /* Mapable */]],
  components: {
    'wgu-app-tpl': __WEBPACK_IMPORTED_MODULE_3__WguAppTemplate_vue__["a" /* default */],
    PoiInfo: __WEBPACK_IMPORTED_MODULE_4__components_PoiInfo__["a" /* default */]
  },
  data: function data() {
    return {
      baseColor: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appConfig.baseColor
    };
  },
  methods: {
    /**
     * Checks if application is inside iFrame
     * taken from https://stackoverflow.com/a/326076/
     */
    inIframe: function inIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    onMapBound: function onMapBound() {
      this.applyCategorizedStyleToLayers();
      this.applyClusterStyleToLayers();
    },

    /**
     * Extract values for sparkline
     *
     * @param {String} seriesValue The value of the series property
     *
     * @returns {Array} The array of the values to display.
     */
    extractTimeLineValues: function extractTimeLineValues(seriesValue) {
      if (!seriesValue) {
        console.warn('No station data available.');
        return;
      }

      try {
        // seriesValue comes as String and needs to be parsed
        var seriesJson = JSON.parse(seriesValue); // reshape to required format

        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(seriesJson).call(seriesJson, function (item) {
          return item['val'];
        });
      } catch (error) {
        console.warn('Parsing station data failed.');
      }
    },

    /**
     * Applies the category style to all layers that
     * have this setting enabled.
     */
    applyCategorizedStyleToLayers: function applyCategorizedStyleToLayers() {
      // find layer with category style
      var layers = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers();

      layers.forEach(function (layer) {
        var styleConf = layer.get('styleConf'); // check if layer has a category style

        var hasCategoryStyle = styleConf && styleConf.categoryKey && styleConf.categories;

        if (hasCategoryStyle) {
          var styleFunction = function styleFunction(feature, resolution) {
            // the name of the attribute that holds the categories
            var categoryKey = styleConf.categoryKey; // the current category to evaluate e.g. 'shop' or 'pharmacy'

            var categoryValue = feature.get(categoryKey); // the provided style for the catgory

            var catStyle = styleConf.categories[categoryValue]; // create the respective style with the style factory

            var olStyle = __WEBPACK_IMPORTED_MODULE_6__src_factory_OlStyle_js__["a" /* OlStyleFactory */].getInstance(catStyle); // add label to point

            if (olStyle && styleConf.label && styleConf.label.attribute && styleConf.label.attribute !== '') {
              // we need to clone the style, otherwise the text-based points cannot be shown anymore
              var clonedStyle = olStyle.clone();
              var newLabelStyle = __WEBPACK_IMPORTED_MODULE_6__src_factory_OlStyle_js__["a" /* OlStyleFactory */].getTextStyleFunction(clonedStyle, styleConf.label);
              return [olStyle, newLabelStyle(feature, resolution)];
            }

            return olStyle;
          }; // overwrite existing default style


          layer.setStyle(styleFunction);
        }
      });
    },

    /**
     * Applies cluster styling to all layers that have activated this setting.
     */
    applyClusterStyleToLayers: function applyClusterStyleToLayers() {
      var _this = this;

      // TODO: permalink shows helper layer
      var layers = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers();

      layers.forEach(function (layer) {
        var clusterConf = layer.get('clusterRendering');

        if (!clusterConf) {
          return;
        }

        var twinSource = new __WEBPACK_IMPORTED_MODULE_11_ol_source_Vector__["a" /* default */]();
        var twinLayer = new __WEBPACK_IMPORTED_MODULE_10_ol_layer_Vector__["a" /* default */]({
          name: 'twin layer',
          source: twinSource
        }); // sync visibility of both layers

        layer.on('change:visible', function () {
          var visible = layer.getVisible();
          twinLayer.setVisible(visible);
        }); // hide in layer list

        twinLayer.set('displayInLayerList', false); // set new layer id

        twinLayer.set('lid', layer.get('lid') + '-cluster-helper'); // hover

        var hoverable = layer.get('hoverable');
        twinLayer.set('hoverable', hoverable);
        layer.set('hoverable', false);
        twinLayer.set('hoverAttribute', layer.get('hoverAttribute')); // poiInfo

        twinLayer.set('poiInfo', layer.get('poiInfo')); // callout line style

        var callOutStyleSettings = clusterConf.calloutStyle || {
          strokeColor: 'rgb(136, 138, 133, 0.3)',
          strokeWidth: 1
        };
        var calloutStyle = __WEBPACK_IMPORTED_MODULE_6__src_factory_OlStyle_js__["a" /* OlStyleFactory */].getInstance(callOutStyleSettings);
        calloutStyle.setGeometry(function (feature) {
          if (!feature || !feature.getGeometry() || !feature.get('originalGeometry')) {
            return;
          }

          var movedCoordinate = feature.getGeometry().getCoordinates();
          var originalCoordinate = feature.get('originalGeometry').getCoordinates();

          if (!movedCoordinate || !originalCoordinate) {
            return;
          }

          return new __WEBPACK_IMPORTED_MODULE_9_ol_geom_LineString__["a" /* default */]([movedCoordinate, originalCoordinate]);
        });
        var clonedOriginalStyle = layer.getStyle();
        var twinStyle = __WEBPACK_IMPORTED_MODULE_13__src_util_Style__["a" /* default */].appendStyle(clonedOriginalStyle, calloutStyle); // TODO: make a restriction on the resolution
        // TODO: error on zoom out very far
        //      "Uncaught TypeError: Cannot read property 'getImage' of "

        twinLayer.setStyle(twinStyle); // remove original select interaction
        // this prevents a interaction of the original cluster point

        var correspondingInteraction = __WEBPACK_IMPORTED_MODULE_12__src_util_MapInteraction__["a" /* default */].getSelectInteraction(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this), layer.get('lid'));

        if (correspondingInteraction) {
          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this).removeInteraction(correspondingInteraction);
        } // selection


        twinLayer.set('selectable', layer.get('selectable'));
        twinLayer.set('selectStyle', layer.get('selectStyle')); // if layer is selectable register a select interaction

        var doAppendSelectStyle = layer.get('doAppendSelectStyle');

        if (twinLayer.get('selectable')) {
          var selectClick = __WEBPACK_IMPORTED_MODULE_12__src_util_MapInteraction__["a" /* default */].createSelectInteraction(twinLayer, twinLayer.get('selectStyle'), doAppendSelectStyle); // register/activate interaction on map

          __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this).addInteraction(selectClick);
        }

        __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this).addLayer(twinLayer); // replace original source with cluster source


        var clusterSrc = new __WEBPACK_IMPORTED_MODULE_7_ol_source_Cluster__["a" /* default */]({
          // 0 pixel means identical features
          distance: clusterConf.clusterDistance || 0,
          // pixel
          source: layer.getSource()
        }); // when cluster source changes
        // we clear the source of the twin layer

        clusterSrc.on('change', function (event) {
          twinSource.clear();
        });
        var clusterCircleRadius = clusterConf.clusterRadius || 40;

        var clusterStyle = function clusterStyle(cluster, resolution) {
          var features = cluster.get('features');
          var count = features.length;

          if (count === 1) {
            var singleFeature = features[0].clone();
            twinSource.addFeature(singleFeature);
            return null;
          } else {
            var centerStyleConfig = clusterConf.centerStyle || {
              radius: 2,
              fillColor: 'black'
            };
            var centerStyle = __WEBPACK_IMPORTED_MODULE_6__src_factory_OlStyle_js__["a" /* OlStyleFactory */].getInstance(centerStyleConfig);
            var _clusterStyle = [centerStyle]; // compute circle coordinates for each feature

            features.forEach(function (feature, index) {
              var clonedFeature = feature.clone();
              var oldGeometry = clonedFeature.getGeometry();
              var oldCoord = oldGeometry.getCoordinates();

              var newCoord = _this.getCircleCoordinate(oldCoord, count, index, clusterCircleRadius);

              var newGeometry = new __WEBPACK_IMPORTED_MODULE_8_ol_geom_Point__["a" /* default */](newCoord);
              clonedFeature.setGeometry(newGeometry); // add original geometry, necessary for callout lines

              clonedFeature.set('originalGeometry', oldGeometry);
              twinSource.addFeature(clonedFeature);
            });
            return _clusterStyle;
          }
        }; // applied modified source and style
        // to original layer


        layer.setSource(clusterSrc);
        layer.setStyle(clusterStyle);
      });
    },

    /**
     * Compute the coordinate of a de-clustered feature.
     *
     * @param {ol.coordinate} coordinate The original coordinate of the feature
     * @param {int} clusterCount The count of features in the current cluster
     * @param {int} index The index of the feature in the cluster
     * @param {int} [radius=40] The radius of the circle in pixel
     *
     * @returns {ol.coordinate} The new coordinate in the map CRS
     */
    getCircleCoordinate: function getCircleCoordinate(coordinate, clusterCount, index, radius) {
      if (!coordinate || !clusterCount) {
        return;
      }

      if (!index && index !== 0) {
        return;
      } // TODO: incease radius based on number of features


      if (!radius) {
        radius = 40;
      }

      var oldPixelCoord = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getPixelFromCoordinate(coordinate);

      var maxAngle = 2 * Math.PI;
      var angle = maxAngle / clusterCount * index; // TODO: make rotation configurable
      // rotate by 45°

      angle = angle + Math.PI / 4;
      var yValue = Math.sin(angle) * radius;
      var xValue = Math.cos(angle) * radius;
      oldPixelCoord[0] = oldPixelCoord[0] + xValue;
      oldPixelCoord[1] = oldPixelCoord[1] - yValue;
      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getCoordinateFromPixel(oldPixelCoord);
    }
  }
});

/***/ }),

/***/ "HEFi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray__ = __webpack_require__("EmY/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_toConsumableArray__ = __webpack_require__("mF7D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_json_stringify__ = __webpack_require__("gPdZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_includes__ = __webpack_require__("wk9Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_entries__ = __webpack_require__("FRTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_find__ = __webpack_require__("2x6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_util_Layer__ = __webpack_require__("fIFi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_mixins_Mapable_js__ = __webpack_require__("WFjz");










//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * Card that shows information about a POI.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_12__src_mixins_Mapable_js__["a" /* Mapable */]],
  props: {
    color: {
      type: String,
      required: false,
      default: 'red darken-3'
    },
    icon: {
      type: String,
      required: false,
      default: 'info'
    },
    componentTitle: {
      type: String,
      required: false,
      default: 'Info'
    }
  },
  data: function data() {
    return {
      show: false,
      imageHeight: 150,

      /** not displayed in the list, but on the component's window */
      windowProperties: {
        /** the heading of the window content */
        title: {
          possibleKeys: ['name', 'title', 'station_name']
        },

        /** the description below the heading */
        description: {
          possibleKeys: ['description']
        },

        /** the image above the list */
        image: {
          possibleKeys: ['image_url', 'image', 'photo', 'photo_url']
        }
      },

      /** displayed in the list with icons */
      iconProperties: {
        address: {
          possibleKeys: ['station_id'],
          icon: 'location_on'
        },
        phone: {
          possibleKeys: ['phone', 'telephone'],
          icon: 'call'
        },
        contact: {
          possibleKeys: ['contact'],
          icon: 'perm_identity'
        },
        email: {
          possibleKeys: ['email'],
          icon: 'email'
        }
      },

      /** displayed as buttons at the bottom */
      linkProperties: {
        website: {
          possibleKeys: ['website', 'homepage', 'www'],
          icon: 'language',
          title: 'Website'
        }
      },

      /** displayed in the list with custom names */
      customNamedProperties: {},

      /** not displayed at all */
      excludedProperties: [],
      windowItems: {},
      namedItems: {},
      iconItems: {},
      linkItems: {},
      properties: {},
      featureProperties: {},
      layerId: undefined,
      defaultExcludedProperties: ['boundedBy' // automatically created by OpenLayers
      ]
    };
  },
  mounted: function mounted() {
    var _this = this;

    // react on feature selection event
    // if feature is found this compontent will
    // be made visible
    __WEBPACK_IMPORTED_MODULE_11__src_WguEventBus__["a" /* WguEventBus */].$on('map-selectionchange', function (lid, newFeatureArray, oldFeatureArray) {
      // Prevents case that de-select event from previous layer
      // fires later than the select event of the new layer
      // this fixes the bug that the new window does not open
      if (oldFeatureArray.length && !newFeatureArray.length && lid !== _this.layerId) {
        return;
      } // get layer


      var layer = __WEBPACK_IMPORTED_MODULE_10__src_util_Layer__["a" /* default */].getLayerByLid(lid, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this));

      if (!layer) {
        return;
      }

      var poiInfo = layer.get('poiInfo');

      if (poiInfo) {
        // TODO: consider setting imageHeight per feature and not per layer
        if (poiInfo.imageHeight) {
          _this.imageHeight = poiInfo.imageHeight;
        }

        if (poiInfo.windowProperties) {
          _this.windowProperties = poiInfo.windowProperties;
        }

        if (poiInfo.iconProperties) {
          _this.iconProperties = poiInfo.iconProperties;
        }

        if (poiInfo.customNamedProperties) {
          _this.customNamedProperties = poiInfo.customNamedProperties;
        }

        if (poiInfo.excludedProperties) {
          _this.excludedProperties = poiInfo.excludedProperties;
        }

        if (poiInfo.linkProperties) {
          _this.linkProperties = poiInfo.linkProperties;
        }
      } // clear existing data


      _this.windowItems = {};
      _this.iconItems = {};
      _this.namedItems = {};
      _this.linkItems = {};
      _this.properties = {}; // check if new feature is selected

      if (newFeatureArray && newFeatureArray.length === 1) {
        var feature = newFeatureArray[0]; // deep copy
        // static properties that will not be changed
        // used for appending to slot

        _this.featureProperties = JSON.parse(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_json_stringify___default()(feature.getProperties())); // deep copy
        // object will be changed during execution

        _this.properties = JSON.parse(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_json_stringify___default()(feature.getProperties())); // get Link

        var geometryName = feature.getGeometryName();

        _this.deleteUnwantedProperties(geometryName);

        _this.linkItems = _this.getLinkItems();
        _this.windowItems = _this.getWindowItems();
        _this.iconItems = _this.getIconItems();
        _this.namedItems = _this.getNamedItems(feature);
        _this.show = true; // necessary to for identification of fired select/deselect
        // events belong to this window or not

        _this.layerId = lid;
      } else {
        _this.show = false;
      }
    });
  },
  methods: {
    /**
     * Delete unwanted properties.
     *
     * @param {String} geometryName The name of the feature's geometry property.
     */
    deleteUnwantedProperties: function deleteUnwantedProperties(geometryName) {
      for (var _i = 0, _Object$keys = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_object_keys___default()(this.properties); _i < _Object$keys.length; _i++) {
        var _context;

        var key = _Object$keys[_i];

        // concat arrays and properties
        var allExcludedProperties = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context = []).call(_context, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_toConsumableArray___default()(this.defaultExcludedProperties), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_toConsumableArray___default()(this.excludedProperties), [geometryName]); // make lower case


        allExcludedProperties = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(allExcludedProperties).call(allExcludedProperties, function (x) {
          return x.toLowerCase();
        }); // delete unwanted properties

        if (__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_includes___default()(allExcludedProperties).call(allExcludedProperties, key.toLowerCase())) {
          delete this.properties[key];
        }
      }
    },

    /**
     * Extract items that are placed as link at the bottom of the window
     * deletes them from the properties object.
     *
     * @returns {Object} The items that are shown on the window.
     */
    getLinkItems: function getLinkItems() {
      var _this2 = this;

      var linkItems = {};

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_entries___default()(this.linkProperties).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray___default()(_ref, 2),
            key = _ref2[0],
            config = _ref2[1];

        var value = _this2.properties[key];

        if (value) {
          // deep copy
          linkItems[key] = JSON.parse(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_json_stringify___default()(config)); // store item in object

          linkItems[key].url = _this2.properties[key]; // delete object from property.
          // this is necessary that it will not be reused

          delete _this2.properties[key];
        }
      });

      return linkItems;
    },

    /**
     * Extract items that are placed on the window and not in the list
     * from the properties and deletes them from the properties object.
     *
     * @returns {Object} The items that are shown on the window.
     */
    getWindowItems: function getWindowItems() {
      var _this3 = this;

      var windowItems = {};

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_entries___default()(this.windowProperties).forEach(function (_ref3) {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray___default()(_ref3, 2),
            key = _ref4[0],
            config = _ref4[1];

        var foundKey = _this3.findCorrespondingKey(config);

        if (foundKey) {
          // deep copy
          windowItems[key] = JSON.parse(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_json_stringify___default()(_this3.windowProperties[key])); // store item in object

          windowItems[key].value = _this3.properties[foundKey]; // delete object from property.
          // this is necessary that it will not be reused by 'getNamedItems()'

          delete _this3.properties[foundKey];
        }
      });

      return windowItems;
    },

    /**
     * Extract icon items from the properties and deletes them
     * from the properties object.
     *
     * @returns {Object} The items that are shown with an icon in the list.
     */
    getIconItems: function getIconItems() {
      var _this4 = this;

      var iconItems = {};

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_entries___default()(this.iconProperties).forEach(function (_ref5) {
        var _ref6 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray___default()(_ref5, 2),
            key = _ref6[0],
            config = _ref6[1];

        if (!config.icon) {
          console.warn("setting for property '".concat(key, "' misses entry for 'icon'"));
          return;
        }

        var foundKey = _this4.findCorrespondingKey(config);

        if (foundKey) {
          // deep copy
          iconItems[key] = JSON.parse(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_json_stringify___default()(_this4.iconProperties[key])); // store item in object

          iconItems[key].value = _this4.properties[foundKey]; // delete object from property.
          // this is necessary that it will not be reused by 'getNamedItems()'

          delete _this4.properties[foundKey];
        }
      });

      return iconItems;
    },

    /**
     * Finds the key in the feature's properties that corresponds
     * to the key defined in the config.
     *
     * If many keys are given via 'possibleKeys', only the first
     * is taken.
     *
     * @param config {Object} The configuration how the the property shall be displayed.
     * @returns {String} The corresponding key of the feature.
     */
    findCorrespondingKey: function findCorrespondingKey(config) {
      var foundKey; // property 'key' always has precedence over 'possibleKeys'

      if (config.key && this.properties[config.key]) {
        foundKey = config.key;
      } else if (config.possibleKeys) {
        var _context2, _context3;

        // make lower case
        var possibleKeys = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context2 = config.possibleKeys).call(_context2, function (x) {
          return x.toLowerCase();
        }); // check if in apporiate key is available in the feature


        foundKey = __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_find___default()(_context3 = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_object_keys___default()(this.properties)).call(_context3, function (prop) {
          return __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_includes___default()(possibleKeys).call(possibleKeys, prop.toLowerCase());
        });
      } else {
        // apparently setting is wrong
        return;
      }

      return foundKey;
    },

    /**
     * Extract items from feature that should be display as simple
     * key-value pair.
     *
     * @returns {Object} The extracted item.
     */
    getNamedItems: function getNamedItems() {
      var _this5 = this;

      var namedItems = {}; // we loop through properties with custom names first
      // this ensures they are added first and in the same order
      // as in the appConfig

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_entries___default()(this.customNamedProperties).forEach(function (_ref7) {
        var _ref8 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray___default()(_ref7, 2),
            key = _ref8[0],
            displayName = _ref8[1];

        // find key in this.properties
        var value = _this5.properties[key];

        if (value) {
          namedItems[key] = {
            key: key,
            displayKey: displayName,
            value: value
          };
          delete _this5.properties[key];
        }
      }); // handle remaining properties that have no special treatment


      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_entries___default()(this.properties).forEach(function (_ref9) {
        var _ref10 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray___default()(_ref9, 2),
            key = _ref10[0],
            value = _ref10[1];

        namedItems[key] = {
          key: key,
          value: value
        };
      });

      return namedItems;
    }
  }
});

/***/ }),

/***/ "HyBD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find__ = __webpack_require__("2x6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LayerPreviewImage__ = __webpack_require__("DgqD");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-bglayerlist',
  components: {
    'wgu-layerpreviewimage': __WEBPACK_IMPORTED_MODULE_6__LayerPreviewImage__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_Mapable__["a" /* Mapable */]],
  props: {
    emptyText: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    dark: {
      type: Boolean,
      required: true
    },
    selColor: {
      type: String,
      required: true
    },
    selDark: {
      type: Boolean,
      required: true
    },
    imageWidth: {
      type: Number,
      required: true
    },
    imageHeight: {
      type: Number,
      required: true
    },
    previewIcon: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      layers: []
    };
  },
  mounted: function mounted() {
    // Work around a bug in vuetify which doesn't realize the overflow of slideGroups properly,
    // when the control is initially rendered. The underlying implementation relies on the clientWidth
    // property of DOM elements, which is not computed on mount time. The bug is related to
    // https://github.com/vuejs/Discussion/issues/394 .The following works in Firefox and Chrome.
    var slideGroup = this.$refs.slideGroup;

    if (slideGroup) {
      setTimeout(function () {
        slideGroup.onResize();
      }, 10);
    }
  },
  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable).
     * Bind to the layers from the OpenLayers map.
     */
    onMapBound: function onMapBound() {
      this.layers = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().getArray();
    },

    /**
     * Handler for click on item in layer list:
     * Set the selected background layer to visible and hide all other background layers.
     * @param  {Object} selLayer  Layer selected by the user
     */
    onSelectLayer: function onSelectLayer(selLayer) {
      var _context;

      selLayer.setVisible(true);

      __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context = this.displayedLayers).call(_context, function (layer) {
        return layer !== selLayer;
      }).forEach(function (layer) {
        layer.setVisible(false);
      });
    }
  },
  computed: {
    /**
     * Reactive property to return the OpenLayers layers marked as 'isBaseLayer'.
     */
    displayedLayers: function displayedLayers() {
      var _context2;

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context2 = this.layers).call(_context2, function (layer) {
        return layer.get('isBaseLayer');
      }).reverse();
    },

    /**
     * Reactive property to return the currently visible OpenLayers background layer.
     * To disambiguate multiple selected background layers - which may occur programmatically -
     * this returns the first in the list of background layers.
     */
    selectedLayer: function selectedLayer() {
      var _context3;

      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find___default()(_context3 = this.displayedLayers).call(_context3, function (layer) {
        return layer.getVisible();
      });
    }
  }
});

/***/ }),

/***/ "ILVl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapRecorderWin_vue__ = __webpack_require__("1iCm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39db3e30_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapRecorderWin_vue__ = __webpack_require__("vUNz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapRecorderWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39db3e30_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapRecorderWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39db3e30_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapRecorderWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ijfx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","dark":_vm.dark,"title":_vm.$t('wgu-zoomtomaxextent.title')},on:{"click":_vm.onClick}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []


/***/ }),

/***/ "Iw4/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L1xf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray__ = __webpack_require__("EmY/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_trim__ = __webpack_require__("9gOy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_string_split_js__ = __webpack_require__("388n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_string_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_string_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_regexp_exec_js__ = __webpack_require__("XEfP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_regexp_exec_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_regexp_exec_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_object_to_string_js__ = __webpack_require__("vw/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_regexp_to_string_js__ = __webpack_require__("q4B+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_regexp_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_regexp_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_string_replace_js__ = __webpack_require__("ocEJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_string_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_string_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es_number_to_fixed_js__ = __webpack_require__("9P18");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es_number_to_fixed_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es_number_to_fixed_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_util_colors__ = __webpack_require__("IHMs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_es5_util_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Color__ = __webpack_require__("nF/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ol_proj_js__ = __webpack_require__("yGLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ol_coordinate__ = __webpack_require__("IZoy");








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-coords-table',
  props: {
    color: {
      type: String,
      required: false,
      default: 'red darken-3'
    },
    coordsData: {
      type: Object
    },
    showMapPos: {
      type: Boolean,
      required: false,
      default: true
    },
    showWgsPos: {
      type: Boolean,
      required: false,
      default: true
    },
    showHdms: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      coordRows: null
    };
  },
  computed: {
    tableStyles: function tableStyles() {
      // calculate border color of tables due to current color property
      var borderColor = this.color;

      if (!__WEBPACK_IMPORTED_MODULE_9__util_Color__["a" /* default */].isCssColor(this.color)) {
        var _context;

        var _this$color$toString$ = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_trim___default()(_context = this.color.toString()).call(_context).split(' ', 2),
            _this$color$toString$2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray___default()(_this$color$toString$, 2),
            colorName = _this$color$toString$2[0],
            colorModifier = _this$color$toString$2[1];

        borderColor = __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_util_colors___default.a[colorName];

        if (colorModifier) {
          colorModifier = colorModifier.replace('-', '');
          borderColor = __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_util_colors___default.a[colorName][colorModifier];
        }
      }

      return {
        'border': '2px solid ' + borderColor
      };
    }
  },
  methods: {},
  watch: {
    coordsData: function coordsData() {
      var me = this;
      var coordinate = me.coordsData.coordinate;
      var projection = me.coordsData.projection;
      var coordinateWgs84 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_ol_proj_js__["j" /* transform */])(coordinate, projection, 'EPSG:4326');
      var coordRows = {};

      if (me.showMapPos) {
        // show coordinate in map' SRS
        coordRows['MAP PROJ'] = coordinate[1].toFixed(2) + ' ' + coordinate[0].toFixed(2);
      }

      if (me.showWgsPos) {
        // show coordinate in WGS 84
        var _coordinateWgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_ol_proj_js__["j" /* transform */])(coordinate, projection, 'EPSG:4326');

        coordRows['WGS 84'] = _coordinateWgs[1].toFixed(7) + '° ' + _coordinateWgs[0].toFixed(7) + '°';
      }

      if (me.showHdms) {
        // show coordinate in WGS 84 as formatted degree / min / secs
        var hdms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_ol_coordinate__["e" /* toStringHDMS */])(coordinateWgs84);
        coordRows['HDMS'] = hdms;
      }

      me.coordRows = coordRows;
    }
  }
});

/***/ }),

/***/ "L4cT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"color":_vm.color,"dark":_vm.dark,"elevation":"8"}},[(_vm.displayedLayers.length)?_c('v-slide-group',{ref:"slideGroup",staticClass:"pa-1",attrs:{"mandatory":"","show-arrows":"","value":_vm.selectedLayer},on:{"change":_vm.onSelectLayer}},_vm._l((_vm.displayedLayers),function(layer){return _c('v-slide-item',{key:layer.lid,attrs:{"value":layer},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_c('v-card',{staticClass:"ma-1",attrs:{"color":active ? _vm.selColor : _vm.color,"dark":active? _vm.selDark : _vm.dark,"hover":"","width":_vm.imageWidth},on:{"click":toggle}},[_c('wgu-layerpreviewimage',{attrs:{"layer":layer,"mapView":_vm.map.getView(),"width":_vm.imageWidth,"height":_vm.imageHeight,"previewIcon":_vm.previewIcon}}),_vm._v(" "),_c('v-card-title',{staticClass:"caption"},[_c('span',{staticClass:"d-inline-block text-truncate"},[_vm._v("\n            "+_vm._s(layer.get('name'))+"\n          ")])])],1)]}}],null,true)})}),1):_c('v-alert',{staticClass:"mb-0",attrs:{"type":"info"}},[_vm._v(" \n    "+_vm._s(_vm.emptyText)+"\n  ")])],1)}
var staticRenderFns = []


/***/ }),

/***/ "LaCf":
/***/ (function(module, exports) {

module.exports = {"app":{"title":"SAUBER Messstationen","browserTitle":"SAUBER","footerTextLeft":"Powered by <a href='https://meggsimum.de/wegue/' target='_blank'>Wegue WebGIS</a>","footerTextRight":"meggsimum","logo":"App Logo"},"mapLayers":{},"wgu-helpwin":{"title":"Info","textTitle":"Messstationen","htmlContent":"Mit dieser Anwendung können die Messstationen aus dem SAUBER Projekt erkundet werden. <br><br> Jede Station ist mit den Symbolen der jeweils gemessenen Schadstoffe umringt. Ein Klick auf den Schadstoff öffnet ein Fenster mit Informationen. Dazu gehören ein Foto, allgemeine Metadaten und ein Vorschau-Diagram der aktuellen Messwerte falls diese verfügbar sind. <br><br> Der Button öffnet die offizielle Internetseite der jeweiligen Messstation.","infoLinkText":"SAUBER Projekt","infoLinkUrl":"https://sauber-projekt.de/"}}

/***/ }),

/***/ "MPh8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DraggableWin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");

/**
 * Directive to make a window component draggable by dragging it's header.
 * Proudly inspired by and most of the essential code taken from
 * https://github.com/branu-ws/v-drag/blob/master/src/index.js
 */

var DraggableWin = {
  dragConfig: {
    // if this is present, only a specific area of the draggable will respond to
    // dragging (e. g. header bar).
    draggableElementSelector: null,
    down: false,
    height: 0,
    width: 0,
    initialX: 0,
    initialY: 0,
    constraintToWindow: true,
    cursorPreviousX: 0,
    cursorPreviousY: 0,
    draggerOffsetLeft: 0,
    draggerOffsetTop: 0,
    overlay: null,
    draggableEl: null,
    initialZIndex: undefined
  },
  bind: function bind(elmnt, binding, vnode) {
    if (binding.value === false) {
      // disable this directive if set to v-draggable-win="false"
      return;
    } // get the header element to bind the events on it


    var header = elmnt.querySelector('div.wgu-win-title');

    if (!header) {
      return;
    }

    var dragConfig = DraggableWin.dragConfig; // restrict the dragging at least to window title

    dragConfig.draggableElementSelector = binding.arg || 'wgu-win-title'; // set cursor so it's signal that the user can drag the window

    header.style.cursor = 'move';
    elmnt.addEventListener('mouseup', function (e) {
      return DraggableWin.mouseup(e, elmnt, dragConfig);
    });
    elmnt.addEventListener('mousedown', function (e) {
      return DraggableWin.mousedown(e, elmnt, dragConfig);
    });
    elmnt.addEventListener('mousemove', function (e) {
      return DraggableWin.mousemove(e, elmnt, dragConfig);
    });
    setDraggerOffset(elmnt, dragConfig);
    dragConfig.initialZIndex = elmnt.style.zIndex;
    /**
     * Creates an overlay in order to bind the mouse events to it.
     * @private
     */

    function createOverlay(e, el, _data) {
      var overlay = document.createElement('div');
      overlay.setAttribute('style', "\n        width: 100vw;\n        height: 100vh;\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 10000;\n      ");
      overlay.addEventListener('mouseup', function (e) {
        return mouseup(e, el, _data);
      });
      overlay.addEventListener('mousedown', function (e) {
        return mousedown(e, el, _data);
      });
      overlay.addEventListener('mousemove', function (e) {
        return mousemove(e, el, _data);
      });
      document.body.appendChild(overlay);
      return overlay;
    }
    /**
     * Checks if the given selector (id or class) occurs in the given path
     */


    function checkIfSelectorInPath(selector, path) {
      if (!path) {
        return false;
      }

      for (var i = 0; i < path.length; i++) {
        // check for ID
        if (path[i].id === selector) {
          return true;
        } // also check for a class name


        if (path[i].classList && path[i].classList.contains(selector)) {
          return true;
        }
      }

      return false;
    }
    /**
     * Adjusts element's z-index.
     */


    function adjustElementZIndex(el, index) {
      el.style.zIndex = index;
    }
    /**
     * Event handler for mouse down.
     */


    function mousedown(e, el, _data) {
      // if the user set a argument to v-drag,
      // it means they only want a specific area to be draggable
      // eg: `v-drag:drag-header` means only the element with
      // id="drag-header" or class="drag-header" should be draggable.
      // If the user clicked another area, do nothing.
      // By default it is restricted to class="wgu-win-title"
      if (_data.draggableElementSelector && !checkIfSelectorInPath(_data.draggableElementSelector, e.path)) {
        return;
      }

      if (_data.overlay) {
        _data.overlay.remove();
      } // set the width each click
      // just in case it changed since last time (by external plugin, for example)


      _data.width = el.offsetWidth;
      _data.height = el.offsetHeight;
      _data.down = true;
      _data.initialX = e.clientX;
      _data.initialY = e.clientY;
      var overlay = createOverlay(e, el, _data);
      _data.overlay = overlay;
      adjustElementZIndex(el, 10001);
    }

    DraggableWin.mousedown = mousedown;
    /**
     * Event handler for mouse up.
     */

    function mouseup(e, el, _data) {
      _data.down = false;

      if (!_data.overlay) {
        return;
      }

      _data.overlay.removeEventListener('mouseup', mouseup);

      _data.overlay.removeEventListener('mousedown', mousedown);

      _data.overlay.removeEventListener('mousemove', mousemove);

      _data.overlay.remove();

      adjustElementZIndex(el, _data.initialZIndex);
      setDraggerOffset(el, _data); // preserve the current position as property of the vue / Wegue window
      // so it can be restored when the window is re-opened

      vnode.componentInstance.$parent.top = _data.draggerOffsetTop + 'px';
      vnode.componentInstance.$parent.left = _data.draggerOffsetLeft + 'px';
    }

    DraggableWin.mouseup = mouseup;
    /**
     * Checks if left window boundary is reached.
     */

    function reachedLeft(el, _data, movingLeft) {
      return el.offsetLeft + _data.width >= window.innerWidth && !movingLeft;
    }
    /**
     * Checks if right window boundary is reached.
     */


    function reachedRight(el, _data, movingRight) {
      return el.offsetLeft <= 0 && !movingRight;
    }
    /**
     * Checks if top window boundary is reached.
     */


    function reachedTop(el, _data, movingUp) {
      return el.offsetTop <= 0 && !movingUp;
    }
    /**
     * Checks if bottom window boundary is reached.
     */


    function reachedBottom(el, _data, movingDown) {
      return el.offsetTop + _data.height >= window.innerHeight && !movingDown;
    }
    /**
     * Event handler for mouse move.
     */


    function mousemove(e, el, _data) {
      if (_data.down) {
        var movingLeft = _data.cursorPreviousX > e.clientX;
        var movingRight = _data.cursorPreviousX < e.clientX;
        var movingUp = _data.cursorPreviousY < e.clientY;
        var movingDown = _data.cursorPreviousY > e.clientY;

        if (_data.constraintToWindow && (reachedLeft(el, _data, movingLeft) || reachedRight(el, _data, movingRight))) {// do now allow moving outside the window horizontally
        } else {
          el.style.left = _data.draggerOffsetLeft + (e.clientX - _data.initialX) + 'px';
        }

        if (_data.constraintToWindow && (reachedTop(el, _data, movingUp) || reachedBottom(el, _data, movingDown))) {// do now allow moving outside the window vertically
        } else {
          el.style.top = _data.draggerOffsetTop + (e.clientY - _data.initialY) + 'px';
        }
      }

      _data.cursorPreviousX = e.clientX;
      _data.cursorPreviousY = e.clientY;
    }

    DraggableWin.mousemove = mousemove;
    /**
     * Applies the offset values of the element.
     */

    function setDraggerOffset(el, _data) {
      _data.draggerOffsetLeft = el.offsetLeft;
      _data.draggerOffsetTop = el.offsetTop;
    }
  }
}; // Make directive available globally

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('draggable-win', DraggableWin);

/***/ }),

/***/ "MV43":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributeTableWin_vue__ = __webpack_require__("36PU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0637ec11_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeTableWin_vue__ = __webpack_require__("u0sK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("6f8f")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0637ec11"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributeTableWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0637ec11_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeTableWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0637ec11_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeTableWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N/gh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_array_map_js__ = __webpack_require__("/TzG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_proj__ = __webpack_require__("yGLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_geom_Point__ = __webpack_require__("T18w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_Feature__ = __webpack_require__("nq2H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_layer__ = __webpack_require__("ItK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_source__ = __webpack_require__("8cSO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_style__ = __webpack_require__("beD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WguEventBus__ = __webpack_require__("ZkkH");




//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-geolocator',
  props: {
    zoomAnimation: {
      type: Boolean,
      required: false,
      default: true
    },
    zoomAnimationDuration: {
      type: Number,
      required: false,
      default: 2400
    },
    maxZoom: {
      type: Number,
      required: false,
      default: 15
    },
    markerColor: {
      type: String,
      required: false,
      default: 'blue'
    },
    markerText: {
      type: String,
      required: false,
      default: 'person_pin_circle'
    }
  },
  data: function data() {
    return {
      isGeolocationAPIAvailable: null,
      isGeolocationFound: false,
      isSearchingForGeolocation: false,
      geolocationMarker: new __WEBPACK_IMPORTED_MODULE_9_ol_style__["b" /* Style */]({
        text: new __WEBPACK_IMPORTED_MODULE_9_ol_style__["d" /* Text */]({
          text: this.markerText,
          font: 'normal 30px Material Icons',
          fill: new __WEBPACK_IMPORTED_MODULE_9_ol_style__["f" /* Fill */]({
            color: this.markerColor
          })
        })
      })
    };
  },
  created: function created() {
    var me = this;
    __WEBPACK_IMPORTED_MODULE_10__WguEventBus__["a" /* WguEventBus */].$on('ol-map-mounted', function (olMap) {
      me.map = olMap;
    });

    if (!navigator.geolocation) {
      me.isGeolocationAPIAvailable = false;
    } else {
      me.isGeolocationAPIAvailable = true;
    }
  },
  methods: {
    /**
     *
     */
    createAndRemoveExistingLayer: function createAndRemoveExistingLayer(layers, layerId) {
      var _context;

      // if the geolocationLayer is already included it has to be removed
      layers.remove(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context = layers.getArray()).call(_context, function (layer) {
        return layerId === layer.get('lid');
      })[0]); // create new layer

      var layer = new __WEBPACK_IMPORTED_MODULE_7_ol_layer__["a" /* Vector */]({
        source: new __WEBPACK_IMPORTED_MODULE_8_ol_source__["c" /* Vector */](),
        style: this.geolocationMarker
      });
      layer.setProperties({
        lid: layerId
      });
      return layer;
    },

    /**
     *
     */
    geolocateUserAndShowMarkerOnMap: function geolocateUserAndShowMarkerOnMap() {
      var _this = this;

      if (this.isGeolocationAPIAvailable) {
        this.isSearchingForGeolocation = true; // access current geolocation position and show on map

        navigator.geolocation.getCurrentPosition(function (position) {
          if (typeof __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this) !== 'undefined') {
            // create location point and reproject to map's projection
            var mapProjection = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this).getView().getProjection();

            var projCoords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ol_proj__["m" /* fromLonLat */])([position.coords.longitude, position.coords.latitude], mapProjection);
            var currentPosGeom = new __WEBPACK_IMPORTED_MODULE_5_ol_geom_Point__["a" /* default */](projCoords);
            _this.isGeolocationFound = true;
            _this.isSearchingForGeolocation = false; // get a layer to draw the current position on

            var geolocLayer = _this.createAndRemoveExistingLayer(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this).getLayers(), 'wgu-geolocator-layer');

            geolocLayer.getSource().addFeature(new __WEBPACK_IMPORTED_MODULE_6_ol_Feature__["a" /* default */]({
              geometry: currentPosGeom
            }));

            __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this).addLayer(geolocLayer); // collect zooming options


            var zoomOpts = {
              maxZoom: _this.maxZoom,
              padding: [50, 50, 50, 50]
            };

            if (_this.zoomAnimation) {
              zoomOpts.duration = _this.zoomAnimationDuration;
            } // zoom to geolocation position


            __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this).getView().fit(currentPosGeom, zoomOpts);
          } else {
            console.error('The map is not defined in the getCurrentPosition callback');
          }
        }, // error handling for geolocation
        function (error) {
          // log the error without displaying it, simply allows debugging
          console.error('Geolocation error : code ' + error.code + ' - ' + error.message); // display user friendly error message

          alert('Geolocation error : code ' + error.code + ' - ' + error.message);
          _this.isGeolocationAPIAvailable = false;
          _this.isSearchingForGeolocation = false;
        }, {
          enableHighAccuracy: true,
          maximumAge: 60000,
          timeout: 27000
        });
      } else {
        this.isGeolocationAPIAvailable = false;
      }
    }
  }
});

/***/ }),

/***/ "ND6S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('v-progress-circular',{staticClass:"wgu-maploading-status",attrs:{"value":80,"indeterminate":"","color":_vm.color}}):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find__ = __webpack_require__("2x6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_slice__ = __webpack_require__("J849");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_array_from__ = __webpack_require__("XK4L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_symbol__ = __webpack_require__("X78b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_get_iterator_method__ = __webpack_require__("8Qmx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_get_iterator_method___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_get_iterator_method__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_get_iterator__ = __webpack_require__("uiEL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_portal_vue__ = __webpack_require__("TX8X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_portal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_portal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mdi_font_css_materialdesignicons_css__ = __webpack_require__("csSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mdi_font_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__mdi_font_css_materialdesignicons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_icons_iconfont_material_icons_css__ = __webpack_require__("aqYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_material_icons_iconfont_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_material_icons_iconfont_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__node_modules_ol_ol_css__ = __webpack_require__("ktr9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__node_modules_ol_ol_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__node_modules_ol_ol_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__app_WguApp__ = __webpack_require__("y+0P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_Url__ = __webpack_require__("v9hS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_Locale__ = __webpack_require__("e/Tm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_Object__ = __webpack_require__("XSiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuetify_dist_vuetify_min_css__);
function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_symbol___default.a === "undefined" || __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_get_iterator_method___default()(o) == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_get_iterator___default()(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { var _context2; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_slice___default()(_context2 = Object.prototype.toString.call(o)).call(_context2, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_array_from___default()(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }








// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_portal_vue___default.a);
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_i18n__["a" /* default */]);

__webpack_require__("SPmS"); // try to load an optional app specific CSS file (set project-specific styles)


try {
  __webpack_require__("Op2c");
} catch (e) {}

__WEBPACK_IMPORTED_MODULE_7_vue__["default"].config.productionTip = false; // Detect isEmbedded state by attribute embedded and
// make accessible for all components
// recommended by https://vuejs.org/v2/cookbook/adding-instance-properties.html

var appEl = document.querySelector('#app');
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$isEmbedded = appEl.hasAttribute('embedded'); // Detect an URL parameter for a custom app context

var appCtx = __WEBPACK_IMPORTED_MODULE_15__util_Url__["a" /* default */].getQueryParam('appCtx');
var appCtxFile = '';

if (appCtx) {
  // simple aproach to avoid path traversal
  appCtxFile = '-' + appCtx.replace(/(\.\.[/])+/g, '');
}
/**
 * Creates the active vuetify instance.
 *
 * @param {Object} appConfig Global application context.
 * @returns The active vuetify instance.
 */


var createVuetify = function createVuetify(appConfig) {
  var preset = {
    icons: {
      iconfont: 'mdiSvg'
    },
    lang: {
      current: __WEBPACK_IMPORTED_MODULE_16__util_Locale__["a" /* default */].getPreferredLanguage(appConfig),
      locales: __WEBPACK_IMPORTED_MODULE_16__util_Locale__["a" /* default */].importVuetifyLocales()
    }
  };
  return new __WEBPACK_IMPORTED_MODULE_8_vuetify___default.a(preset);
};
/**
 * Creates the VueI18n object used for internationalization.
 *
 * @param {Object} appConfig Global application context.
 * @returns The active I18n instance.
 */


var createVueI18n = function createVueI18n(appConfig) {
  var preset = {
    locale: __WEBPACK_IMPORTED_MODULE_16__util_Locale__["a" /* default */].getPreferredLanguage(appConfig),
    fallbackLocale: __WEBPACK_IMPORTED_MODULE_16__util_Locale__["a" /* default */].getFallbackLanguage(appConfig),
    messages: __WEBPACK_IMPORTED_MODULE_16__util_Locale__["a" /* default */].importVueI18nLocales()
  };
  return new __WEBPACK_IMPORTED_MODULE_10_vue_i18n__["a" /* default */](preset);
};
/**
 * Backwards compatibility layer for legacy features in app-conf.json.
 *
 * @param {Object} appConfig Global application context.
 * @returns The migrated application context.
 */


var migrateAppConfig = function migrateAppConfig(appConfig) {
  // Migrate boolean values for module.win.
  if (appConfig.modules) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default()(appConfig.modules).forEach(function (name) {
      var module = appConfig.modules[name];

      if (typeof module.win === 'boolean') {
        module.win = module.win ? 'floating' : undefined;
      }
    });
  } // Create warnings for text based configuration properties,
  // which are no longer supported and have been moved to the language files.

  /* eslint-disable no-useless-escape */


  var deprecatedTextProps = {
    'title': 'app.title',
    'browserTitle': 'app.browserTitle',
    'footerTextLeft': 'app.footerTextLeft',
    'footerTextRight': 'app.footerTextRight',
    'mapGeodataDragDop\\.layerName': 'mapLayers.wgu-drag-drop-layer.name',
    'modules.\\.wgu-attributetable\\.selectorLabel': 'wgu-attributetable.selectorLabel',
    'modules\\.wgu-geocoder\\.placeHolder': 'wgu-geocoder.placeHolder',
    'modules\\.wgu-infoclick\\.mediaInfoLinkText': 'wgu-infoclick.mediaInfoLinkText',
    'modules\\.wgu-zoomtomaxextent\\.text': 'wgu-zoomtomaxextent.text',
    'modules\\.wgu-helpwin\\.windowTitle': 'wgu-helpwin.title',
    'modules\\.wgu-helpwin\\.textTitle': 'wgu-helpwin.textTitle',
    'modules\\.wgu-helpwin\\.htmlContent': 'wgu-helpwin.htmlContent',
    'modules\\.wgu-helpwin\\.infoLinkUrl': 'wgu-helpwin.infoLinkUrl',
    'modules\\.wgu-helpwin\\.infoLinkText': 'wgu-helpwin.infoLinkText',
    'modules\\..*\\.title': '<moduleName>.title'
  };
  /* eslint-enable no-useless-escape */

  var configPaths = __WEBPACK_IMPORTED_MODULE_17__util_Object__["a" /* default */].toPaths(appConfig);

  var _iterator = _createForOfIteratorHelper(configPaths),
      _step;

  try {
    var _loop = function _loop() {
      var _context;

      var path = _step.value;

      var match = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_find___default()(_context = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default()(deprecatedTextProps)).call(_context, function (pattern) {
        var regex = new RegExp('^\\.' + pattern + '$', 'g');
        return regex.test(path);
      });

      if (match) {
        console.warn('The configuration path "' + path + '" is deprecated, ' + 'instead declare a path "' + deprecatedTextProps[match] + '" in all language files in your "/app/locales" folder');
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  ; // Create a warning if the 'lid' property of mapLayers is missing.

  if (appConfig.mapLayers) {
    appConfig.mapLayers.forEach(function (layer, i) {
      if (!layer.lid) {
        console.warn('mapLayers[' + i + '] does not declare a lid property');
      }
    });
  }

  return appConfig;
};
/**
 * Create the vue application.
 *
 * @param {Object} appConfig Global application context.
 */


var createApp = function createApp(appConfig) {
  // make app config accessible for all components
  __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$appConfig = migrateAppConfig(appConfig);
  /* eslint-disable no-new */

  new __WEBPACK_IMPORTED_MODULE_7_vue__["default"]({
    vuetify: createVuetify(appConfig),
    i18n: createVueI18n(appConfig),
    el: '#app',
    template: '<wgu-app/>',
    components: {
      WguApp: __WEBPACK_IMPORTED_MODULE_14__app_WguApp__["a" /* default */]
    }
  });
}; // Look in the static dir for an app-specific config file.


var configFile = 'static/app-conf' + appCtxFile + '.json';
fetch(configFile).then(function (response) {
  return response.json().then(function (appConfig) {
    createApp(appConfig);
  });
}).catch(function () {
  console.error('Cannot load config file: ' + configFile);
});

/***/ }),

/***/ "Nkpt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es_array_map_js__ = __webpack_require__("/TzG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modulecore_ModuleCard__ = __webpack_require__("6OvL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WguEventBus_js__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropertyTable__ = __webpack_require__("ZY9t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CoordsTable__ = __webpack_require__("R3+W");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-infoclick-win',
  inheritAttrs: false,
  components: {
    'wgu-module-card': __WEBPACK_IMPORTED_MODULE_2__modulecore_ModuleCard__["a" /* default */],
    'wgu-property-table': __WEBPACK_IMPORTED_MODULE_4__PropertyTable__["a" /* default */],
    'wgu-coords-table': __WEBPACK_IMPORTED_MODULE_5__CoordsTable__["a" /* default */]
  },
  props: {
    color: {
      type: String,
      required: false,
      default: 'red darken-3'
    },
    icon: {
      type: String,
      required: false,
      default: 'info'
    },
    showMedia: {
      type: Boolean,
      required: false,
      default: false
    },
    // below props only have an effect if showMedia=true
    mediaInfoLinkUrlProp: {
      type: String,
      required: false
    },
    imageProp: {
      type: String,
      required: false
    },
    imageDescriptionProp: {
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      moduleName: 'wgu-infoclick',
      attributeData: null,
      coordsData: null
    };
  },
  created: function created() {
    var me = this; // Listen to the ol-map-mounted event and receive the OL map instance

    __WEBPACK_IMPORTED_MODULE_3__WguEventBus_js__["a" /* WguEventBus */].$on('ol-map-mounted', function (olMap) {
      // make the OL map accessible in this component
      me.map = olMap;
    });
  },
  methods: {
    registerMapClick: function registerMapClick(unregister) {
      var me = this;

      if (unregister === true) {
        __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).un('singleclick', me.onMapClick);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).on('singleclick', me.onMapClick);
      }
    },

    /**
     * Handler for 'singleclick' on the map.
     * Collects data and passes it to corresponding objects.
     *
     * @param  {ol/MapBrowserEvent} evt The OL event of 'singleclick' on the map
     */
    onMapClick: function onMapClick(evt) {
      var me = this;

      var featureLayer = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
        return [feature, layer];
      }); // collect feature attributes --> PropertyTable


      if (featureLayer) {
        var feat = featureLayer[0];
        var props = feat.getProperties(); // do not show geometry property

        delete props.geometry;
        me.attributeData = props;
      } else {
        me.attributeData = null;
      } // collect click coordinate + projection --> CoordsTable


      me.coordsData = {
        coordinate: evt.coordinate,
        projection: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).getView().getProjection().getCode()
      };
    },

    /**
     * (Un-)Register map interactions when the visibility of the module changes.
     *
     * @param  {boolean} visible New visibility state
    */
    show: function show(visible) {
      var me = this;

      if (visible) {
        me.registerMapClick();
      } else {
        // cleanup old data
        me.attributeData = null;
        me.coordsData = null;
      }
    }
  }
});

/***/ }),

/***/ "NuBg":
/***/ (function(module, exports) {

module.exports = {"app":{"title":"Vue.js / OpenLayers WebGIS","browserTitle":"Wegue Demo App","footerTextLeft":"Powered by <a href='https://meggsimum.de/wegue/' target='_blank'>Wegue WebGIS</a>","footerTextRight":"meggsimum","logo":"App Logo"},"mapLayers":{"wgu-geolocator-layer":{"name":"Current Position"},"wgu-measure-layer":{"name":"Measure Layer"},"wgu-drag-drop-layer":{"name":"Drag/Drop Data"}},"wgu-toolbar-menu":{"title":"Open toolbar menu"},"wgu-attributetable":{"title":"Attribute Table","selectorLabel":"Choose a layer","loadingText":"Loading... Please move to an area where the layer is visible"},"wgu-bglayerswitcher":{"title":"Change background map","emptyText":"No background layers available."},"wgu-geocoder":{"title":"Address Search","placeHolder":"Search for an address"},"wgu-geolocator":{"title":"Geolocation"},"wgu-helpwin":{"title":"About","textTitle":"About Wegue","htmlContent":"<b>WebGIS with OpenLayers and Vue.js</b> Template and re-usable components for webmapping applications with OpenLayers and Vue.js","infoLinkUrl":"http://wegue.org/","infoLinkText":"More info"},"wgu-infoclick":{"title":"Map Click Info","mapClick":"Click on the map to get information for the clicked map position.","mediaClick":"Click on a feature on the map to show connected media information.","mediaInfoLinkText":null},"wgu-layerlist":{"title":"Layers"},"wgu-maprecorder":{"title":"Map recorder","options":"Options","videoFormat":"Video format","frameRate":"Frame rate (frames/s)","bitRate":"Bit rate (MBits/s)","fileName":"Filename","error":"Failed to start recording."},"wgu-zoomtomaxextent":{"title":"Reset Map Extent"},"wgu-measuretool":{"title":"Measure","distance":"Distance","length":"Length","area":"Area","lengthKm":"{0} km","lengthMeter":"{0} m","areaSquareKm":"{0} km²","areaSquareMeter":"{0} m²"},"wgu-localeswitcher":{"title":"Language Settings"}}

/***/ }),

/***/ "O1k0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-btn',{attrs:{"icon":"","dark":"","title":_vm.$t('wgu-geolocator.title')},on:{"click":_vm.geolocateUserAndShowMarkerOnMap}},[(this.isSearchingForGeolocation)?_c('v-icon',[_vm._v("update")]):(this.isGeolocationAPIAvailable && (!this.isGeolocationFound))?_c('v-icon',[_vm._v("location_searching")]):(this.isGeolocationAPIAvailable && this.isGeolocationFound)?_c('v-icon',[_vm._v("gps_fixed")]):_c('v-icon',[_vm._v("location_disabled")])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "OUzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayerFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_number_is_integer__ = __webpack_require__("MO7B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_starts_with__ = __webpack_require__("4gXO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_layer_Tile__ = __webpack_require__("Mdwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_source_TileWMS__ = __webpack_require__("DwLH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_source_OSM__ = __webpack_require__("WiOa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_layer_VectorTile__ = __webpack_require__("fZPI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_source_VectorTile__ = __webpack_require__("hGhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_format_MVT__ = __webpack_require__("fGhu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_format_GeoJSON__ = __webpack_require__("aUhy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_format_TopoJSON__ = __webpack_require__("UjZP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ol_format_KML__ = __webpack_require__("srNp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ol_format_GML2__ = __webpack_require__("aodK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ol_format_GML3__ = __webpack_require__("X0BE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ol_format_GML32__ = __webpack_require__("z8pl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ol_layer_Vector__ = __webpack_require__("Umvz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ol_source_Vector__ = __webpack_require__("WMwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_ol_source_XYZ__ = __webpack_require__("irp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_ol_loadingstrategy__ = __webpack_require__("f2+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__OlStyle__ = __webpack_require__("fT5P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_ol_extent__ = __webpack_require__("/LWt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_ol_proj__ = __webpack_require__("yGLh");





















/**
 * Factory, which creates OpenLayers layer instances according to a given config
 * object.
 */

var LayerFactory = {
  /**
   * Maps the format literal of the config to the corresponding OL module.
   * @type {Object}
   */
  formatMapping: {
    'MVT': __WEBPACK_IMPORTED_MODULE_7_ol_format_MVT__["a" /* default */],
    'GeoJSON': __WEBPACK_IMPORTED_MODULE_8_ol_format_GeoJSON__["a" /* default */],
    'TopoJSON': __WEBPACK_IMPORTED_MODULE_9_ol_format_TopoJSON__["a" /* default */],
    'KML': __WEBPACK_IMPORTED_MODULE_10_ol_format_KML__["a" /* default */],
    'GML2': __WEBPACK_IMPORTED_MODULE_11_ol_format_GML2__["a" /* default */],
    'GML3': __WEBPACK_IMPORTED_MODULE_12_ol_format_GML3__["a" /* default */],
    'GML32': __WEBPACK_IMPORTED_MODULE_13_ol_format_GML32__["a" /* default */]
  },

  /**
   * Maps the format literal of the config to the corresponding WFS outputFormat.
   * @type {Object}
   */
  wfsFormatMapping: {
    'GeoJSON': 'application/json',
    'GML2': 'text/xml; subtype=gml/2.1.2',
    'GML3': 'text/xml; subtype=gml/3.1.1',
    'GML32': 'text/xml; subtype=gml/3.2'
  },

  /**
   * Returns an OpenLayers layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @param  {ol/Map} olMap  Optional OL map we work on
   * @return {ol/layer/Base} OL layer instance
   */
  getInstance: function getInstance(lConf, olMap) {
    // create correct layer type
    if (lConf.type === 'WMS') {
      return this.createWmsLayer(lConf);
    } else if (lConf.type === 'WFS') {
      return this.createWfsLayer(lConf, olMap);
    } else if (lConf.type === 'XYZ') {
      return this.createXyzLayer(lConf);
    } else if (lConf.type === 'OSM') {
      return this.createOsmLayer(lConf);
    } else if (lConf.type === 'VECTOR') {
      return this.createVectorLayer(lConf);
    } else if (lConf.type === 'VECTORTILE') {
      return this.createVectorTileLayer(lConf);
    } else {
      return null;
    }
  },

  /**
   * Returns an OpenLayers WMS layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Tile} OL WMS layer instance
   */
  createWmsLayer: function createWmsLayer(lConf) {
    var layer = new __WEBPACK_IMPORTED_MODULE_2_ol_layer_Tile__["a" /* default */]({
      lid: lConf.lid,
      isBaseLayer: lConf.isBaseLayer,
      previewImage: lConf.previewImage,
      displayInLayerList: lConf.displayInLayerList,
      extent: lConf.extent,
      visible: lConf.visible,
      opacity: lConf.opacity,
      confName: lConf.name,
      confAttributions: lConf.attributions,
      source: new __WEBPACK_IMPORTED_MODULE_3_ol_source_TileWMS__["a" /* default */]({
        url: lConf.url,
        params: {
          'LAYERS': lConf.layers,
          'TILED': lConf.tiled
        },
        serverType: lConf.serverType,
        tileGrid: lConf.tileGrid,
        projection: lConf.projection,
        crossOrigin: lConf.crossOrigin
      })
    });
    return layer;
  },

  /**
   * Returns an OpenLayers WFS layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @param  {ol/Map} olMap  The OpenLayers map we work on
   * @return {ol.layer.Tile} OL WFS layer instance
   */
  createWfsLayer: function createWfsLayer(lConf, olMap) {
    var mapSrs = olMap.getView().getProjection().getCode(); // set a default projection if not set in config

    if (!lConf.projection) {
      lConf.projection = mapSrs;
    } // set a default WFS version if not set in config


    if (!lConf.version) {
      lConf.version = '1.1.0';
    }

    if (!lConf.format) {
      lConf.format = 'GML3';
    } // detect the WFS output format


    var outputFormat = this.wfsFormatMapping[lConf.format]; // overwrite format options, so they fit to the SRS (map vs. data)

    if (mapSrs !== lConf.projection) {
      lConf.formatConfig.dataProjection = lConf.projection;
      lConf.formatConfig.featureProjection = mapSrs;
    }

    var vectorSource = new __WEBPACK_IMPORTED_MODULE_15_ol_source_Vector__["a" /* default */]({
      format: new this.formatMapping[lConf.format](lConf.formatConfig),
      loader: function loader(extent) {
        // assemble WFS GetFeature request
        var wfsRequest = lConf.url + '?service=WFS&' + 'version=' + lConf.version + '&request=GetFeature&' + 'typename=' + lConf.typeName + '&' + 'outputFormat=' + outputFormat + '&srsname=' + lConf.projection; // add WFS version dependent feature limitation

        if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_number_is_integer___default()(parseInt(lConf.maxFeatures))) {
          var _context;

          if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_starts_with___default()(_context = lConf.version).call(_context, '1.')) {
            wfsRequest += '&maxFeatures=' + lConf.maxFeatures;
          } else {
            wfsRequest += '&count=' + lConf.maxFeatures;
          }
        } // add bbox filter


        if (lConf.loadOnlyVisible !== false) {
          if (mapSrs !== lConf.projection) {
            extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_ol_extent__["i" /* applyTransform */])(extent, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_ol_proj__["b" /* getTransform */])(mapSrs, lConf.projection));
          }

          wfsRequest += '&bbox=' + extent.join(',') + ',' + lConf.projection + '';
        } // load data from WFS, parse and add to vector source


        fetch(wfsRequest).then(function (response) {
          return response.text();
        }).then(function (responseText) {
          var feats = vectorSource.getFormat().readFeatures(responseText);
          vectorSource.addFeatures(feats);
        });
      },
      strategy: lConf.loadOnlyVisible !== false ? __WEBPACK_IMPORTED_MODULE_17_ol_loadingstrategy__["b" /* bbox */] : undefined
    });
    var vector = new __WEBPACK_IMPORTED_MODULE_14_ol_layer_Vector__["a" /* default */]({
      lid: lConf.lid,
      isBaseLayer: lConf.isBaseLayer,
      previewImage: lConf.previewImage,
      displayInLayerList: lConf.displayInLayerList,
      extent: lConf.extent,
      visible: lConf.visible,
      opacity: lConf.opacity,
      source: vectorSource,
      style: __WEBPACK_IMPORTED_MODULE_18__OlStyle__["a" /* OlStyleFactory */].getInstance(lConf.style),
      columnMapping: lConf.columnMapping,
      hoverable: lConf.hoverable,
      poiInfo: lConf.poiInfo,
      clusterRendering: lConf.clusterRendering,
      selectable: lConf.selectable,
      selectStyle: lConf.selectStyle,
      styleConf: lConf.style,
      doAppendSelectStyle: lConf.doAppendSelectStyle,
      hoverAttribute: lConf.hoverAttribute,
      confName: lConf.name,
      confAttributions: lConf.attributions
    });
    return vector;
  },

  /**
   * Returns an XYZ based tile layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Tile} OL XYZ layer instance
   */
  createXyzLayer: function createXyzLayer(lConf) {
    var xyzLayer = new __WEBPACK_IMPORTED_MODULE_2_ol_layer_Tile__["a" /* default */]({
      lid: lConf.lid,
      isBaseLayer: lConf.isBaseLayer,
      previewImage: lConf.previewImage,
      displayInLayerList: lConf.displayInLayerList,
      visible: lConf.visible,
      opacity: lConf.opacity,
      confName: lConf.name,
      confAttributions: lConf.attributions,
      source: new __WEBPACK_IMPORTED_MODULE_16_ol_source_XYZ__["a" /* default */]({
        url: lConf.url,
        tileGrid: lConf.tileGrid,
        projection: lConf.projection,
        crossOrigin: lConf.crossOrigin
      })
    });
    return xyzLayer;
  },

  /**
   * Returns an OpenLayers OSM layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Tile} OL OSM layer instance
   */
  createOsmLayer: function createOsmLayer(lConf) {
    var layer = new __WEBPACK_IMPORTED_MODULE_2_ol_layer_Tile__["a" /* default */]({
      lid: lConf.lid,
      isBaseLayer: lConf.isBaseLayer,
      previewImage: lConf.previewImage,
      displayInLayerList: lConf.displayInLayerList,
      visible: lConf.visible,
      opacity: lConf.opacity,
      confName: lConf.name,
      confAttributions: lConf.attributions,
      source: new __WEBPACK_IMPORTED_MODULE_4_ol_source_OSM__["b" /* default */]({
        crossOrigin: lConf.crossOrigin
      })
    });
    return layer;
  },

  /**
   * Returns an OpenLayers vector layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Vector} OL vector layer instance
   */
  createVectorLayer: function createVectorLayer(lConf) {
    var vectorLayer = new __WEBPACK_IMPORTED_MODULE_14_ol_layer_Vector__["a" /* default */]({
      lid: lConf.lid,
      isBaseLayer: lConf.isBaseLayer,
      previewImage: lConf.previewImage,
      displayInLayerList: lConf.displayInLayerList,
      extent: lConf.extent,
      visible: lConf.visible,
      opacity: lConf.opacity,
      source: new __WEBPACK_IMPORTED_MODULE_15_ol_source_Vector__["a" /* default */]({
        url: lConf.url,
        format: new this.formatMapping[lConf.format](lConf.formatConfig)
      }),
      style: __WEBPACK_IMPORTED_MODULE_18__OlStyle__["a" /* OlStyleFactory */].getInstance(lConf.style),
      styleConf: lConf.style,
      hoverable: lConf.hoverable,
      hoverAttribute: lConf.hoverAttribute,
      poiInfo: lConf.poiInfo,
      clusterRendering: lConf.clusterRendering,
      selectable: lConf.selectable,
      selectStyle: lConf.selectStyle,
      columnMapping: lConf.columnMapping,
      doAppendSelectStyle: lConf.doAppendSelectStyle,
      confName: lConf.name,
      confAttributions: lConf.attributions
    });
    return vectorLayer;
  },

  /**
   * Returns an OpenLayers vector tile layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.VectorTile} OL vector tile layer instance
   */
  createVectorTileLayer: function createVectorTileLayer(lConf) {
    var vtLayer = new __WEBPACK_IMPORTED_MODULE_5_ol_layer_VectorTile__["a" /* default */]({
      lid: lConf.lid,
      isBaseLayer: lConf.isBaseLayer,
      previewImage: lConf.previewImage,
      displayInLayerList: lConf.displayInLayerList,
      visible: lConf.visible,
      opacity: lConf.opacity,
      source: new __WEBPACK_IMPORTED_MODULE_6_ol_source_VectorTile__["a" /* default */]({
        url: lConf.url,
        format: new this.formatMapping[lConf.format](),
        tileGrid: lConf.tileGrid,
        projection: lConf.projection
      }),
      style: __WEBPACK_IMPORTED_MODULE_18__OlStyle__["a" /* OlStyleFactory */].getInstance(lConf.style),
      hoverable: lConf.hoverable,
      hoverAttribute: lConf.hoverAttribute,
      confName: lConf.name,
      confAttributions: lConf.attributions
    });
    return vtLayer;
  }
};

/***/ }),

/***/ "Op2c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P5f+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-logo',
  data: function data() {
    return {
      logoSrc: this.$appConfig.logo,
      logoSize: this.$appConfig.logoSize,
      logoWidth: this.$appConfig.logoWidth,
      logoHeight: this.$appConfig.logoHeight
    };
  },
  created: function created() {
    // for backwards compat we use logoSize if width and height are missing
    if (this.logoSize && !this.logoWidth && !this.logoHeight) {
      this.logoWidth = this.logoSize;
      this.logoHeight = this.logoSize;
    }
  }
});

/***/ }),

/***/ "PJIL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray__ = __webpack_require__("EmY/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find__ = __webpack_require__("2x6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_entries__ = __webpack_require__("FRTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_includes__ = __webpack_require__("wk9Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Layer__ = __webpack_require__("fIFi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_MapInteraction__ = __webpack_require__("wO5V");








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-attributetable',
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_Mapable__["a" /* Mapable */]],
  props: {
    /** The ID of the vector layer to display */
    layerId: {
      type: String,
      required: false,
      default: null
    },

    /** The name of the unique feature identifier */
    uniqueRecordKeyName: {
      type: String,
      required: false,
      default: 'fid'
    },

    /**
     * How many rows a page of the table should have.
     * Should be manually adjusted with tableHeight.
     */
    rowsPerPage: {
      type: Number,
      required: false,
      default: 10
    },

    /**
     * The height of the table in pixel.
     * Should be manually adjusted with rowsPerPage.
     */
    tableHeight: {
      type: Number,
      required: false,
      default: 272
    },

    /** If map and table should be synced */
    syncTableMapSelection: {
      type: Boolean,
      required: false,
      default: true
    },

    /** The maximum zoom level when clicking on a row */
    maxZoomOnFeature: {
      type: Number,
      required: false,
      default: 15
    },

    /** A list of column names that should not be displayed. */
    forbiddenColumnNames: {
      type: Array,
      required: false,
      default: function _default() {
        return ['geometry', 'the_geom'];
      }
    }
  },
  data: function data() {
    return {
      headers: [],
      records: [],
      features: [],
      selectedRow: [],
      layer: null,
      loading: true,
      page: 1
    };
  },
  created: function created() {
    this.populateTable();

    if (this.syncTableMapSelection) {
      this.activateSelectRowOnMapClick();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.layer && this.layer.getSource()) {
      // unregister event after table is closed
      this.layer.getSource().un('change', this.prepareTableDataAndColumns);
    }
  },
  watch: {
    layerId: function layerId() {
      this.populateTable();
    },
    features: function features() {
      var _context,
          _this = this;

      this.records = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context = this.features).call(_context, function (feature) {
        var record = feature.getProperties(); // set feature id

        record[_this.uniqueRecordKeyName] = feature.getId();
        return record;
      });
    },
    records: function records() {
      // set loading status depending if records are available
      if (this.records.length === 0) {
        this.loading = true;
      } else {
        this.loading = false;
        this.highlightInitialFeatureSelectionInTable();
      }
    }
  },
  methods: {
    /**
     * Highlight row when feature is already selected
     * before table is opened.
     */
    highlightInitialFeatureSelectionInTable: function highlightInitialFeatureSelectionInTable() {
      var correspondingInteraction = __WEBPACK_IMPORTED_MODULE_11__util_MapInteraction__["a" /* default */].getSelectInteraction(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this), this.layerId);

      if (!correspondingInteraction) {
        return;
      }

      var features = correspondingInteraction.getFeatures();

      if (!features || features.getLength() !== 1) {
        return;
      }

      var feature = features.getArray()[0];

      if (!feature) {
        return;
      }

      var fid = feature.getId();

      if (!fid) {
        return;
      }

      this.highlightRowFromSelectedFeature(fid);
    },

    /**
     * Set the table height depending on desktop
     * or mobile view.
     *
     * @returns {int} The height of the table.
     */
    getTableHeight: function getTableHeight() {
      if (this.$vuetify.breakpoint.xs) {
        // we do not want to set this property
        return undefined;
      } else {
        return this.tableHeight;
      }
    },

    /**
     * Activate behaviour that a selected feature on the
     * map will be selected in the AttributeTable as well.
     */
    activateSelectRowOnMapClick: function activateSelectRowOnMapClick() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_10__WguEventBus__["a" /* WguEventBus */].$on('map-selectionchange', function (lid, featureArray) {
        if (lid !== _this2.layerId || featureArray.length !== 1) {
          return;
        }

        var fid = featureArray[0].getId();

        _this2.highlightRowFromSelectedFeature(fid);
      });
    },

    /**
     * Highlight row matching the feature ID
     * and set correct page of the table.
     *
     * @param {Number} fid The ID of the selected feature.
     */
    highlightRowFromSelectedFeature: function highlightRowFromSelectedFeature(fid) {
      var _context2,
          _this3 = this;

      if (!fid) {
        return;
      }

      var foundRecord = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find___default()(_context2 = this.records).call(_context2, function (record) {
        return record.fid === fid;
      });

      if (!foundRecord) {
        return;
      }

      this.selectedRow = [foundRecord];
      var recIndex = this.records.indexOf(foundRecord);

      if (!recIndex) {
        return;
      }

      this.$nextTick(function () {
        // calculate page and set it
        _this3.page = Math.ceil((recIndex + 1) / _this3.rowsPerPage);
      });
    },

    /**
     * Handler for click on a row.
     *
     * It zooms to the clicked features.
     *
     * If the layer is 'selectable', the corresponding feature on the
     * map will be styled as selected.
     */
    onRowClick: function onRowClick(record) {
      var _context3;

      if (!this.syncTableMapSelection) {
        return;
      }

      var fid = record[this.uniqueRecordKeyName];

      if (!fid) {
        return;
      }

      this.selectedRow = [record];

      var foundFeature = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_find___default()(_context3 = this.features).call(_context3, function (feature) {
        return feature.getId() === fid;
      });

      if (!foundFeature) {
        return;
      } // zoom to feature


      __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView().fit(foundFeature.getGeometry(), {
        maxZoom: this.maxZoomOnFeature
      });

      var correspondingInteraction = __WEBPACK_IMPORTED_MODULE_11__util_MapInteraction__["a" /* default */].getSelectInteraction(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this), this.layerId); // we can only select layers that have a select interaction

      if (!correspondingInteraction) {
        return;
      } // add to map selection


      correspondingInteraction.getFeatures().clear();
      correspondingInteraction.getFeatures().push(foundFeature);
    },

    /**
     * Load features from layer and display it in
     * in the table.
     */
    populateTable: function populateTable() {
      if (!__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this) || !this.layerId) {
        return;
      } // reset table properties


      this.records = [];
      this.features = [];
      this.headers = [];
      this.selectedRow = [];
      this.page = 1;
      this.layer = __WEBPACK_IMPORTED_MODULE_9__util_Layer__["a" /* default */].getLayerByLid(this.layerId, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this)); // load currently available features

      this.prepareTableDataAndColumns(); // features can only be loaded if layer is visible
      // that's why we switch the layers on and retrieve them
      // once the features are available
      // https://github.com/openlayers/openlayers/blob/main/doc/faq.md#why-arent-there-any-features-in-my-source

      this.layer.getSource().on('change', this.prepareTableDataAndColumns);
      this.layer.setVisible(true);
    },

    /**
     * Loads the features from the layer source and
     * prepares the required columns for the table.
     */
    prepareTableDataAndColumns: function prepareTableDataAndColumns() {
      this.features = this.layer.getSource().getFeatures();
      this.applyColumnMapping();
    },

    /**
     * Read column mapping from layer property.
     * Otherwise we retrieve it from the feature
     * properties names.
     */
    applyColumnMapping: function applyColumnMapping() {
      var _this4 = this;

      if (!this.layer.getSource() || !this.layer.getSource().getFeatures() || !this.layer.getSource().getFeatures()[0]) {
        return;
      }

      var headers = [];

      if (this.layer.get('columnMapping')) {
        for (var _i = 0, _Object$entries = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_entries___default()(this.layer.get('columnMapping')); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray___default()(_Object$entries[_i], 2),
              propertyName = _Object$entries$_i[0],
              displayName = _Object$entries$_i[1];

          headers.push({
            text: displayName,
            value: propertyName
          });
        }
      } else {
        // TODO: taking the first feature assumes that all features
        //       have the same structure
        var keys = this.layer.getSource().getFeatures()[0].getKeys(); // remove keys that contain a geometry

        var filtered = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_filter___default()(keys).call(keys, function (key) {
          var _context4;

          return !__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_includes___default()(_context4 = _this4.forbiddenColumnNames).call(_context4, key);
        });

        filtered.forEach(function (propertyName) {
          headers.push({
            text: propertyName,
            value: propertyName
          });
        });
      }

      this.headers = headers;
    }
  }
});

/***/ }),

/***/ "QIMA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wgu-bglayerswitcher-wrapper"}},[_c('v-menu',{attrs:{"offset-x":"","nudge-right":"15","transition":"scale-transition","close-on-content-click":false,"attach":"#wgu-bglayerswitcher-wrapper"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-sheet',{staticClass:"wgu-bglayerswitcher"},[_c('v-btn',_vm._g({attrs:{"color":_vm.color,"dark":_vm.dark,"fab":"","title":_vm.$t('wgu-bglayerswitcher.title')}},on),[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))])],1)],1)]}}]),model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "),(_vm.show)?_c('wgu-bglayerlist',{attrs:{"color":"white","dark":false,"selColor":_vm.color,"selDark":_vm.dark,"previewIcon":_vm.icon,"imageWidth":_vm.imageWidth,"imageHeight":_vm.imageHeight,"emptyText":_vm.$t('wgu-bglayerswitcher.emptyText')}}):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "R3+W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoordsTable_vue__ = __webpack_require__("L1xf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77ae31db_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoordsTable_vue__ = __webpack_require__("G08c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Iw4/")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoordsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77ae31db_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoordsTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77ae31db_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoordsTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RAvm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_source___ = __webpack_require__("8cSO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_layer_Group__ = __webpack_require__("0uY1");


//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-maploading-status',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Mapable__["a" /* Mapable */]],
  props: {
    color: {
      type: String,
      default: 'red darken-3'
    }
  },
  data: function data() {
    return {
      loading: 0,
      visible: false
    };
  },
  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable)
     * and registers the current map layers.
     */
    onMapBound: function onMapBound() {
      var me = this;
      me.registerLayers(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).getLayerGroup());
    },

    /**
     * Registers the needed events for the passed layer and takes care
     * of layer groups by calling itself recursively.
     *
     * @param  {ol/layer/Base | ol/layer/Group} layer Layer or group to register
     */
    registerLayers: function registerLayers(layer) {
      var me = this;

      if (layer instanceof __WEBPACK_IMPORTED_MODULE_4_ol_layer_Group__["a" /* default */]) {
        // call ourself recursively
        var layers = layer.getLayers();
        layers.forEach(function (child) {
          me.registerLayers(child);
        }); // handle future changes to this group or stop doing so

        layers.on('add', me.onLayerAddedToGroup, me);
        layers.on('remove', me.onLayerRemovedFromGroup, me);
      } else {
        var source = layer.getSource();
        me.bindLoadHandlers(source, true); // reacting on a changed source in a layer

        layer.on('change:source', function (evt) {
          me.bindLoadHandlers(evt.target.getSource(), true);
          me.bindLoadHandlers(evt.oldValue, false);
        });
      }
    },

    /**
     * Registers needed events for the passed source and takes care
     * of sources which do not naturally support load events (`vector`-sources).
     *
     * @param  {ol/source/Source} source The layer source to register
     */
    bindLoadHandlers: function bindLoadHandlers(source, register) {
      var me = this;
      var eventPrefix = '';
      var method = register ? 'on' : 'un';

      if (source instanceof __WEBPACK_IMPORTED_MODULE_3_ol_source___["a" /* Image */]) {
        // includes ImageWms, also e.g. ImageArcGISRest, OSM …
        eventPrefix = 'image';
      } else if (source instanceof __WEBPACK_IMPORTED_MODULE_3_ol_source___["b" /* TileImage */]) {
        // includes TileWMS, Bing and more
        eventPrefix = 'tile';
      } else if (source instanceof __WEBPACK_IMPORTED_MODULE_3_ol_source___["c" /* Vector */]) {
        if (source instanceof __WEBPACK_IMPORTED_MODULE_3_ol_source___["d" /* Cluster */]) {
          source = source.getSource();
        }

        eventPrefix = 'vector';
      }

      if (eventPrefix) {
        source[method](eventPrefix + 'loadstart', me.incrementLoading, me);
        source[method](eventPrefix + 'loadend', me.decrementLoading, me);
        source[method](eventPrefix + 'loaderror', me.decrementLoading, me);
      }
    },

    /**
     * Called whenever loading of a layer starts.
     * This will increment the internal counter and show this loading indicator.
     */
    incrementLoading: function incrementLoading() {
      var me = this;
      me.loading++;
      me.visible = true;
    },

    /**
     * Called whenever loading stops or errors.
     * This will decrement the internal counter and if nothing is currently
     * loading the counter is reset and the loading indicator is hidden.
     */
    decrementLoading: function decrementLoading() {
      var me = this;
      me.loading--;

      if (me.loading <= 0) {
        me.visible = false;
        me.resetLoading();
      }
    },

    /**
     * Helper method to reset the internal loading counter.
     */
    resetLoading: function resetLoading() {
      this.loading = 0;
    },

    /**
     * Takes care of added layers to any `ol/layer/Group`. These need to get
     * registered to the appropriate handlers.
     *
     * @param {ol/events/Event} evt The add event of the `ol/layer/Group`.
     */
    onLayerAddedToGroup: function onLayerAddedToGroup(evt) {
      this.registerLayers(evt.element);
    },

    /**
     * Takes care of removed layers to any `ol/layer/Group`. These need to get
     * unregistered from the appropriate handlers.
     *
     * @param {ol/events/Event} evt The remove event of the `ol/layer/Group`.
     */
    onLayerRemovedFromGroup: function onLayerRemovedFromGroup(evt) {
      this.registerLayers(evt.element);
    }
  }
});

/***/ }),

/***/ "SPmS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TVSi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__ = __webpack_require__("8tls");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58e1ee71_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__ = __webpack_require__("8xuK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58e1ee71_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58e1ee71_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TooU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-measure-type-chooser',
  props: {
    measureType: {
      type: String,
      default: 'distance'
    }
  },
  data: function data() {
    return {
      measureTypeData: this.measureType
    };
  },
  watch: {
    // listen to changed measurement type and forward to parent component
    measureTypeData: function measureTypeData(newVal, oldVal) {
      this.$emit('wgu-measuretype-change', newVal, oldVal);
    }
  }
});

/***/ }),

/***/ "UdpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray__ = __webpack_require__("EmY/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es_array_map_js__ = __webpack_require__("/TzG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es_array_map_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es_array_map_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_string_split_js__ = __webpack_require__("388n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_string_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_string_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_regexp_exec_js__ = __webpack_require__("XEfP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_regexp_exec_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_regexp_exec_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_object_to_string_js__ = __webpack_require__("vw/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_regexp_to_string_js__ = __webpack_require__("q4B+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_regexp_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_regexp_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es_number_to_fixed_js__ = __webpack_require__("9P18");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es_number_to_fixed_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es_number_to_fixed_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_core_js_stable_instance_trim__ = __webpack_require__("9gOy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_core_js_stable_instance_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_core_js_stable_instance_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ol_Map__ = __webpack_require__("trid");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ol_View__ = __webpack_require__("Lfyu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ol_control_Attribution__ = __webpack_require__("bAyG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_ol_control_Zoom__ = __webpack_require__("Lmaf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_ol_interaction__ = __webpack_require__("TDso");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_ol_control_Rotate__ = __webpack_require__("lZ2e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_ol_proj_Projection__ = __webpack_require__("7rnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_ol_tilegrid_TileGrid__ = __webpack_require__("clnH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_ol_proj_proj4__ = __webpack_require__("4Asb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_ol_proj__ = __webpack_require__("yGLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_ol_Overlay__ = __webpack_require__("kZ1N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_ol_format__ = __webpack_require__("3Zsm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_ol_layer__ = __webpack_require__("ItK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_ol_source__ = __webpack_require__("8cSO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_proj4__ = __webpack_require__("nvAS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__WguEventBus_js__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__factory_Layer_js__ = __webpack_require__("OUzU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__util_Color__ = __webpack_require__("nF/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__util_Layer__ = __webpack_require__("fIFi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__PermalinkController__ = __webpack_require__("1l2W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__util_MapInteraction__ = __webpack_require__("wO5V");












//
//















 // import the app-wide EventBus







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-map',
  props: {
    color: {
      type: String,
      required: false,
      default: 'red darken-3'
    },
    collapsibleAttribution: {
      type: Boolean,
      default: false
    },
    rotateableMap: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      zoom: this.$appConfig.mapZoom,
      center: this.$appConfig.mapCenter,
      projection: this.$appConfig.mapProjection,
      projectionObj: null,
      projectionDefs: this.$appConfig.projectionDefs,
      tileGridDefs: this.$appConfig.tileGridDefs || {},
      tileGrids: {},
      permalink: this.$appConfig.permalink,
      mapGeodataDragDop: this.$appConfig.mapGeodataDragDop,
      // mapping format string to OL module / class
      formatMapping: {
        GPX: __WEBPACK_IMPORTED_MODULE_24_ol_format__["a" /* GPX */],
        GeoJSON: __WEBPACK_IMPORTED_MODULE_24_ol_format__["b" /* GeoJSON */],
        IGC: __WEBPACK_IMPORTED_MODULE_24_ol_format__["c" /* IGC */],
        KML: __WEBPACK_IMPORTED_MODULE_24_ol_format__["d" /* KML */],
        TopoJSON: __WEBPACK_IMPORTED_MODULE_24_ol_format__["e" /* TopoJSON */]
      },
      dragDropLayerCreated: false
    };
  },
  mounted: function mounted() {
    var me = this; // Make the OL map accessible for Mapable mixin even 'ol-map-mounted' has
    // already been fired. Don not use directly in cmps, use Mapable instead.

    __WEBPACK_IMPORTED_MODULE_12_vue__["default"].prototype.$map = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(me); // Send the event 'ol-map-mounted' with the OL map as payload

    __WEBPACK_IMPORTED_MODULE_28__WguEventBus_js__["a" /* WguEventBus */].$emit('ol-map-mounted', __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(me)); // resize the map, so it fits to parent

    me.timerHandle = setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).setTarget(document.getElementById('ol-map-container'));

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).updateSize(); // adjust the bg color of the OL buttons (like zoom, rotate north, ...)


      me.setOlButtonColor(); // initialize map hover functionality

      me.setupMapHover();
    }, 200);
  },
  destroyed: function destroyed() {
    if (this.timerHandle) {
      clearTimeout(this.timerHandle);
    }

    if (this.permalinkController) {
      this.permalinkController.tearDown();
      this.permalinkController = undefined;
    } // Send the event 'ol-map-unmounted' with the OL map as payload


    __WEBPACK_IMPORTED_MODULE_28__WguEventBus_js__["a" /* WguEventBus */].$emit('ol-map-unmounted', __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(this));
  },
  created: function created() {
    var _context,
        _this = this;

    // make map rotateable according to property
    var interactions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17_ol_interaction__["a" /* defaults */])({
      altShiftDragRotate: this.rotateableMap,
      pinchRotate: this.rotateableMap
    }); // add geodata drag-drop support according to config

    if (this.mapGeodataDragDop) {
      var dragAndDropInteraction = this.setupGeodataDragDrop();
      interactions.push(dragAndDropInteraction);
    }

    var controls = [new __WEBPACK_IMPORTED_MODULE_16_ol_control_Zoom__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_15_ol_control_Attribution__["a" /* default */]({
      collapsible: this.collapsibleAttribution
    })]; // add a button control to reset rotation to 0, if map is rotateable

    if (this.rotateableMap) {
      controls.push(new __WEBPACK_IMPORTED_MODULE_18_ol_control_Rotate__["a" /* default */]());
    } // Optional projection (EPSG) definitions for Proj4


    if (this.projectionDefs) {
      // Add all (array of array)
      __WEBPACK_IMPORTED_MODULE_27_proj4__["a" /* default */].defs(this.projectionDefs); // Register with OpenLayers

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_ol_proj_proj4__["a" /* register */])(__WEBPACK_IMPORTED_MODULE_27_proj4__["a" /* default */]);
    } // Projection for map, default is Web Mercator


    var projection;

    if (!this.projection) {
      projection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22_ol_proj__["a" /* get */])('EPSG:3857');
    } else {
      projection = new __WEBPACK_IMPORTED_MODULE_19_ol_proj_Projection__["a" /* default */](this.projection);
    } // Optional TileGrid definitions by name, for ref in Layers


    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context = __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_object_keys___default()(this.tileGridDefs)).call(_context, function (name) {
      _this.tileGrids[name] = new __WEBPACK_IMPORTED_MODULE_20_ol_tilegrid_TileGrid__["a" /* default */](_this.tileGridDefs[name]);
    });

    this.map = new __WEBPACK_IMPORTED_MODULE_13_ol_Map__["a" /* default */]({
      layers: [],
      controls: controls,
      interactions: interactions,
      view: new __WEBPACK_IMPORTED_MODULE_14_ol_View__["a" /* default */]({
        center: this.center,
        zoom: this.zoom,
        projection: projection
      })
    }); // create layers from config and add them to map

    this.registerLayerEvents();
    var layers = this.createLayers();

    __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().extend(layers);

    if (this.$appConfig.permalink) {
      this.permalinkController = this.createPermalinkController();

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).set('permalinkcontroller', this.permalinkController, true);

      this.permalinkController.apply();
      this.permalinkController.setup();
    }
  },
  methods: {
    /**
     * Creates the OL layers due to the "mapLayers" array in app config.
     * @return {ol.layer.Base[]} Array of OL layer instances
     */
    createLayers: function createLayers() {
      var me = this;
      var layers = [];
      var appConfig = this.$appConfig;
      var mapLayersConfig = appConfig.mapLayers || [];
      mapLayersConfig.reverse().forEach(function (lConf) {
        // Some Layers may require a TileGrid object
        // Remarks: Passing null instead of undefined as parameters into the
        //  constructor of OpenLayers sources overwrites OpenLayers defaults.
        lConf.tileGrid = lConf.tileGridRef ? me.tileGrids[lConf.tileGridRef] : undefined;
        var layer = __WEBPACK_IMPORTED_MODULE_29__factory_Layer_js__["a" /* LayerFactory */].getInstance(lConf, __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(me));
        layers.push(layer); // if layer is selectable register a select interaction

        if (lConf.selectable) {
          var selectClick = __WEBPACK_IMPORTED_MODULE_33__util_MapInteraction__["a" /* default */].createSelectInteraction(layer, lConf.selectStyle, lConf.doAppendSelectStyle); // register/activate interaction on map

          __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).addInteraction(selectClick);
        }
      });
      return layers;
    },

    /**
     * Hook up events to process newly added and modified OL layers.
     * This is currently used to update locale specific layer properties.
     */
    registerLayerEvents: function registerLayerEvents() {
      var _this2 = this;

      var layers = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers();

      layers.on('add', function (evt) {
        var layer = evt.element;

        _this2.updateLocalizedLayerProps(evt.element);

        layer.on('propertychange', function (evt) {
          if (evt.key === 'lid' || evt.key === 'langKey') {
            _this2.updateLocalizedLayerProps(evt.target);
          }
        });
      });
    },

    /**
     * Creates a PermalinkController, override in subclass for specializations.
     *
     * @return {PermalinkController} PermalinkController instance.
     */
    createPermalinkController: function createPermalinkController() {
      return new __WEBPACK_IMPORTED_MODULE_32__PermalinkController__["a" /* default */](__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(this), this.$appConfig.permalink);
    },

    /**
     * Sets the background color of the OL buttons to the color property.
     */
    setOlButtonColor: function setOlButtonColor() {
      var me = this;

      if (__WEBPACK_IMPORTED_MODULE_30__util_Color__["a" /* default */].isCssColor(me.color)) {
        // directly apply the given CSS color
        if (document.querySelector('.ol-zoom')) {
          document.querySelector('.ol-zoom .ol-zoom-in').style.backgroundColor = me.color;
          document.querySelector('.ol-zoom .ol-zoom-out').style.backgroundColor = me.color;
        }

        if (document.querySelector('.ol-rotate')) {
          document.querySelector('.ol-rotate .ol-rotate-reset').style.backgroundColor = me.color;
        }
      } else {
        var _context2;

        // apply vuetify color by transforming the color to the corresponding
        // CSS class (see https://vuetifyjs.com/en/framework/colors)
        var _me$color$toString$tr = __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_core_js_stable_instance_trim___default()(_context2 = me.color.toString()).call(_context2).split(' ', 2),
            _me$color$toString$tr2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray___default()(_me$color$toString$tr, 2),
            colorName = _me$color$toString$tr2[0],
            colorModifier = _me$color$toString$tr2[1];

        if (document.querySelector('.ol-zoom')) {
          document.querySelector('.ol-zoom .ol-zoom-in').classList.add(colorName);
          document.querySelector('.ol-zoom .ol-zoom-in').classList.add(colorModifier);
          document.querySelector('.ol-zoom .ol-zoom-out').classList.add(colorName);
          document.querySelector('.ol-zoom .ol-zoom-out').classList.add(colorModifier);
        }

        if (document.querySelector('.ol-rotate')) {
          document.querySelector('.ol-rotate .ol-rotate-reset').classList.add(colorName);
          document.querySelector('.ol-rotate .ol-rotate-reset').classList.add(colorModifier);
        }
      }
    },

    /**
     * Initializes the map hover functionality:
     * Adds a little tooltip like DOM element, wrapped as OL Overlay to the
     * map.
     * Registers a 'pointermove' event on the map and shows the layer's
     * 'hoverAttribute' if the layer is configured as 'hoverable'
     */
    setupMapHover: function setupMapHover() {
      var me = this;

      var map = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(me);

      var overlayEl; // create a span to show map tooltip

      overlayEl = document.createElement('span');
      overlayEl.classList.add('wgu-hover-tooltiptext');
      map.getTarget().append(overlayEl);
      me.overlayEl = overlayEl; // wrap the tooltip span in a OL overlay and add it to map

      me.overlay = new __WEBPACK_IMPORTED_MODULE_23_ol_Overlay__["a" /* default */]({
        element: overlayEl,
        stopEvent: false,
        className: 'wgu-hover-ol-overlay',
        autoPan: true,
        autoPanAnimation: {
          duration: 250
        }
      });
      map.addOverlay(me.overlay); // show tooltip if a hoverable feature gets hit with the mouse

      map.on('pointermove', me.onPointerMove, me);
    },

    /**
     * Shows the hover tooltip on the map if an appropriate feature of a
     * 'hoverable' layer was hit with the mouse.
     *
     * @param  {Object} event The OL event for pointermove
     */
    onPointerMove: function onPointerMove(event) {
      var me = this;

      var map = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(me);

      var overlayEl = me.overlayEl;
      var hoverAttr;
      var features = map.getFeaturesAtPixel(event.pixel, {
        layerFilter: function layerFilter(layer) {
          if (layer.get('hoverable')) {
            hoverAttr = layer.get('hoverAttribute');
          }

          return layer.get('hoverable');
        }
      });

      if (!features || features.length === 0 || !hoverAttr) {
        hoverAttr = null;
        overlayEl.innerHTML = null;
        me.overlay.setPosition(undefined);
        return;
      }

      var feature = features[0];
      var attr = feature.get(hoverAttr);
      overlayEl.innerHTML = attr;
      me.overlay.setPosition(event.coordinate);
    },

    /**
     * Initializes the geodata drag-drop functionality:
     * Adds the ol/interaction/DragAndDrop to the map and draws the dropped
     * features in a vector layer
     */
    setupGeodataDragDrop: function setupGeodataDragDrop() {
      var _context3,
          _context4,
          _this3 = this;

      var mapDdConf = this.mapGeodataDragDop;

      var formats = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context3 = __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context4 = mapDdConf.formats).call(_context4, function (formatStr) {
        return _this3.formatMapping[formatStr];
      })).call(_context3, function (fs) {
        return _this3.formatMapping[fs];
      });

      var dragAndDropInteraction = new __WEBPACK_IMPORTED_MODULE_17_ol_interaction__["b" /* DragAndDrop */]({
        formatConstructors: formats
      });
      dragAndDropInteraction.on('addfeatures', function (event) {
        var ddSource;

        if (mapDdConf.replaceData !== false) {
          if (!_this3.dragDropLayerCreated) {
            _this3.createDragDropLayer(mapDdConf);

            _this3.dragDropLayerCreated = true;
          } // replace existing geodata with the newly dropped data set


          var ddLayer = __WEBPACK_IMPORTED_MODULE_31__util_Layer__["a" /* default */].getLayersBy('wegueDragDropLayer', true, __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this3))[0];
          ddSource = ddLayer.getSource();
          ddSource.clear();
        } else {
          // add new layer for each dropped data set
          var newDdLayer = _this3.createDragDropLayer(mapDdConf);

          ddSource = newDdLayer.getSource();
        }

        ddSource.addFeatures(event.features);

        if (mapDdConf.zoomToData === true) {
          __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(_this3).getView().fit(ddSource.getExtent());
        }
      }, this);
      return dragAndDropInteraction;
    },

    /**
     * Creates the vector layer for showing drag/drop geodata on the map.
     *
     * @param {Object} mapDdConf the config object for this functionality
     */
    createDragDropLayer: function createDragDropLayer(mapDdConf) {
      var vectorSource = new __WEBPACK_IMPORTED_MODULE_26_ol_source__["c" /* Vector */]({});
      var vectorLayer = new __WEBPACK_IMPORTED_MODULE_25_ol_layer__["a" /* Vector */]({
        // random unique layer ID
        // For localization the randomized layer ID cannot be used, therefore map it to a fixed key
        // which will be part of the language path ('mapLayers.wgu-drag-drop-layer')
        lid: 'wgu-drag-drop-layer-' + (Math.random() * 1000000).toFixed(0),
        langKey: 'wgu-drag-drop-layer',
        wegueDragDropLayer: true,
        source: vectorSource,
        displayInLayerList: mapDdConf.displayInLayerList
      });

      __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).addLayer(vectorLayer);

      return vectorLayer;
    },

    /**
     * Updates locale specific layer properties. This is typically invoked after changes to
     * layer attributes, changes to the OpenLayers layer collection to process new layers
     * or after changes to the active locale.
     *
     * Remarks:
     * If a layer definition exists in the application context, any 'name' or 'attribution'
     * property declared there will take precedence over the ones declared in the
     * language packs.
     *
     * @param {ol.layer.Layer} OL layer instance
     */
    updateLocalizedLayerProps: function updateLocalizedLayerProps(layer) {
      var langKey = layer.get('langKey') || layer.get('lid');
      var pathLayer = 'mapLayers.' + langKey; // Update layer name.

      var pathName = pathLayer + '.name';
      layer.set('name', layer.get('confName') || this.$t(pathName)); // Update optional layer attributions.

      var pathAttributions = pathLayer + '.attributions';
      var source = layer.getSource();

      if (source && typeof source.setAttributions === 'function' && (layer.get('confAttributions') || this.$te(pathAttributions))) {
        source.setAttributions(layer.get('confAttributions') || this.$t(pathAttributions));
      }
    }
  },
  watch: {
    /**
     * Watch for locale changes and update language specific layer attributes.
     */
    '$i18n.locale': function $i18nLocale() {
      var _this4 = this;

      var layers = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers();

      layers.forEach(function (layer) {
        _this4.updateLocalizedLayerProps(layer);
      });
    }
  }
});

/***/ }),

/***/ "UkhJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelpWin_vue__ = __webpack_require__("7OTJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14204d04_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpWin_vue__ = __webpack_require__("1iwb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("dAkn")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14204d04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelpWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14204d04_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14204d04_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VLBH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Mapable__ = __webpack_require__("WFjz");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-layerlist',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Mapable__["a" /* Mapable */]],
  props: {},
  data: function data() {
    return {
      layers: []
    };
  },
  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable).
     * Bind to the layers from the OpenLayers map.
     */
    onMapBound: function onMapBound() {
      this.layers = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getLayers().getArray();
    },

    /**
     * Handler for click on item in layer list:
     * Toggles the corresponding layer visibility.
     *
     * @param  {Object} layer Layer object
     */
    onItemClick: function onItemClick(layer) {
      layer.setVisible(!layer.getVisible());
    }
  },
  computed: {
    /**
     * Reactive property to return the OpenLayers layers to be shown in the control.
     * Remarks: The 'displayInLayerList' attribute should default to true per convention.
     */
    displayedLayers: function displayedLayers() {
      var _context;

      return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_filter___default()(_context = this.layers).call(_context, function (layer) {
        return layer.get('displayInLayerList') !== false && !layer.get('isBaseLayer');
      }).reverse();
    }
  }
});

/***/ }),

/***/ "VNHm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_trim__ = __webpack_require__("9gOy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_function_name_js__ = __webpack_require__("YY9M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_function_name_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_function_name_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GeocoderController__ = __webpack_require__("qbcg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_extent__ = __webpack_require__("/LWt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_proj__ = __webpack_require__("yGLh");





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-geocoder-input',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_Mapable__["a" /* Mapable */]],
  props: {
    icon: {
      type: String,
      required: false,
      default: 'search'
    },
    rounded: {
      type: Boolean,
      required: false,
      default: true
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: true
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true
    },
    dark: {
      type: Boolean,
      required: false,
      default: false
    },
    persistentHint: {
      type: Boolean,
      required: false,
      default: true
    },
    debug: {
      type: Boolean,
      required: false,
      default: false
    },
    minChars: {
      type: Number,
      required: false,
      default: 3
    },
    queryDelay: {
      type: Number,
      required: false,
      default: 300
    },
    selectZoom: {
      type: Number,
      required: false,
      default: 16
    },
    provider: {
      type: String,
      required: false,
      default: 'osm'
    },
    providerOptions: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      results: [],
      lastQueryStr: '',
      noFilter: true,
      search: null,
      selecting: false,
      selected: null,
      hideSearch: true,
      timeout: null
    };
  },
  computed: {
    resultItems: function resultItems() {
      var _this = this;

      var items = [];

      if (!this.results) {
        return items;
      }

      this.trace("computed.resultItems() - cur results len=".concat(this.results.length)); // Convert results to v-combobox (text, value) Items

      this.results.forEach(function (result) {
        _this.trace("add to this.items: ".concat(result.address.name));

        items.push({
          text: result.address.name,
          value: result
        });
      });
      return items;
    }
  },
  methods: {
    trace: function trace(str) {
      this.debug && console && console.info(str);
    },
    toggle: function toggle() {
      // Show/hide search combobox
      this.hideSearch = !this.hideSearch;
    },
    // Query by string - should return list of selection items (adresses) for ComboBox
    querySelections: function querySelections(queryStr) {
      var _this2 = this;

      this.timeout = setTimeout(function () {
        // Let Geocoder Provider do the query
        // items (item.text fields) will be shown in combobox dropdown suggestions
        _this2.trace("geocoderController.query: ".concat(queryStr));

        _this2.geocoderController.query(queryStr).then(function (results) {
          return _this2.onQueryResults(results);
        }).catch(function (err) {
          return _this2.onQueryError(err);
        });
      }, this.queryDelay);
    },
    onQueryResults: function onQueryResults(results) {
      // Handle query results from GeocoderController
      this.timeout && clearTimeout(this.timeout);
      this.timeout = null;
      this.results = null;

      if (!results || results.length === 0) {
        return;
      } // ASSERT: results is defined and at least one result


      this.trace("results ok: len=".concat(results.length));
      this.results = results;
    },
    onQueryError: function onQueryError(err) {
      if (err) {
        this.trace("onQueryResult error: ".concat(err));
      }
    }
  },
  watch: {
    // Input string value changed
    search: function search(queryStr) {
      if (this.timeout || this.selecting) {
        // Query or selection in progress
        this.trace("query or selection in progress...");
        return;
      }

      if (!queryStr || queryStr.length === 0) {
        // Query reset
        this.trace("queryStr none");
        this.results = null;
        return;
      } // ASSERTION: queryStr is valid


      queryStr = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_trim___default()(queryStr).call(queryStr); // Only query if minimal number chars typed and querystring has changed

      queryStr.length >= this.minChars && queryStr !== this.lastQueryStr && this.querySelections(queryStr);
      this.lastQueryStr = queryStr;
    },
    // User has selected entry from suggested items
    selected: function selected(item) {
      if (!item || !item.hasOwnProperty('text') || !item.hasOwnProperty('value')) {
        return;
      }

      this.selecting = true;
      this.trace("selected=".concat(item.text)); // Position Map on result

      var result = item.value;

      var mapProjection = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView().getProjection();

      var coords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_ol_proj__["m" /* fromLonLat */])([result.lon, result.lat], mapProjection); // Prefer zooming to bounding box if present in result

      if (result.hasOwnProperty('boundingbox')) {
        // Result with bounding box.
        // bbox is in EPSG:4326, needs to be transformed to Map Projection (e.g. EPSG:3758)
        var extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_ol_extent__["i" /* applyTransform */])(result.boundingbox, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_ol_proj__["b" /* getTransform */])('EPSG:4326', mapProjection));

        __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView().fit(extent);
      } else {
        // No bbox in result: center on lon/lat from result and zoom in
        __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView().setZoom(this.selectZoom);
      }

      __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView().setCenter(coords);

      this.selecting = false;
    }
  },
  mounted: function mounted() {
    // Setup GeocoderController to which we delegate Provider and query-handling
    this.geocoderController = new __WEBPACK_IMPORTED_MODULE_6__GeocoderController__["a" /* GeocoderController */](this.provider, this.providerOptions, this);
  }
});

/***/ }),

/***/ "VT4C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OlMeasureController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__ = __webpack_require__("nOcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__ = __webpack_require__("howJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_interaction_Draw__ = __webpack_require__("aUJj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_Observable_js__ = __webpack_require__("nxYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_source_Vector__ = __webpack_require__("WMwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_layer_Vector__ = __webpack_require__("Umvz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_style_Style__ = __webpack_require__("Mjwz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_style_Stroke__ = __webpack_require__("00zS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ol_style_Circle__ = __webpack_require__("uli1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ol_style_Fill__ = __webpack_require__("lUmj");












/**
 * Class holding the OpenLayers related logic for the measure tool.
 */

var OlMeasureController = /*#__PURE__*/function () {
  /* the OL map we want to measure on */
  function OlMeasureController(olMap, measureConf) {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default()(this, OlMeasureController);

    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_defineProperty___default()(this, "map", null);

    this.map = olMap;
    this.measureConf = measureConf || {};
    this.measureLayer = undefined;
  }
  /**
   * Tears down this controller.
   */


  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default()(OlMeasureController, [{
    key: "destroy",
    value: function destroy() {
      if (!this.measureLayer || !__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this)) {
        return;
      }

      this.removeInteraction();

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).removeLayer(this.measureLayer);

      this.measureLayer = undefined;
    }
    /**
     * Creates a vector layer for the measurement results and adds it to the
     * map.
     */

  }, {
    key: "createMeasureLayer",
    value: function createMeasureLayer() {
      var me = this;
      var measureConf = me.measureConf; // create a vector layer to

      var source = new __WEBPACK_IMPORTED_MODULE_6_ol_source_Vector__["a" /* default */]();
      this.measureLayer = new __WEBPACK_IMPORTED_MODULE_7_ol_layer_Vector__["a" /* default */]({
        lid: 'wgu-measure-layer',
        displayInLayerList: false,
        source: source,
        style: new __WEBPACK_IMPORTED_MODULE_8_ol_style_Style__["d" /* default */]({
          fill: new __WEBPACK_IMPORTED_MODULE_11_ol_style_Fill__["a" /* default */]({
            color: measureConf.fillColor || 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new __WEBPACK_IMPORTED_MODULE_9_ol_style_Stroke__["a" /* default */]({
            color: measureConf.strokeColor || 'rgba(0, 0, 0, 0.5)',
            width: 2
          })
        })
      });

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).addLayer(this.measureLayer); // make vector source available as member


      me.source = source;
    }
    /**
     * Creates and adds the necessary draw interaction and adds it to the map.
     */

  }, {
    key: "addInteraction",
    value: function addInteraction(measureType, mapClickCb) {
      var me = this;
      var measureConf = me.measureConf; // cleanup possible old draw interaction

      if (me.draw) {
        me.removeInteraction();
      }

      var type = measureType === 'area' ? 'Polygon' : 'LineString';
      var draw = new __WEBPACK_IMPORTED_MODULE_4_ol_interaction_Draw__["a" /* default */]({
        source: me.source,
        type: type,
        style: new __WEBPACK_IMPORTED_MODULE_8_ol_style_Style__["d" /* default */]({
          fill: new __WEBPACK_IMPORTED_MODULE_11_ol_style_Fill__["a" /* default */]({
            color: measureConf.sketchFillColor || 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new __WEBPACK_IMPORTED_MODULE_9_ol_style_Stroke__["a" /* default */]({
            color: measureConf.sketchStrokeColor || 'rgba(0, 0, 0, 0.5)',
            lineDash: [10, 10],
            width: 2
          }),
          image: new __WEBPACK_IMPORTED_MODULE_10_ol_style_Circle__["a" /* default */]({
            radius: 5,
            stroke: new __WEBPACK_IMPORTED_MODULE_9_ol_style_Stroke__["a" /* default */]({
              color: measureConf.sketchVertexStrokeColor || 'rgba(0, 0, 0, 0.7)'
            }),
            fill: new __WEBPACK_IMPORTED_MODULE_11_ol_style_Fill__["a" /* default */]({
              color: measureConf.sketchVertexFillColor || 'rgba(255, 255, 255, 0.2)'
            })
          })
        })
      });

      __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).addInteraction(draw);

      var listener;
      var sketch;
      draw.on('drawstart', function (evt) {
        // clear old measure features
        me.source.clear(); // preserve sketch

        sketch = evt.feature;
        listener = __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(me).on('click', function (evt) {
          var geom = sketch.getGeometry(); // execute given callback

          mapClickCb(geom);
        });
      }, me);
      draw.on('drawend', function () {
        // unset sketch
        sketch = null;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_ol_Observable_js__["b" /* unByKey */])(listener);
      }, me); // make draw interaction available as member

      me.draw = draw;
    }
    /**
     * Removes the current interaction and clears the values.
     */

  }, {
    key: "removeInteraction",
    value: function removeInteraction() {
      if (this.draw) {
        __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).removeInteraction(this.draw);

        this.draw = undefined;
      }

      if (this.source) {
        this.source.clear();
      }
    }
  }]);

  return OlMeasureController;
}();



/***/ }),

/***/ "VcDn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W2JY":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de.json": "LaCf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "W2JY";

/***/ }),

/***/ "WFjz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Mapable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__ = __webpack_require__("ZkkH");

/**
 * Mixin, which binds the OL map to the target component.
 * Executes the onMapBound function of the target component, if available.
 */

var Mapable = {
  created: function created() {
    var _this = this;

    // if the OL map is not present in the vue prototype we have to wait until
    // it is mounted. Otherwise apply OL map as member var.
    if (!this.$map) {
      // apply OL map once OL map is mounted
      __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__["a" /* WguEventBus */].$on('ol-map-mounted', function (olMap) {
        // make the OL map accessible in this component
        _this.map = olMap;

        if (_this.onMapBound) {
          _this.onMapBound();

          _this.unbound = false;
        }
      });
    } else {
      // OL map is already mounted --> directly apply as member
      this.map = this.$map;

      if (this.onMapBound) {
        this.onMapBound();
        this.unbound = false;
      }
    }

    __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__["a" /* WguEventBus */].$on('ol-map-unmounted', function () {
      // Make the OL map unaccessible in this component
      if (_this.onMapUnbound) {
        _this.onMapUnbound();

        _this.unbound = true;
      }
    });
  }
};

/***/ }),

/***/ "XSiL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray__ = __webpack_require__("mF7D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_typeof__ = __webpack_require__("xtLq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_assign__ = __webpack_require__("E6nQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_assign__);





/**
 * Object related utility methods.
 */
var ObjectUtil = {
  /**
   * Tests whether item is an object
   * @param {*} item The item to test.
   * @returns {Boolean} True if the item is an object.
   */
  isObject: function isObject(item) {
    return item && __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_typeof___default()(item) === 'object' && !Array.isArray(item);
  },

  /**
   * Deep in place merge of source object into target object.
   * @param {Object} target The target of the merge operation.
   * @param {Object} source The source of the merge operation.
   */
  mergeDeep: function mergeDeep(target, source) {
    if (ObjectUtil.isObject(target) && ObjectUtil.isObject(source)) {
      for (var key in source) {
        if (ObjectUtil.isObject(source[key])) {
          if (!target[key]) {
            __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_assign___default()(target, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_defineProperty___default()({}, key, {}));
          }

          ObjectUtil.mergeDeep(target[key], source[key]);
        } else {
          __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_assign___default()(target, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_defineProperty___default()({}, key, source[key]));
        }
      }
    }
  },

  /**
   * Recursively list all property paths in an object.
   *
   * @param {Object} item An object to extract property paths from.
   * @param {String} path Internal usage for recursion.
   * @returns {Array} An array containing all paths to keys of the object.
   */
  toPaths: function toPaths(item) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var result = [];

    if (item && __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_typeof___default()(item) === 'object') {
      if (Array.isArray(item)) {
        for (var i = 0; i < item.length; i++) {
          result.push.apply(result, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray___default()(ObjectUtil.toPaths(item[i], path + '[' + i + ']')));
        }
      } else {
        for (var p in item) {
          result.push.apply(result, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_toConsumableArray___default()(ObjectUtil.toPaths(item[p], path + '.' + p)));
        }
      }
    } else {
      result.push(path);
    }

    return result;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (ObjectUtil);

/***/ }),

/***/ "Xzb6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YFln":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"measure-result"},[_vm._v("\n    "+_vm._s(_vm.$t("wgu-measuretool.length"))+": "+_vm._s(_vm.distance)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"measure-result"},[_vm._v("\n    "+_vm._s(_vm.$t("wgu-measuretool.area"))+": "+_vm._s(_vm.area)+"\n  ")])])}
var staticRenderFns = []


/***/ }),

/***/ "YPa9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BgLayerList_vue__ = __webpack_require__("HyBD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13a42903_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BgLayerList_vue__ = __webpack_require__("L4cT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BgLayerList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13a42903_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BgLayerList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13a42903_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BgLayerList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YvPU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocaleSwitcher_vue__ = __webpack_require__("gjO7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47fb8868_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocaleSwitcher_vue__ = __webpack_require__("mVey");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocaleSwitcher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47fb8868_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocaleSwitcher_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47fb8868_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocaleSwitcher_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZKPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OpenStreetMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__ = __webpack_require__("nOcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__ = __webpack_require__("howJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_number_parse_float__ = __webpack_require__("8U/s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_number_parse_float__);




// Code modified from: https://github.com/jonataswalker/ol-geocoder version: July 30, 2019
// The MIT License (MIT)
//
// Copyright (c) 2015 Jonatas Walker
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

/**
 * OpenStreetMap Nominatim Provider. See https://nominatim.openstreetmap.org.
 *
 * @class OpenStreetMap
 */
var OpenStreetMap = /*#__PURE__*/function () {
  /**
   * @constructor
   */
  function OpenStreetMap() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default()(this, OpenStreetMap);

    this.settings = {
      url: 'https://nominatim.openstreetmap.org/search/',
      params: {
        q: '',
        format: 'json',
        addressdetails: 1,
        limit: 10,
        countrycodes: '',
        'accept-language': 'en-US'
      }
    };
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default()(OpenStreetMap, [{
    key: "getParameters",
    value: function getParameters(opt) {
      return {
        url: this.settings.url,
        params: {
          q: opt.query,
          format: this.settings.params.format,
          addressdetails: this.settings.params.addressdetails,
          limit: opt.limit || this.settings.params.limit,
          countrycodes: opt.countrycodes || this.settings.params.countrycodes,
          'accept-language': opt.lang || this.settings.params['accept-language']
        }
      };
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(results) {
      if (!results || results.length === 0) {
        return;
      }

      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map___default()(results).call(results, function (result) {
        var _context;

        result = {
          lon: __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_number_parse_float___default()(result.lon),
          lat: __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_number_parse_float___default()(result.lat),
          boundingbox: __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context = result.boundingbox).call(_context, function (x) {
            return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_number_parse_float___default()(x);
          }),
          address: {
            name: result.display_name,
            road: result.address.road || '',
            houseNumber: result.address.house_number || '',
            postcode: result.address.postcode || '',
            city: result.address.city || result.address.town || '',
            state: result.address.state || '',
            country: result.address.country || ''
          },
          original: {
            formatted: result.display_name,
            details: result.address
          }
        }; // Make bbox llx,lly,urx,ury

        var bbox = result.boundingbox;
        result.boundingbox = [bbox[2], bbox[0], bbox[3], bbox[1]];
        return result;
      });
    }
  }]);

  return OpenStreetMap;
}();

/***/ }),

/***/ "ZY9t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PropertyTable_vue__ = __webpack_require__("v4OI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d37f3e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PropertyTable_vue__ = __webpack_require__("0dsf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("01On")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PropertyTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d37f3e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PropertyTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40d37f3e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PropertyTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZfcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__ = __webpack_require__("kJWX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f7d4afb_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__ = __webpack_require__("8NCD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("fUjn")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f7d4afb_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f7d4afb_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZkkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WguEventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
 // Vue instance acting as app-wide event-bus

var WguEventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ "a3aq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn-toggle',{attrs:{"mandatory":""},model:{value:(_vm.measureTypeData),callback:function ($$v) {_vm.measureTypeData=$$v},expression:"measureTypeData"}},[_c('v-btn',{attrs:{"large":"","value":"distance"}},[_vm._v("\n     "+_vm._s(_vm.$t("wgu-measuretool.distance"))+"\n   ")]),_vm._v(" "),_c('v-btn',{attrs:{"large":"","value":"area"}},[_vm._v("\n     "+_vm._s(_vm.$t("wgu-measuretool.area"))+"\n   ")])],1)}
var staticRenderFns = []


/***/ }),

/***/ "aqYZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "arw4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-card',{staticClass:"position"},[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":""}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c('v-toolbar-title',{staticClass:"wgu-win-title"},[_vm._v(_vm._s(_vm.componentTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-app-bar-nav-icon',{on:{"click":function($event){_vm.show = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('div',{staticClass:"card-content"},[(_vm.windowItems.image && _vm.windowItems.image.value)?_c('v-img',{attrs:{"height":_vm.imageHeight,"src":_vm.windowItems.image.value}}):_vm._e(),_vm._v(" "),(_vm.windowItems.image && _vm.windowItems.image.value)?_c('p',{staticClass:"photo-attribution"},[_vm._v("\n      Quelle Foto: "),_c('a',{attrs:{"href":_vm.windowItems.image.value,"target":"_blank"}},[_vm._v(_vm._s(_vm.windowItems.image.value))])]):_vm._e(),_vm._v(" "),(_vm.windowItems.title && _vm.windowItems.title.value)?_c('v-card-title',[_vm._v("\n    "+_vm._s(_vm.windowItems.title.value)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.windowItems.description && _vm.windowItems.description.value)?_c('v-card-subtitle',[_vm._v("\n    "+_vm._s(_vm.windowItems.description.value)+"\n    ")]):_vm._e(),_vm._v(" "),_vm._t("poiinfo-after-subtitle",null,{"featureProperties":_vm.featureProperties}),_vm._v(" "),_c('v-card-text',[_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.iconItems),function(item,key){return _c('v-list-item',{key:key},[_c('v-list-item-content',[_c('v-icon',{staticClass:"poi-icon"},[_vm._v("\n            "+_vm._s(item.icon)+"\n          ")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(item.value))])],1)],1)}),_vm._v(" "),_vm._l((_vm.namedItems),function(item,key){return _c('v-list-item',{key:key},[_c('v-list-item-content',[_c('v-list-item-title',[_c('b',[_vm._v(_vm._s(item.displayKey || item.key))])])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(item.value))])],1)],1)})],2)],1),_vm._v(" "),(_vm.linkItems)?_c('v-card-actions',_vm._l((_vm.linkItems),function(config,key){return _c('v-btn',{key:key,attrs:{"href":config.url,"target":"_blank","color":_vm.color,"dark":"","small":""}},[(config.icon)?_c('v-icon',{attrs:{"left":""}},[_vm._v("\n          "+_vm._s(config.icon)+"\n        ")]):_vm._e(),_vm._v("\n        "+_vm._s(config.title)+"\n      ")],1)}),1):_vm._e()],2)],1):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "c0QU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WguAppTemplate_vue__ = __webpack_require__("04/i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cd2a13c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguAppTemplate_vue__ = __webpack_require__("fVX8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WguAppTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cd2a13c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguAppTemplate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cd2a13c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguAppTemplate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cOdf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),

/***/ "csSS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cspx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureResult_vue__ = __webpack_require__("F+zM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22f632e3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureResult_vue__ = __webpack_require__("YFln");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("xdWY")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureResult_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22f632e3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureResult_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22f632e3_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureResult_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dAkn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dvsc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e/Tm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__ = __webpack_require__("6zSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__ = __webpack_require__("2bj9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__ = __webpack_require__("lv5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_toConsumableArray__ = __webpack_require__("mF7D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_keys__ = __webpack_require__("qWzE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_core_js_stable_instance_trim__ = __webpack_require__("9gOy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_core_js_stable_instance_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_core_js_stable_instance_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs3_core_js_stable_instance_find__ = __webpack_require__("2x6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs3_core_js_stable_instance_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs3_core_js_stable_instance_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs3_core_js_stable_instance_includes__ = __webpack_require__("wk9Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs3_core_js_stable_instance_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs3_core_js_stable_instance_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Object_js__ = __webpack_require__("XSiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Url_js__ = __webpack_require__("v9hS");






function ownKeys(object, enumerableOnly) { var keys = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys___default()(object); if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default.a) { var symbols = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default()(object); if (enumerableOnly) symbols = __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_filter___default()(symbols).call(symbols, function (sym) { return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_helpers_defineProperty___default()(target, key, source[key]); }); } else if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default.a) { Object.defineProperties(target, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(source, key)); }); } } return target; }











/**
 * Locale related utility methods.
 */

var LocaleUtil = {
  /**
   * Hardcoded fallback if no supported languages are declared in app config.
   */
  supportedLanguageFallback: {
    'en': 'English'
  },

  /**
   * Import a webpack context for language files and returns message content.
   * @param {Object} context The webpack context returned by require.context.
   * @param {Object} mappingFunc A function to extract messages from an item of the webpack context.
   *
   * @returns {Object} A container with message data. Key is the language code, value contains the messages.
   */
  importLocales: function importLocales(context, mappingFunc) {
    var _context;

    return __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_instance_keys___default()(context).call(context)).call(_context, function (key) {
      return {
        key: key,
        locale: key.match(/[a-z0-9-_]+/i)[0]
      };
    }).reduce(function (messages, _ref) {
      var key = _ref.key,
          locale = _ref.locale;
      return _objectSpread(_objectSpread({}, messages), {}, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_helpers_defineProperty___default()({}, locale, mappingFunc(context(key))));
    }, {});
  },

  /**
   * Import all Wegue core language files from 'src/locales' and optionally
   * app specific language files from 'app/locales'. Language files will be merged,
   * such that Wegue core messages can be overridden by app messages.
   *
   * @returns  {Object} A container with message data. Key is the language code, value contains the messages.
   */
  importVueI18nLocales: function importVueI18nLocales() {
    var jsonContentExtractor = function jsonContentExtractor(i) {
      return i;
    }; // Load Wegue core language files.


    var i18nMessages = LocaleUtil.importLocales(__webpack_require__("1ywd"), jsonContentExtractor); // Try to load optional app specific language files and merge contents.

    try {
      var i18nMessagesApp = LocaleUtil.importLocales(__webpack_require__("W2JY"), jsonContentExtractor);
      __WEBPACK_IMPORTED_MODULE_13__Object_js__["a" /* default */].mergeDeep(i18nMessages, i18nMessagesApp);
    } catch (e) {}

    return i18nMessages;
  },

  /**
   * Import vuetify language files from 'node_modules/vuetify/es/locale'.
   *
   * @returns A container with message data. Key is the language code, value contains the messages.
   */
  importVuetifyLocales: function importVuetifyLocales() {
    var moduleDefaultExtractor = function moduleDefaultExtractor(i) {
      return i.default;
    };

    return LocaleUtil.importLocales(__webpack_require__("qETa"), moduleDefaultExtractor);
  },

  /**
  * Detects the preferred language which is supported by the application
  * and returns the language code.
  * Priority order:
  * 1. URL-parameter
  * 2. Preferred browser language
  * 3. One of the accepted browser languages
  * 4. The fallback language declared in appConfig
  * 5. The fallback language declared above
  *
  * @param {Object} appConfig Global application context.
  * @returns The language code of the preferred language.
  */
  getPreferredLanguage: function getPreferredLanguage(appConfig) {
    var _context2, _context3;

    var precedence = __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context2 = [__WEBPACK_IMPORTED_MODULE_14__Url_js__["a" /* default */].getQueryParam('lang'), navigator.language || navigator.userLanguage]).call(_context2, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_helpers_toConsumableArray___default()(navigator.languages), [LocaleUtil.getFallbackLanguage(appConfig), __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys___default()(LocaleUtil.supportedLanguageFallback)[0]]); // Transform codes like 'de-DE' or 'en-GB' to 'de' or 'en'.


    var languages = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context3 = __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs3_core_js_stable_instance_filter___default()(precedence).call(precedence, function (value) {
      return !!value;
    })).call(_context3, function (value) {
      return value ? __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs3_core_js_stable_instance_trim___default()(value).call(value).split(/-|_/)[0] : null;
    });

    return __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs3_core_js_stable_instance_find___default()(languages).call(languages, function (value) {
      return LocaleUtil.isLanguageSupported(value, appConfig);
    });
  },

  /**
   * Get languages supported by the application, which are declared in the application context.
   * Fallback will be {'en':'English}'
   *
   * @param {Object} appConfig Global application context.
   * @returns {Object} A container with key value pairs, while key corresponds to the language code and
   *  value contains a human readable language name.
   */
  getSupportedLanguages: function getSupportedLanguages(appConfig) {
    var isDefined = appConfig.lang && appConfig.lang.supported && __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys___default()(appConfig.lang.supported).length > 0;
    return isDefined ? appConfig.lang.supported : LocaleUtil.supportedLanguageFallback;
  },

  /**
   * Get the fallback language declared in the application context.
   * If none such it is declared, returns 'en'.
   *
   * @param {Object} appConfig Global application context.
   * @returns {String} The language code of the fallback language.
   */
  getFallbackLanguage: function getFallbackLanguage(appConfig) {
    var isDefined = appConfig.lang && appConfig.lang.fallback;
    return isDefined ? appConfig.lang.fallback : __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys___default()(LocaleUtil.supportedLanguageFallback)[0];
  },

  /**
   * Checks whether the language code is supported by the application.
   *
   * @param {String} code The language code
   * @param {Object} appConfig Global application context.
   * @returns {Boolean} True if the language code is supported by the application.
   */
  isLanguageSupported: function isLanguageSupported(code, appConfig) {
    var _context4;

    var supported = LocaleUtil.getSupportedLanguages(appConfig);
    return __WEBPACK_IMPORTED_MODULE_12__babel_runtime_corejs3_core_js_stable_instance_includes___default()(_context4 = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs3_core_js_stable_object_keys___default()(supported)).call(_context4, code);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (LocaleUtil);

/***/ }),

/***/ "f54h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OpenCage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__ = __webpack_require__("nOcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__ = __webpack_require__("howJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map__);



// Code modified from: https://github.com/jonataswalker/ol-geocoder version: July 30, 2019
// The MIT License (MIT)
//
// Copyright (c) 2015 Jonatas Walker
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

/**
 * OpenCage Provider, needs key. See https://opencagedata.com.
 *
 * @class OpenCage
 *
 */
var OpenCage = /*#__PURE__*/function () {
  /**
   * @constructor
   */
  function OpenCage() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_classCallCheck___default()(this, OpenCage);

    this.settings = {
      url: 'https://api.opencagedata.com/geocode/v1/json?',
      params: {
        q: '',
        key: '',
        limit: 10,
        countrycodes: '',
        language: 'en-US',
        pretty: 1,
        no_annotations: 1
      }
    };
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_createClass___default()(OpenCage, [{
    key: "getParameters",
    value: function getParameters(options) {
      return {
        url: this.settings.url,
        params: {
          q: options.query,
          key: options.key,
          limit: options.limit || this.settings.params.limit,
          countrycode: options.countrycodes || this.settings.params.countrycodes,
          language: options.language || this.settings.params.language
        }
      };
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(results) {
      var _context;

      if (!results.results || results.results.length === 0) {
        return;
      }

      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_map___default()(_context = results.results).call(_context, function (result) {
        return {
          lon: result.geometry.lng,
          lat: result.geometry.lat,
          boundingbox: result.bounds && [result.bounds.southwest.lng, result.bounds.southwest.lat, result.bounds.northeast.lng, result.bounds.northeast.lat],
          address: {
            name: result.formatted,
            road: result.components.road || '',
            houseNumber: result.components.house_number || '',
            postcode: result.components.postcode || '',
            city: result.components.city || result.components.town || '',
            state: result.components.state || '',
            country: result.components.country || ''
          },
          original: {
            formatted: result.formatted,
            details: result.components
          }
        };
      });
    }
  }]);

  return OpenCage;
}();

/***/ }),

/***/ "fDqz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-module-card',_vm._b({staticClass:"wgu-layerlist",attrs:{"moduleName":"wgu-layerlist","icon":_vm.icon}},'wgu-module-card',_vm.$attrs,false),[_c('wgu-layerlist')],1)}
var staticRenderFns = []


/***/ }),

/***/ "fIFi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Util class for OL layers
 */
var LayerUtil = {
  /**
   * Returns a set of map layers which matches the given key value pair.
   *
   * @param {String} key - Key to filter layers
   * @param {Object} value - Value to filter layers
   * @param  {ol.Map} olMap  The OL map to search in
   * @return {ol.layer.Base[]} Array of matching layers
   */
  getLayersBy: function getLayersBy(key, value, olMap) {
    if (!olMap) {
      return [];
    }

    var layerMatches = [];
    olMap.getLayers().forEach(function (layer) {
      if (layer.get(key) === value) {
        layerMatches.push(layer);
      }
    });
    return layerMatches;
  },

  /**
   * Returns a map layer with the given LID (Layer ID)
   *
   * @param  {String} lid    The LID of the layer to query
   * @param  {ol.Map} olMap  The OL map to search in
   * @return {ol.layer.Base} The OL layer instance or undefined
   */
  getLayerByLid: function getLayerByLid(lid, olMap) {
    return LayerUtil.getLayersBy('lid', lid, olMap)[0];
  },

  /**
   * Zooms to the given layer's extent.
   * Will only work if the layer has kind of vector source.
   *
   * @param  {ol.layer.Base} vecLayer OL vector layer
   * @param  {ol.Map} olMap           The map to perform the zoom on
   */
  zoomToLayerExtent: function zoomToLayerExtent(vecLayer, olMap) {
    if (!vecLayer || !vecLayer.getSource().getExtent || !olMap) {
      return;
    }

    var extent = vecLayer.getSource().getExtent();
    olMap.getView().fit(extent);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (LayerUtil);

/***/ }),

/***/ "fT5P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OlStyleFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__ = __webpack_require__("6zSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__ = __webpack_require__("2bj9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__ = __webpack_require__("lv5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_number_max_safe_integer__ = __webpack_require__("L1Nm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_style__ = __webpack_require__("beD/");








function ownKeys(object, enumerableOnly) { var keys = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_object_keys___default()(object); if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default.a) { var symbols = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default()(object); if (enumerableOnly) symbols = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default()(symbols).call(symbols, function (sym) { return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty___default()(target, key, source[key]); }); } else if (__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default.a) { Object.defineProperties(target, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(source, key)); }); } } return target; }


/**
 * Factory, which creates OpenLayers style instances according to a given config
 * object.
 * This only covers a minimal subset of the OpenLayers style capabilities.
 * It allows to create simple styles for points, line and polygons.
 * For advanced styling use a custom style function or
 * GeoStyler<https://github.com/terrestris/geostyler>
 */

var OlStyleFactory = {
  /**
   * Returns an OpenLayers Style instance due to given config.
   *
   * @param  {Object} styleConf  Style config object
   * @return {Style}             OL Style instance
   */
  getInstance: function getInstance(styleConf) {
    var style;

    if (!styleConf) {
      return;
    } else if (styleConf.radius || styleConf.iconUrl || styleConf.textIcon) {
      style = OlStyleFactory.createPointStyle(styleConf);
    } else if (styleConf.fillColor) {
      style = OlStyleFactory.createPolygonStyle(styleConf);
    } else if (styleConf.strokeColor || styleConf.strokeWidth) {
      style = OlStyleFactory.createLineStyle(styleConf);
    }

    if (styleConf.label && styleConf.label.attribute && styleConf.label.attribute !== '') {
      // use an OL style function to enable labels
      return OlStyleFactory.getTextStyleFunction(style, styleConf.label);
    }

    return style;
  },

  /**
   * Returns an OpenLayers style instance for point due to given config.
   *
   * @param  {Object} styleConf  Style config object
   * @return {Style}             OL style instance
   */
  createPointStyle: function createPointStyle(styleConf) {
    var pointStyle;

    if (styleConf.iconUrl) {
      pointStyle = new __WEBPACK_IMPORTED_MODULE_7_ol_style__["b" /* Style */]({
        image: new __WEBPACK_IMPORTED_MODULE_7_ol_style__["a" /* Icon */]({
          src: styleConf.iconUrl,
          scale: styleConf.scale || 1,
          anchor: styleConf.iconAnchor,
          anchorXUnits: styleConf.iconAnchorXUnits,
          anchorYUnits: styleConf.iconAnchorYUnits
        })
      });
    } else if (styleConf.radius) {
      pointStyle = new __WEBPACK_IMPORTED_MODULE_7_ol_style__["b" /* Style */]({
        image: new __WEBPACK_IMPORTED_MODULE_7_ol_style__["c" /* Circle */]({
          radius: styleConf.radius,
          fill: OlStyleFactory.createFill(styleConf),
          stroke: OlStyleFactory.createStroke(styleConf)
        })
      });
    } else {
      pointStyle = new __WEBPACK_IMPORTED_MODULE_7_ol_style__["b" /* Style */]({
        text: new __WEBPACK_IMPORTED_MODULE_7_ol_style__["d" /* Text */]({
          text: styleConf.textIcon,
          font: styleConf.font || 'normal 30px Material Icons',
          fill: OlStyleFactory.createFill(styleConf)
        })
      });
    }

    return pointStyle;
  },

  /**
   * Returns an OpenLayers style instance for lines due to given config.
   *
   * @param  {Object} styleConf  Style config object
   * @return {Style}             OL style instance
   */
  createLineStyle: function createLineStyle(styleConf) {
    var olStyle = new __WEBPACK_IMPORTED_MODULE_7_ol_style__["b" /* Style */]({
      stroke: OlStyleFactory.createStroke(styleConf)
    });
    return olStyle;
  },

  /**
   * Returns an OpenLayers style instance for polygons due to given config.
   *
   * @param  {Object} styleConf  Style config object
   * @return {Style}             OL style instance
   */
  createPolygonStyle: function createPolygonStyle(styleConf) {
    var olStyle = OlStyleFactory.createLineStyle(styleConf);
    olStyle.setFill(OlStyleFactory.createFill(styleConf));
    return olStyle;
  },

  /**
   * Creates an OL Stroke object due to given config.
   *
   * @param  {Object} styleConf Style config object
   * @return {Stroke}           OL Stroke instance
   */
  createStroke: function createStroke(styleConf) {
    return new __WEBPACK_IMPORTED_MODULE_7_ol_style__["e" /* Stroke */]({
      color: styleConf.strokeColor,
      width: styleConf.strokeWidth
    });
  },

  /**
   * Creates an OL Fill object due to given config.
   *
   * @param  {Object} styleConf Style config object
   * @return {Fill}             OL Fill instance
   */
  createFill: function createFill(styleConf) {
    return new __WEBPACK_IMPORTED_MODULE_7_ol_style__["f" /* Fill */]({
      color: styleConf.fillColor
    });
  },

  /**
   * Creates and returns a basic OL style object for texts.
   *
   * @param {Object} labelConf Style config object for labels
   * @returns {ol/style/Text} The OL style object for texts
   */
  getTextStyle: function getTextStyle(labelConf) {
    // create a clone to avoid unwanted in place modification
    var textConf = _objectSpread({}, labelConf);

    textConf.fill = new __WEBPACK_IMPORTED_MODULE_7_ol_style__["f" /* Fill */]({
      color: textConf.fillColor
    });
    textConf.stroke = new __WEBPACK_IMPORTED_MODULE_7_ol_style__["e" /* Stroke */]({
      color: textConf.outlineColor,
      width: textConf.outlineWidth
    });
    var textStyle = new __WEBPACK_IMPORTED_MODULE_7_ol_style__["d" /* Text */](textConf);
    return textStyle;
  },

  /**
   * Wraps the given OL style as function and injects a text style symbolizer
   * in order to show a label at the feature.
   *
   * @param {ol/style/Style} style
   * @param {Object} labelStyleConf
   * @returns {ol/style/Style~StyleFunction}
   *    Style function returning the OL style object enriched by texts / labels
   */
  getTextStyleFunction: function getTextStyleFunction(style, labelStyleConf) {
    var labelStyle = OlStyleFactory.getTextStyle(labelStyleConf);
    var labelAttr = labelStyleConf.attribute;
    return function (feature, resolution) {
      // detect min/max resolution to show labels
      // if nothing is configured labels are shown regardless of resolution
      var minRes = labelStyleConf.minResolution || __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_number_max_safe_integer___default.a;
      var maxRes = labelStyleConf.maxResolution || 0;

      if (resolution < minRes && resolution > maxRes) {
        // set text to display
        labelStyle.setText(feature.get(labelAttr)); // apply text style to overall style object

        style.setText(labelStyle);
      } else {
        labelStyle.setText(null);
      }

      return style;
    };
  }
};

/***/ }),

/***/ "fUjn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fVX8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{ 'wgu-app': true, 'wgu-app-embedded': _vm.isEmbedded },attrs:{"id":"wgu-app","data-app":""}},[_vm._t("wgu-app-begin"),_vm._v(" "),_c('wgu-app-header',{attrs:{"color":_vm.baseColor}},[_vm._t("wgu-tb-start",null,{"slot":"wgu-tb-start"}),_vm._v(" "),_vm._t("wgu-tb-after-title",null,{"slot":"wgu-tb-after-title"}),_vm._v(" "),_vm._t("wgu-tb-before-auto-buttons",null,{"slot":"wgu-tb-before-auto-buttons"}),_vm._v(" "),_vm._t("wgu-tb-after-auto-buttons",null,{"slot":"wgu-tb-after-auto-buttons"}),_vm._v(" "),_vm._t("wgu-tb-end",null,{"slot":"wgu-tb-end"})],2),_vm._v(" "),_vm._t("wgu-after-header"),_vm._v(" "),(_vm.sidebarWins.length)?_c('wgu-app-sidebar',[_vm._l((_vm.sidebarWins),function(moduleWin,index){return [_c(moduleWin.type,_vm._b({key:index,tag:"component",attrs:{"color":_vm.baseColor}},'component',moduleWin,false))]})],2):_vm._e(),_vm._v(" "),_vm._t("wgu-before-content"),_vm._v(" "),_c('v-content',{attrs:{"app":""}},[_c('v-container',{staticClass:"pa-0",attrs:{"id":"ol-map-container","fluid":"","fill-height":""}},[_c('wgu-map',{attrs:{"color":_vm.baseColor}}),_vm._v(" "),_c('wgu-maploading-status',{attrs:{"color":_vm.baseColor}}),_vm._v(" "),_vm._t("wgu-after-map"),_vm._v(" "),_c('portal-target',{attrs:{"name":"map-overlay"}}),_vm._v(" "),_c('wgu-app-logo'),_vm._v(" "),_c('wgu-bglayerswitcher',{attrs:{"color":_vm.baseColor}})],2)],1),_vm._v(" "),_vm._l((_vm.floatingWins),function(moduleWin,index){return [_c(moduleWin.type,_vm._b({key:index,tag:"component",attrs:{"color":_vm.baseColor}},'component',moduleWin,false))]}),_vm._v(" "),_vm._t("wgu-before-footer"),_vm._v(" "),_c('wgu-app-footer',{attrs:{"color":_vm.baseColor,"footerTextLeft":_vm.$t('app.footerTextLeft'),"footerTextRight":_vm.$t('app.footerTextRight'),"showCopyrightYear":_vm.showCopyrightYear}}),_vm._v(" "),_vm._t("wgu-after-footer"),_vm._v(" "),_vm._t("wgu-app-end")],2)}
var staticRenderFns = []


/***/ }),

/***/ "gjO7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_Locale__ = __webpack_require__("e/Tm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-localeswitcher',
  props: {
    icon: {
      type: String,
      required: false,
      default: 'language'
    },
    dark: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      lang: __WEBPACK_IMPORTED_MODULE_0__util_Locale__["a" /* default */].getSupportedLanguages(this.$appConfig)
    };
  },
  methods: {
    /**
     * Change the i18n and built-in vuetify locale.
     */
    onItemClick: function onItemClick(langCode) {
      this.$i18n.locale = this.$vuetify.lang.current = langCode;
    }
  }
});

/***/ }),

/***/ "gxed":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__ = __webpack_require__("J5eo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_web_dom_collections_for_each_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__ = __webpack_require__("6zSr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__ = __webpack_require__("44wJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__ = __webpack_require__("2bj9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__ = __webpack_require__("lv5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty__ = __webpack_require__("BKP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_components_modulecore_ToggleButton__ = __webpack_require__("TVSi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_components_maxextentbutton_ZoomToMaxExtentButton__ = __webpack_require__("qqRY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_components_geocoder_Geocoder__ = __webpack_require__("kyCG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_components_geolocator_Geolocator__ = __webpack_require__("1nz2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_components_localeswitcher_LocaleSwitcher__ = __webpack_require__("YvPU");







function ownKeys(object, enumerableOnly) { var keys = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys___default()(object); if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default.a) { var symbols = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_object_get_own_property_symbols___default()(object); if (enumerableOnly) symbols = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_filter___default()(symbols).call(symbols, function (sym) { return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs3_helpers_defineProperty___default()(target, key, source[key]); }); } else if (__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default.a) { Object.defineProperties(target, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptors___default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_get_own_property_descriptor___default()(source, key)); }); } } return target; }


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-header',
  components: {
    'wgu-toggle-btn': __WEBPACK_IMPORTED_MODULE_8__src_components_modulecore_ToggleButton__["a" /* default */],
    'wgu-geocoder-btn': __WEBPACK_IMPORTED_MODULE_10__src_components_geocoder_Geocoder__["a" /* default */],
    'wgu-zoomtomaxextent-btn': __WEBPACK_IMPORTED_MODULE_9__src_components_maxextentbutton_ZoomToMaxExtentButton__["a" /* default */],
    'wgu-geolocator-btn': __WEBPACK_IMPORTED_MODULE_11__src_components_geolocator_Geolocator__["a" /* default */],
    'wgu-localeswitcher-btn': __WEBPACK_IMPORTED_MODULE_12__src_components_localeswitcher_LocaleSwitcher__["a" /* default */]
  },
  props: {
    color: {
      type: String,
      required: false,
      default: 'red darken-3'
    }
  },
  data: function data() {
    return {
      menuButtons: this.getModuleButtons('menu'),
      tbButtons: this.getModuleButtons('toolbar')
    };
  },
  methods: {
    /**
     * Determines the module button configuration objects from app-config:
     * If the module button toggles a window, then a generic wgu-toggle-btn will
     * be returned - otherwise the button is custom.
     *
     *    menuButtons: [
     *      {type: 'wgu-layerlist-toggle-btn'},
     *      {type: 'wgu-helpwin-toggle-btn'},
     *      {type: 'wgu-measuretool-toggle-btn'}
     *    ]
     * @param  {String} target Either 'menu' or 'toolbar'
     * @return {Array} module button configuration objects
     */
    getModuleButtons: function getModuleButtons(target) {
      var appConfig = __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$appConfig || {};
      var modulesConfs = appConfig.modules || {};
      var buttons = [];

      for (var _i = 0, _Object$keys = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs3_core_js_stable_object_keys___default()(modulesConfs); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        var moduleOpts = appConfig.modules[key];

        if (moduleOpts.target === target) {
          buttons.push(_objectSpread({
            type: moduleOpts.win ? 'wgu-toggle-btn' : key + '-btn',
            moduleName: key,
            // TODO For further simplifications we should revise the config property 'darkLayout'.
            dark: moduleOpts.darkLayout
          }, moduleOpts));
        }
      }

      return buttons;
    }
  }
});

/***/ }),

/***/ "h9kb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_LayerPreview__ = __webpack_require__("yekt");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-layerpreviewimage',
  props: {
    mapView: {
      type: Object,
      required: true
    },
    layer: {
      type: Object,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    previewIcon: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      imgLoaded: false
    };
  },
  computed: {
    /**
     * Returns an URL to the layers preview image.
     */
    previewURL: function previewURL() {
      return this.layer.get('previewImage') || __WEBPACK_IMPORTED_MODULE_1__util_LayerPreview__["a" /* default */].getUrl(this.layer, this.mapView.getCenter(), this.mapView.getResolution(), this.mapView.getProjection());
    }
  }
});

/***/ }),

/***/ "hQPT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-card',_vm._b({directives:[{name:"draggable-win",rawName:"v-draggable-win",value:(_vm.cardDraggable),expression:"cardDraggable"}],class:_vm.cardClasses,style:(_vm.cardStyles)},'v-card',_vm.cardAttr,false),[_c('v-img',{attrs:{"src":_vm.backgroundImage}},[_c('v-toolbar',_vm._b({},'v-toolbar',_vm.toolbarAttr,false),[_c('v-icon',{staticClass:"mr-4"},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c('v-toolbar-title',{staticClass:"wgu-win-title"},[_vm._v(_vm._s(_vm.$t(_vm.moduleName + '.title')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._t("wgu-win-toolbar"),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.minimizable)?_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){_vm.minimized = !_vm.minimized}}},[(_vm.minimized)?_c('v-icon',[_vm._v("web_asset")]):_c('v-icon',[_vm._v("remove")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"mr-0",attrs:{"icon":"","small":""},on:{"click":_vm.toggleUi}},[_c('v-icon',[_vm._v("close")])],1)],2)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.minimized),expression:"!minimized"}]},[_vm._t("default")],2)],1):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "hlHd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i8bC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__("UdpQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_653ad9af_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__("cOdf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("9x2o")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_653ad9af_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_653ad9af_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "imGD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jc9b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BgLayerSwitcher_vue__ = __webpack_require__("ygOZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6689c454_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BgLayerSwitcher_vue__ = __webpack_require__("QIMA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BgLayerSwitcher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6689c454_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BgLayerSwitcher_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6689c454_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BgLayerSwitcher_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jsTI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jsmT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kJWX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-footer',
  props: {
    color: {
      type: String,
      required: false,
      default: 'red darken-3'
    },
    footerTextLeft: {
      type: String,
      required: false,
      default: 'Powered by <a href="https://meggsimum.de/wegue/" target="_blank">Wegue WebGIS</a>'
    },
    footerTextRight: {
      type: String,
      required: false,
      default: 'meggsimum'
    },
    showCopyrightYear: {
      type: Boolean,
      required: false,
      default: true
    }
  }
});

/***/ }),

/***/ "kQCp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_DraggableWin__ = __webpack_require__("MPh8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WguEventBus__ = __webpack_require__("ZkkH");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-module-card',
  inheritAttrs: false,
  directives: {
    DraggableWin: __WEBPACK_IMPORTED_MODULE_1__directives_DraggableWin__["a" /* DraggableWin */]
  },
  props: {
    // Common properties
    moduleName: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    win: {
      type: String,
      required: false,
      default: 'floating'
    },
    minimizable: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: 'red darken-3'
    },
    backgroundImage: {
      type: String,
      required: false,
      default: undefined
    },
    visible: {
      type: Boolean,
      required: false,
      default: false
    },
    // Positioning / sizing properties will be ignored for sidebar cards.
    draggable: {
      type: Boolean,
      required: false,
      default: true
    },
    initPos: {
      type: Object,
      required: false
    },
    height: {
      type: [Number, String],
      required: false,
      default: undefined
    },
    width: {
      type: [Number, String],
      required: false,
      default: undefined
    },
    maxHeight: {
      type: [Number, String],
      required: false,
      default: undefined
    },
    maxWidth: {
      type: [Number, String],
      required: false,
      default: undefined
    },
    minHeight: {
      type: [Number, String],
      required: false,
      default: undefined
    },
    minWidth: {
      type: [Number, String],
      required: false,
      default: undefined
    }
  },
  data: function data() {
    return {
      show: this.visible,
      minimized: false
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2__WguEventBus__["a" /* WguEventBus */].$on(this.moduleName + 'visibility-change', function (visible) {
      _this.show = visible;

      _this.$emit('visibility-change', visible);
    });
  },
  computed: {
    cardClasses: function cardClasses() {
      return this.win === 'floating' ? ['wgu-module-card', 'wgu-floating'] : ['wgu-module-card', 'wgu-sidebar'];
    },
    cardStyles: function cardStyles() {
      return this.win === 'floating' ? {
        left: this.initPos ? this.initPos.left + 'px' : '0px',
        top: this.initPos ? this.initPos.top + 'px' : '0px'
      } : {};
    },
    cardAttr: function cardAttr() {
      return this.win === 'floating' ? {
        height: this.height,
        width: this.width,
        maxHeight: this.maxHeight,
        maxWidth: this.maxWidth,
        minHeight: this.minHeight,
        minWidth: this.minWidth
      } : {};
    },
    cardDraggable: function cardDraggable() {
      return this.win === 'floating' ? this.draggable : false;
    },
    toolbarAttr: function toolbarAttr() {
      return this.backgroundImage ? {
        dark: true,
        flat: true,
        color: 'transparent'
      } : {
        dark: true,
        color: this.color
      };
    }
  },
  methods: {
    toggleUi: function toggleUi() {
      __WEBPACK_IMPORTED_MODULE_2__WguEventBus__["a" /* WguEventBus */].$emit(this.moduleName + 'visibility-change', !this.show);
    }
  }
});

/***/ }),

/***/ "ktr9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kyCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Geocoder_vue__ = __webpack_require__("VNHm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dce445d4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geocoder_vue__ = __webpack_require__("reSj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("jsTI")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Geocoder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dce445d4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geocoder_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dce445d4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Geocoder_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lQeg":
/***/ (function(module, exports) {

module.exports = {"name":"proj4","version":"2.5.0","description":"Proj4js is a JavaScript library to transform point coordinates from one coordinate system to another, including datum transformations.","main":"dist/proj4-src.js","module":"lib/index.js","directories":{"test":"test","doc":"docs"},"scripts":{"build":"grunt","build:tmerc":"grunt build:tmerc","test":"npm run build && istanbul test _mocha test/test.js"},"repository":{"type":"git","url":"git://github.com/proj4js/proj4js.git"},"author":"","license":"MIT","devDependencies":{"chai":"~4.1.2","curl-amd":"github:cujojs/curl","grunt":"^1.0.1","grunt-cli":"~1.2.0","grunt-contrib-connect":"~1.0.2","grunt-contrib-jshint":"~1.1.0","grunt-contrib-uglify":"~3.1.0","grunt-mocha-phantomjs":"~4.0.0","grunt-rollup":"^6.0.0","istanbul":"~0.4.5","mocha":"~4.0.0","rollup":"^0.50.0","rollup-plugin-json":"^2.3.0","rollup-plugin-node-resolve":"^3.0.0","tin":"~0.5.0"},"dependencies":{"mgrs":"1.0.0","wkt-parser":"^1.2.0"}}

/***/ }),

/***/ "lgWu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureWin_vue__ = __webpack_require__("4z3x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b160dce_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureWin_vue__ = __webpack_require__("0ZKt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b160dce_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b160dce_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lk8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',_vm._l((_vm.displayedLayers),function(layer){return _c('v-list-item',{key:layer.lid,staticClass:"wgu-layerlist-item",on:{"click":function($event){return _vm.onItemClick(layer)}}},[_c('input',{key:layer.lid,staticClass:"wgu-layer-viz-cb",attrs:{"type":"checkbox"},domProps:{"checked":layer.getVisible()}}),_vm._v(" "),_c('v-list-item-content',{staticClass:"black--text"},[_c('v-list-item-title',[_vm._v("\n          "+_vm._s(layer.get('name'))+"\n        ")])],1)],1)}),1)}
var staticRenderFns = []


/***/ }),

/***/ "lqFH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"dense":"","loading":_vm.loading,"loading-text":_vm.$t('wgu-attributetable.loadingText'),"headers":_vm.headers,"items":_vm.records,"mobile-breakpoint":"0","page":_vm.page,"footer-props":{
      'items-per-page-options': [],
      'show-first-last-page': true
    },"single-select":"","value":_vm.selectedRow,"item-key":_vm.uniqueRecordKeyName,"items-per-page":_vm.rowsPerPage,"height":_vm.getTableHeight()},on:{"update:page":function($event){_vm.page=$event},"click:row":_vm.onRowClick}})}
var staticRenderFns = []


/***/ }),

/***/ "mUig":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__("gxed");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc5f76d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__("DjXo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Xzb6")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc5f76d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc5f76d2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mVey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"offset-y":"","nudge-bottom":"15","transition":"scale-transition"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn-toggle',{attrs:{"borderless":"","dense":"","background-color":"transparent","dark":_vm.dark,"title":_vm.$t('wgu-localeswitcher.title')},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-btn',_vm._g({staticClass:"ma-2",attrs:{"icon":"","value":true}},on),[_c('v-icon',{staticClass:"mr-1",attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n          "+_vm._s(_vm.$i18n.locale)+" \n        ")],1)],1)]}}]),model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "),_c('v-list',_vm._l((Object.keys(_vm.lang)),function(langCode){return _c('v-list-item',{key:langCode,staticClass:"wgu-langlist-item",on:{"click":function($event){return _vm.onItemClick(langCode)}}},[_c('v-list-item-content',{staticClass:"black--text"},[_c('v-list-item-title',[_vm._v("\n            "+_vm._s(_vm.lang[langCode])+" ("+_vm._s(langCode)+")\n          ")])],1)],1)}),1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "mucN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerList_vue__ = __webpack_require__("VLBH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47a56506_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerList_vue__ = __webpack_require__("lk8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("VcDn")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47a56506_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47a56506_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nF/d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Util class for color related things.
 */
var ColorUtil = {
  /**
   * Detects whether a given string is a CSS color notation.
   *
   * @param {String} color (Color) string to test
   * @return {Boolean} true if given string is in CSS color notation
   */
  isCssColor: function isCssColor(color) {
    return !!color && !!color.match(/^(#|(rgb|hsl)a?\()/);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (ColorUtil);

/***/ }),

/***/ "novK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapLoadingStatus_vue__ = __webpack_require__("RAvm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c93d1702_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapLoadingStatus_vue__ = __webpack_require__("ND6S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("jsmT")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapLoadingStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c93d1702_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapLoadingStatus_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c93d1702_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapLoadingStatus_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "odA+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributeTable_vue__ = __webpack_require__("PJIL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75e4eaab_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeTable_vue__ = __webpack_require__("lqFH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttributeTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75e4eaab_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75e4eaab_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttributeTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qETa":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af.js": "yU6n",
	"./ar.js": "l2Yc",
	"./ca.js": "5QRW",
	"./cs.js": "7EgZ",
	"./de.js": "FgG9",
	"./el.js": "nuzw",
	"./en.js": "kcwg",
	"./es.js": "LW8o",
	"./et.js": "Xoj/",
	"./fa.js": "Dhz9",
	"./fr.js": "r2zY",
	"./he.js": "qKfn",
	"./hr.js": "NY0B",
	"./hu.js": "RuEo",
	"./id.js": "kSeb",
	"./index.js": "YZlv",
	"./it.js": "UXUi",
	"./ja.js": "b2mU",
	"./ko.js": "mK+S",
	"./lt.js": "9STr",
	"./lv.js": "1Jmd",
	"./nl.js": "eCap",
	"./no.js": "iG/Y",
	"./pl.js": "0vAu",
	"./pt.js": "A86W",
	"./ro.js": "Eplm",
	"./ru.js": "MoUL",
	"./sl.js": "cXVd",
	"./sr-Cyrl.js": "/LzZ",
	"./sv.js": "SNeT",
	"./th.js": "P2U1",
	"./tr.js": "Yot5",
	"./uk.js": "MSHb",
	"./zh-Hans.js": "AlPo",
	"./zh-Hant.js": "rgAM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qETa";

/***/ }),

/***/ "qUL7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoClickWin_vue__ = __webpack_require__("Nkpt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a373fa4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoClickWin_vue__ = __webpack_require__("5e8c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("hlHd")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoClickWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a373fa4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoClickWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a373fa4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoClickWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qbcg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PROVIDERS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GeocoderController; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator__ = __webpack_require__("0WSM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_classCallCheck__ = __webpack_require__("nOcP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_createClass__ = __webpack_require__("howJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_regenerator__ = __webpack_require__("I3KW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__providers_osm__ = __webpack_require__("ZKPR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__providers_photon__ = __webpack_require__("Bik2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__providers_opencage__ = __webpack_require__("f54h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_ajax__ = __webpack_require__("9OlX");




// Code modified from: https://github.com/jonataswalker/ol-geocoder version: July 30, 2019
// The MIT License (MIT)
//
// Copyright (c) 2015 Jonatas Walker
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.



 // Geocoder Provider types

var PROVIDERS = {
  'osm': __WEBPACK_IMPORTED_MODULE_4__providers_osm__["a" /* OpenStreetMap */],
  'photon': __WEBPACK_IMPORTED_MODULE_5__providers_photon__["a" /* Photon */],
  'opencage': __WEBPACK_IMPORTED_MODULE_6__providers_opencage__["a" /* OpenCage */]
};
/**
 * @class GeocoderController
 */

var GeocoderController = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {String} providerName name of Provider.
   * @param {Object} options config options for Provider
   * @param {Object} parent callback parent
   */
  function GeocoderController(providerName, options, parent) {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_classCallCheck___default()(this, GeocoderController);

    this.options = options; // Must have Provider class defined for name

    if (!PROVIDERS.hasOwnProperty(providerName)) {
      console.warn("No class defined for Geocoder Provider: '".concat(providerName, "'"));
      return;
    } // Create Provider from name via Factory Method


    this.provider = new PROVIDERS[providerName]();
    this.parent = parent;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_helpers_createClass___default()(GeocoderController, [{
    key: "query",
    value: function () {
      var _query = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_regenerator___default.a.mark(function _callee(q) {
        var parameters, ajax, response;
        return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                parameters = this.provider.getParameters({
                  query: q,
                  key: this.options.key,
                  lang: this.options.lang,
                  countrycodes: this.options.countrycodes,
                  limit: this.options.limit
                });
                ajax = {
                  url: parameters.url,
                  data: parameters.params
                }; // Optional XHR with JSONP (Provider-specific)

                if (parameters.callbackName) {
                  ajax.jsonp = true;
                  ajax.callbackName = parameters.callbackName;
                }

                _context.prev = 3;
                _context.next = 6;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_ajax__["a" /* json */])(ajax);

              case 6:
                response = _context.sent;
                return _context.abrupt("return", this.provider.handleResponse(response));

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
                return _context.abrupt("return", _context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 10]]);
      }));

      function query(_x) {
        return _query.apply(this, arguments);
      }

      return query;
    }()
  }]);

  return GeocoderController;
}();

/***/ }),

/***/ "qq5n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLogo_vue__ = __webpack_require__("P5f+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_119d8dba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLogo_vue__ = __webpack_require__("4uSC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("zrrf")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_119d8dba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLogo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_119d8dba_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLogo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qqRY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZoomToMaxExtentButton_vue__ = __webpack_require__("ypcs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d825a2c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoomToMaxExtentButton_vue__ = __webpack_require__("Ijfx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("imGD")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZoomToMaxExtentButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d825a2c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoomToMaxExtentButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d825a2c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoomToMaxExtentButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "reSj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar-items',[_c('v-combobox',{staticClass:"wgu-geocoder-combo",style:({ display: (_vm.hideSearch ? "none" : "block" ) }),attrs:{"return-object":"","no-filter":_vm.noFilter,"autofocus":_vm.autofocus,"items":_vm.resultItems,"label":_vm.$t('wgu-geocoder.placeHolder'),"clearable":_vm.clearable,"dark":_vm.dark,"color":_vm.dark ? 'white': '',"persistent-hint":_vm.persistentHint,"hidden":_vm.hideSearch,"rounded":_vm.rounded,"search-input":_vm.search},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"icon":"","dark":_vm.dark,"title":_vm.$t('wgu-geocoder.title')},on:{"click":function($event){return _vm.toggle()}}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "tdkq":
/***/ (function(module, exports) {

module.exports = {"app":{"title":"Vue.js / OpenLayers WebGIS","browserTitle":"Wegue Demo Anwendung","footerTextLeft":"Powered by <a href='https://meggsimum.de/wegue/' target='_blank'>Wegue WebGIS</a>","footerTextRight":"meggsimum","logo":"App Logo"},"mapLayers":{"wgu-geolocator-layer":{"name":"Ihr Standort"},"wgu-measure-layer":{"name":"Messergebnisse"},"wgu-drag-drop-layer":{"name":"Drag/Drop Daten"}},"wgu-toolbar-menu":{"title":"Menüleiste ausklappen"},"wgu-attributetable":{"title":"Attribut Tabelle","selectorLabel":"Layer auswählen","loadingText":"Lade... Bitte ein Gebiet auswählen, so dass der Layer sichtbar ist"},"wgu-bglayerswitcher":{"title":"Hintergrundkarte auswählen","emptyText":"Keine Hintergrund-Layer verfügbar."},"wgu-geocoder":{"title":"Adress-Suche","placeHolder":"Adresse suchen"},"wgu-geolocator":{"title":"Mein Standort"},"wgu-helpwin":{"title":"Hilfe","textTitle":"Über Wegue","htmlContent":"<b>WebGIS basierend auf OpenLayers und Vue.js</b></br>Vorlagen und wiederverwertbare Komponenten für Web-Kartenanwendungen mit OpenLayers und Vue.js","infoLinkUrl":"http://wegue.org/","infoLinkText":"Mehr Informationen"},"wgu-infoclick":{"title":"Standortinformation","mapClick":"Auf die Karte klicken, um Standortinformationen anzuzeigen.","mediaClick":"Ein Feature auf der Karte auswählen, um zugehörige Medieninformationen anzuzeigen.","mediaInfoLinkText":null},"wgu-layerlist":{"title":"Layer"},"wgu-maprecorder":{"title":"Videoaufnahme","options":"Optionen","videoFormat":"Videoformat","frameRate":"Bildrate (Bilder/s)","bitRate":"Bitrate (MBits/s)","fileName":"Dateiname","error":"Starten der Aufnahme fehlgeschlagen."},"wgu-zoomtomaxextent":{"title":"Kartenausschnitt zurücksetzen"},"wgu-measuretool":{"title":"Messen","distance":"Entfernung","length":"Länge","area":"Fläche","lengthKm":"{0} km","lengthMeter":"{0} m","areaSquareKm":"{0} km²","areaSquareMeter":"{0} m²"},"wgu-localeswitcher":{"title":"Spracheinstellungen"}}

/***/ }),

/***/ "u0sK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-module-card',_vm._b({staticClass:"wgu-attributetable-win",attrs:{"moduleName":_vm.moduleName,"icon":_vm.icon},on:{"visibility-change":_vm.show},scopedSlots:_vm._u([{key:"wgu-win-toolbar",fn:function(){return [_c('v-select',{staticClass:"wgu-vector-layer-select",attrs:{"items":_vm.displayedLayers,"item-text":function (item) { return item.get('name'); },"dense":"","return-object":"","hide-details":"","label":_vm.$t('wgu-attributetable.selectorLabel')},model:{value:(_vm.selLayer),callback:function ($$v) {_vm.selLayer=$$v},expression:"selLayer"}})]},proxy:true}])},'wgu-module-card',_vm.$attrs,false),[_vm._v(" "),(_vm.selLayer)?_c('wgu-attributetable',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],attrs:{"layerId":_vm.selLayer.get('lid'),"syncTableMapSelection":_vm.syncTableMapSelection}}):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "u4kD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-sidebar',
  data: function data() {
    return {
      sidebarOpen: true
    };
  }
});

/***/ }),

/***/ "v4OI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray__ = __webpack_require__("EmY/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_trim__ = __webpack_require__("9gOy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_trim___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_trim__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_string_split_js__ = __webpack_require__("388n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_string_split_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es_string_split_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_regexp_exec_js__ = __webpack_require__("XEfP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_regexp_exec_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es_regexp_exec_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_object_to_string_js__ = __webpack_require__("vw/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_object_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es_object_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_regexp_to_string_js__ = __webpack_require__("q4B+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_regexp_to_string_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es_regexp_to_string_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es_string_replace_js__ = __webpack_require__("ocEJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es_string_replace_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es_string_replace_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_util_colors__ = __webpack_require__("IHMs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_es5_util_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_Color__ = __webpack_require__("nF/d");








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-property-table',
  props: {
    color: {
      type: String,
      required: false,
      default: 'red darken-3'
    },
    properties: {
      type: Object
    }
  },
  computed: {
    tableStyles: function tableStyles() {
      // calculate border color of tables due to current color property
      var borderColor = this.color;

      if (!__WEBPACK_IMPORTED_MODULE_9__util_Color__["a" /* default */].isCssColor(this.color)) {
        var _context;

        var _this$color$toString$ = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_core_js_stable_instance_trim___default()(_context = this.color.toString()).call(_context).split(' ', 2),
            _this$color$toString$2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_slicedToArray___default()(_this$color$toString$, 2),
            colorName = _this$color$toString$2[0],
            colorModifier = _this$color$toString$2[1];

        borderColor = __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_util_colors___default.a[colorName];

        if (colorModifier) {
          colorModifier = colorModifier.replace('-', '');
          borderColor = __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_util_colors___default.a[colorName][colorModifier];
        }
      }

      return {
        'border': '2px solid ' + borderColor
      };
    },

    /**
     * Display the table control only, if there are properties to show.
     */
    show: function show() {
      return this.properties && __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_object_keys___default()(this.properties).length;
    }
  }
});

/***/ }),

/***/ "v9hS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof__ = __webpack_require__("xtLq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_slicedToArray__ = __webpack_require__("EmY/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_slice__ = __webpack_require__("J849");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_slice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_slice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_keys__ = __webpack_require__("23M+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_concat__ = __webpack_require__("Mnsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_concat__);






/**
 * URL related util methods
 */
var UrlUtil = {
  /**
   * Parses query string like a=b&c=d&e=f etc of the given search part (querySearch) of an URL
   * as JS object (key-value). Uses ES6 coding/parsing as in:
   * https://www.arungudelli.com/tutorial/javascript/get-query-string-parameter-values-from-url-using-javascript/
   *
   * @param  {String} query Search part (queryString) of an URL
   * @return {Object}             Key-value pairs of the URL parameters
   */
  parseQueryString: function parseQueryString(query) {
    return (/^[?#]/.test(query) ? __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs3_core_js_stable_instance_slice___default()(query).call(query, 1) : query).split('&').reduce(function (params, param) {
      var _param$split = param.split('='),
          _param$split2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs3_helpers_slicedToArray___default()(_param$split, 2),
          key = _param$split2[0],
          value = _param$split2[1];

      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
      return params;
    }, {});
  },

  /**
   * Returns the query params of the current 'location' from 'hash' or 'search'.
   *
   * @param  {String} locationType use query or hash part of URL
   * @return {Object}             Key-value pairs of the URL parameters
   */
  getParams: function getParams(locationType) {
    var querySearch = document.location[locationType].substring(1);

    if (!querySearch || querySearch === '') {
      return {};
    }

    return this.parseQueryString(querySearch);
  },

  /**
   * Returns all query params of the given search part (querySearch) of an URL
   * as JS object (key-value).
   * If querySearch is not provided it is derived from the current location.
   *
   * @param  {String} querySearch Search part (querySearch) of an URL
   * @return {Object} Key-value pairs of the URL parameters, may be empty {}.
   */
  getQueryParams: function getQueryParams(querySearch) {
    if (!querySearch) {
      querySearch = document.location.search.substring(1);
    }

    if (!querySearch || querySearch === '') {
      return {};
    }

    return this.parseQueryString(querySearch);
  },

  /**
   * Returns all query params of the given hash part (hash) of an URL
   * as JS object (key-value).
   * If hash is not provided it is derived from the current location.
   *
   * @param  {String} hash Search part (hash) of an URL
   * @return {Object} Key-value pairs of the URL parameters
   */
  getHashParams: function getHashParams(hash) {
    if (!hash) {
      hash = document.location.hash.substring(1);
    }

    return this.parseQueryString(hash);
  },

  /**
   * Returns a dedicated URL parameter if existing.
   * If querySearch is not provided it is derived from the current location.
   *
   * @param  {String} param       The URL param name
   * @param  {String} querySearch Search part (querySearch) of an URL
   * @return {String}             Value of the given URL param
   */
  getQueryParam: function getQueryParam(param, querySearch) {
    var params = this.getQueryParams(querySearch);
    var value;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_keys___default()(params).forEach(function (key) {
      if (key === param) {
        value = params[key];
      }
    });

    return value;
  },

  /**
   * Returns a query string from an object of key/value pairs.
   *
   * @param  {String} obj object with key/values to encode.
   * @return {String} the encoded query string
   */
  toQueryString: function toQueryString(obj) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs3_core_js_stable_object_keys___default()(obj).reduce(function (a, k) {
      var _context;

      a.push(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_helpers_typeof___default()(obj[k]) === 'object' ? _this.toQueryString(obj[k]) : __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs3_core_js_stable_instance_concat___default()(_context = "".concat(encodeURIComponent(k), "=")).call(_context, encodeURIComponent(obj[k])));
      return a;
    }, []).join('&');
  }
};
/* harmony default export */ __webpack_exports__["a"] = (UrlUtil);

/***/ }),

/***/ "vUNz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-module-card',_vm._b({staticClass:"wgu-maprecorder-win",attrs:{"moduleName":_vm.moduleName,"icon":_vm.icon,"width":"350"}},'wgu-module-card',_vm.$attrs,false),[_c('v-expansion-panels',{staticClass:"overflow-y-auto",attrs:{"multiple":true,"accordion":true}},[_c('v-expansion-panel',[_c('v-expansion-panel-header',[_c('v-layout',{attrs:{"align-center":""}},[_c('v-icon',{staticClass:"mr-4"},[_vm._v("settings")]),_vm._v("\n          "+_vm._s(_vm.$t('wgu-maprecorder.options'))+"\n        ")],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-card',{attrs:{"flat":"","color":"transparent"}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t('wgu-maprecorder.videoFormat')))]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0"},[_c('v-select',{attrs:{"items":_vm.mimeTypes,"prepend-icon":"mdi-video-image","menu-props":"auto","dense":"","hide-details":""},model:{value:(_vm.mimeType),callback:function ($$v) {_vm.mimeType=$$v},expression:"mimeType"}})],1),_vm._v(" "),_c('v-subheader',[_vm._v(_vm._s(_vm.$t('wgu-maprecorder.frameRate')))]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0"},[_c('v-slider',{attrs:{"prepend-icon":"mdi-iframe-variable-outline","min":"20","max":"50","step":"1","thumb-label":"","hide-details":""},model:{value:(_vm.frameRate),callback:function ($$v) {_vm.frameRate=_vm._n($$v)},expression:"frameRate"}})],1),_vm._v(" "),_c('v-subheader',[_vm._v(_vm._s(_vm.$t('wgu-maprecorder.bitRate')))]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0"},[_c('v-slider',{attrs:{"prepend-icon":"mdi-quality-high","min":"1.0","max":"10.0","step":"0.1","thumb-label":"","hide-details":""},model:{value:(_vm.videoMBitsPerSecond),callback:function ($$v) {_vm.videoMBitsPerSecond=_vm._n($$v)},expression:"videoMBitsPerSecond"}})],1),_vm._v(" "),_c('v-subheader',[_vm._v(_vm._s(_vm.$t('wgu-maprecorder.fileName')))]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0"},[_c('v-text-field',{attrs:{"prepend-icon":"mdi-rename-box","label":"YYYY-MM-DD at HH.MM.SS","dense":"","single-line":"","hide-details":""},model:{value:(_vm.filename),callback:function ($$v) {_vm.filename=$$v},expression:"filename"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-layout',{attrs:{"align-center":""}},[_c('v-btn',{staticClass:"mr-3",attrs:{"icon":"","fab":"","outlined":""},on:{"click":_vm.toggleRecord}},[(_vm.recording)?_c('v-icon',[_vm._v("stop")]):_c('v-icon',{attrs:{"color":"red darken-4"}},[_vm._v("fiber_manual_record")])],1),_vm._v(" "),_c('v-flex',{attrs:{"fill-height":"","grow":""}},[_c('v-progress-linear',{attrs:{"active":_vm.recording,"buffer-value":"0","stream":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"fill-height":"","shrink":""}},[_c('v-alert',{attrs:{"type":"error","dismissible":""},model:{value:(_vm.error),callback:function ($$v) {_vm.error=$$v},expression:"error"}},[_vm._v("\n          "+_vm._s(_vm.$t('wgu-maprecorder.error'))+"\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "w/12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureTypeChooser_vue__ = __webpack_require__("TooU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89dd710e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureTypeChooser_vue__ = __webpack_require__("a3aq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("8SDf")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureTypeChooser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89dd710e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureTypeChooser_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89dd710e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureTypeChooser_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wClq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var StyleUtil = {
  /**
   * Appends a style to another style.
   *
   * @param {ol.style.Style} originalStyle A style, an array of styles or a style function.
   * @param {ol.style.Style} additionalStyle A single style.
   *
   * @returns {ol.style.Style}
   */
  appendStyle: function appendStyle(originalStyle, additionalStyle) {
    return function (feature, resolution) {
      if (typeof originalStyle === 'function') {
        var layerStyleFunction = originalStyle; // check what kind of result we can expect

        var layerStyle = layerStyleFunction(feature, resolution);

        if (Array.isArray(layerStyle)) {
          // case result is an style array
          var resultArray = [additionalStyle]; // add the array elements to the result Array

          layerStyle.forEach(function (item) {
            return resultArray.push(item);
          });
          return resultArray;
        } else {
          // classic case that result is a simple style
          return [additionalStyle, layerStyleFunction(feature, resolution)];
        }
      } else {
        return [additionalStyle, originalStyle];
      }
    };
  }
};
/* harmony default export */ __webpack_exports__["a"] = (StyleUtil);

/***/ }),

/***/ "wHUX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":_vm.previewURL,"width":_vm.width,"height":_vm.height},on:{"load":function($event){_vm.imgLoaded=true},"error":function($event){_vm.imgLoaded=false}}},[(!_vm.previewURL || !_vm.imgLoaded)?_c('v-layout',{attrs:{"fill-height":"","align-center":"","justify-center":""}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v(_vm._s(_vm.previewIcon))])],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "wO5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_find__ = __webpack_require__("2x6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_interaction_Select__ = __webpack_require__("gsgi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WguEventBus_js__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__factory_OlStyle_js__ = __webpack_require__("fT5P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Style_js__ = __webpack_require__("wClq");





var MapInteractionUtil = {
  /**
   * Create a selectInteraction for a layer
   *
   * @param {ol.layer.Layer} layer The layer to create the interaction for
   * @param {Object} [selectStyleConf] The configuration for the selection style
   * @param {Boolean} [doAppendSelectStyle] If the selection style should be appended to the original style.
   *
   * @returns {ol.interaction.Select} The select interaction
   */
  createSelectInteraction: function createSelectInteraction(layer, selectStyleConf, doAppendSelectStyle) {
    var selectClick;
    var selectStyle;

    if (selectStyleConf) {
      // layer specific select style
      selectStyle = __WEBPACK_IMPORTED_MODULE_3__factory_OlStyle_js__["a" /* OlStyleFactory */].getInstance(selectStyleConf);

      if (doAppendSelectStyle) {
        // append selectStyle to original style of layer
        selectStyle = __WEBPACK_IMPORTED_MODULE_4__Style_js__["a" /* default */].appendStyle(layer.getStyle(), selectStyle);
      }

      selectClick = new __WEBPACK_IMPORTED_MODULE_1_ol_interaction_Select__["a" /* default */]({
        layers: [layer],
        style: selectStyle
      });
    } else {
      selectClick = new __WEBPACK_IMPORTED_MODULE_1_ol_interaction_Select__["a" /* default */]({
        layers: [layer]
      });
    } // necessary for identifying referenced layer


    selectClick.set('lid', layer.get('lid')); // forward an event if feature selection changes

    selectClick.on('select', function (evt) {
      __WEBPACK_IMPORTED_MODULE_2__WguEventBus_js__["a" /* WguEventBus */].$emit('map-selectionchange', layer.get('lid'), evt.selected, evt.deselected);
    });
    return selectClick;
  },

  /**
   * Find the selectIntercation of a layer
   *
   * @param {ol.Map} olMap The OL map to search in
   * @param {String} layerId The layer id, typically 'lid' the property
   * @returns {ol.interaction.Select} The respective selectInteraction
   */
  getSelectInteraction: function getSelectInteraction(olMap, layerId) {
    if (!olMap || !olMap.getInteractions()) {
      return;
    }

    var interactions = olMap.getInteractions().getArray();

    if (!interactions) {
      return;
    }

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_find___default()(interactions).call(interactions, function (interaction) {
      return interaction instanceof __WEBPACK_IMPORTED_MODULE_1_ol_interaction_Select__["a" /* default */] && interaction.get('lid') === layerId;
    });
  }
};
/* harmony default export */ __webpack_exports__["a"] = (MapInteractionUtil);

/***/ }),

/***/ "xdWY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y+0P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WguApp_vue__ = __webpack_require__("GgOu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c809b244_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguApp_vue__ = __webpack_require__("C22J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WguApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c809b244_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguApp_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c809b244_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguApp_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yekt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ol_source_Tile__ = __webpack_require__("Qa85");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_source_TileWMS__ = __webpack_require__("DwLH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_extent__ = __webpack_require__("/LWt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_proj__ = __webpack_require__("yGLh");
/**
 * Create preview images for layers with an underlying Tile or TileWMS source.
 *
 * This is a modified version of LayerPreview released by Jean-Marc VIGLINO
 * under the CeCILL-B license (French BSD license).
 * For the original source of ol-ext see https://github.com/Viglino/ol-ext.
 */




var TileSourcePreview = {
  /**
   * Return the tile image URL of the source.
   * @param {ol.TileSource} source The source to produce the preview for.
   * @param {ol.Coordinate} coords The center of the preview.
   * @param {number} resolution Resolution of the preview.
   * @param {ol.Projection} projection Projection of the coordinates.
   * @returns {String} The preview url.
   */
  getUrl: function getUrl(source, coords, resolution, projection) {
    var coord = source.getTileGrid().getTileCoordForCoordAndResolution(coords, resolution);
    var fn = source.getTileUrlFunction();
    return fn.call(source, coord, projection);
  }
};
var TileWMSSourcePreview = {
  /**
   * Return the tile image URL of the source.
   * @param {ol.TileWMSSource} source The source to produce the preview for.
   * @param {ol.Coordinate} coords The center of the preview.
   * @param {number} resolution Resolution of the preview.
   * @param {ol.Projection} projection Projection of the coordinates.
   * @returns {String} The preview url.
   */
  getUrl: function getUrl(source, coords, resolution, projection) {
    var fn = source.getTileUrlFunction();

    if (fn) {
      var tileGrid = source.getTileGrid() || source.getTileGridForProjection(projection);
      var coord = tileGrid.getTileCoordForCoordAndResolution(coords, resolution);
      return fn.call(source, coord, 1, projection);
    } // Use getfeature info instead


    var url = source.getGetFeatureInfoUrl ? source.getGetFeatureInfoUrl(coords, resolution, projection, {}) : source.getFeatureInfoUrl(coords, resolution, projection, {});
    url = url.replace(/getfeatureinfo/i, 'GetMap');
    return url;
  }
};
var LayerPreview = {
  /**
   * Return a preview URL for the layer.
   * @param {ol.Layer} layer The layer to produce the preview for.
   * @param {ol.Coordinate} coords The center of the preview in view projection.
   * @param {number} resolution Resolution of the preview.
   * @param {ol.Projection} projection The view projection.
   * @returns {String} Preview url or undefined if no preview can be produced.
   */
  getUrl: function getUrl(layer, coords, resolution, projection) {
    var source = layer.getSource(); // If we cannot obtain a source, no preview can be produced.

    if (!source) {
      return undefined;
    }

    try {
      // Clamp the resolution within the resolution supported by the layer.
      resolution = Math.max(Math.min(resolution, layer.getMaxResolution()), layer.getMinResolution()); // Make sure to request an extent within the layers extent.

      var e = layer.getExtent();

      if (e && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_ol_extent__["B" /* containsCoordinate */])(e, coords)) {
        coords = [(e[0] + e[2]) / 2, (e[1] + e[3]) / 2];
      } // Transform the projection of the coords if necessary.


      var sourceProj = source.getProjection();

      if (sourceProj && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ol_proj__["h" /* equivalent */])(projection, sourceProj)) {
        coords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ol_proj__["j" /* transform */])(coords, projection, sourceProj);
        projection = sourceProj;
      } // Obtain the image URL from the source.


      if (source instanceof __WEBPACK_IMPORTED_MODULE_1_ol_source_TileWMS__["a" /* default */]) {
        return TileWMSSourcePreview.getUrl(source, coords, resolution, projection);
      } else if (source instanceof __WEBPACK_IMPORTED_MODULE_0_ol_source_Tile__["b" /* default */]) {
        return TileSourcePreview.getUrl(source, coords, resolution, projection);
      }
    } catch (e) {
      console.error('failed to create preview: ' + e);
    }

    return undefined;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (LayerPreview);

/***/ }),

/***/ "ygOZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__ = __webpack_require__("ZKpu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_number_constructor_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BgLayerList__ = __webpack_require__("YPa9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-bglayerswitcher',
  components: {
    'wgu-bglayerlist': __WEBPACK_IMPORTED_MODULE_1__BgLayerList__["a" /* default */]
  },
  props: {
    color: {
      type: String,
      required: false,
      default: 'red darken-3'
    },
    icon: {
      type: String,
      required: false,
      default: 'map'
    },
    dark: {
      type: Boolean,
      required: false,
      default: true
    },
    imageWidth: {
      type: Number,
      required: false,
      default: 152
    },
    imageHeight: {
      type: Number,
      required: false,
      default: 114
    }
  },
  data: function data() {
    return {
      show: false
    };
  }
});

/***/ }),

/***/ "ypcs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__ = __webpack_require__("YO+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Mapable__ = __webpack_require__("WFjz");

//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-zoomtomaxextent-btn',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Mapable__["a" /* Mapable */]],
  props: {
    icon: {
      type: String,
      required: false,
      default: 'zoom_out_map'
    },
    dark: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    onClick: function onClick() {
      // derive correct initial zoom and center
      var initialCenter = this.$appConfig.mapCenter;
      var initalZoom = this.$appConfig.mapZoom;

      __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView().setCenter(initialCenter);

      __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs3_core_js_stable_instance_map___default()(this).getView().setZoom(initalZoom);
    }
  }
});

/***/ }),

/***/ "zrrf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.aa4717ecb29524c960fd.js